// Composition palettes are separate from dictation and other melody inputs.
export function melodyPaletteDurations(params = {}, authoring = false) {
    const configured = Array.isArray(params.allowedDurations) && params.allowedDurations.length
        ? params.allowedDurations.map(String) : null;
    if (!configured && params.compositionInput === true && String(params.tsig).replace(/\s/g, "") === "6/8") {
        return [
            { id: "8", glyph: "1e", key: "2" },
            { id: "4", glyph: "1q", key: "3" },
            { id: "4.", glyph: "1dq", key: "7" },
            { id: "2.", glyph: "1dh", key: "5" }
        ];
    }
    return [
        ...(authoring || configured?.includes("16") ? [{ id: "16", glyph: "1s", key: "1" }] : []),
        { id: "8", glyph: "1e", key: "2" },
        ...(authoring || configured?.includes("8.") ? [{ id: "8.", glyph: "1de", key: "8" }] : []),
        { id: "4", glyph: "1q", key: "3" },
        { id: "4.", glyph: "1dq", key: "7" },
        { id: "2", glyph: "1h", key: "4" },
        { id: "2.", glyph: "1dh", key: "5" },
        { id: "1", glyph: "1w", key: "6" }
    ].filter(item => !configured || configured.includes(item.id));
}

export function melodyInput(id,container,params,reactParent) {
	this.setNotes = reactParent?.setNotes || null;
	this.params = params;
	// Authoring capability stays on the engine when load replaces params.
	this.authoring = params.authoring === true;

    this.fixedPitch = params.fixedPitch || null;

	this.type = 'melody';
    var width, nts;
    var DB;

	this.hideDurButton = function() {
		DB.whole.attr({display:"none"});
	}

	this.emitChange = function () {
		if (this.setNotes) {
			this.setNotes(this.save().melody);
		}
	};

    this.isMeasureLocked = function (measureIndex) {
        return (
            this.params.lockedMeasures &&
            this.params.lockedMeasures.includes(measureIndex)
        );
    };

	this.appendAll = function() {
		//append elements in the staff
		//eligible elements are
		//	barlines
		//	rests
		//	notes
		//	key signature
		//	time signature
		//	clef
		this.whole.append(this.staffClef);
		this.whole.append(this.timeSignature);
		for (var i=0; i<this.measures.length; i++) {
			for (var j=0; j<this.measures[i].obs.length; j++) {
				if (this.measures[i].obs[j].note) this.whole.append(this.measures[i].obs[j].note)
				if (this.measures[i].obs[j].rest) this.whole.append(this.measures[i].obs[j].rest)
			}
			if (i < (this.measures.length-1))
				this.whole.append(this.barlines[i].barline);
			else
				this.whole.append(this.endLineGroup);
		}

		//append cover
		this.whole.append(this.cr);
	}

	this.clefSpace = function() {
		if (this.staffClef) return this.staffClef.getBBox().width;
		else return 0;
	}
	this.clefRight = function() {
		if (!this.staffClef) return 0;
		var bb = this.staffClef.getBBox();
		return bb.x+bb.width;
	}

	//autosaver function, initializes with this.save(), then checks every 5 seconds if any changes have been made
	this.autosaver = function(parentComponent,teacher) { //pass callback in here
		var initial = this.save();
		var self = this;
		window.setInterval(
			function() {
				var current = self.save();
				if (!objCompare(initial,current)) {
					console.log('updated');
					if (teacher) {
						parentComponent.saveLocal();
					} else {
						parentComponent.save();
					}
					initial = current;
				}
			}, 1000
		)
	}

	//note highlighter
	this.highlightNotes = function(ary) {
		for (var i=0; i<ary.length; i++) {
			var mb = ary[i].split(',');
			var m = parseInt(mb[0]);
			var b = parseInt(mb[1]);
			var nt = this.measures[m].obs[b];
			nt.note.attr({fill:'#E60000'});
			if (nt.stem)
				nt.stem.attr({fill:'#E60000'});
			if (nt.flag)
				nt.flag.attr({fill:'#E60000'});
		}
	}

	this.unhighlightNotes = function(ary) {
		for (var i=0; i<ary.length; i++) {
			var mb = ary[i].split(',');
			var m = parseInt(mb[0]);
			var b = parseInt(mb[1]);
			var nt = this.measures[m].obs[b];
			nt.note.attr({fill:'black'});
			if (nt.stem)
				nt.stem.attr({fill:'black'});
			if (nt.flag)
				nt.flag.attr({fill:'black'});
		}
	}

	//measure highlighter
	this.highlightMeasure = function(mIndex) {
		var measure = this.measures[mIndex];
		var left = measure.left-26;
		var right = measure.right-1;
		this.currentHighlight = this.whole.rect(left,0,right-left,4*17.75).attr({opacity:0.4,fill:'#E60000'});
	}

	this.unhighlightMeasure = function() {
		if (this.currentHighlight) this.currentHighlight.remove();
		delete this.currentHighlight;
	}

	var ERRORS;
	this.createErrorLists = function(list,yOffset) {
		this.clearErrors(); //clears out error divs
		this.DB.whole.attr({display:'none'});
		this.disabled = true;

		list.sort(function(a,b) {return 1000*(a.measure - b.measure) + (a.iBeat - b.iBeat)})

		var prnt = this.container.parentElement;
		var rec = prnt.getElementsByClassName('recunit')[0];
		var inst = document.getElementById(id+'-instructions');
		var vid = prnt.getElementsByClassName('vidunit')[0];

		var recHeight = rec ? rec.getBoundingClientRect().height : 0;
		var instHeight = inst ? inst.getBoundingClientRect().height : 0;
		var vidHeight = vid ? 300 : 0;
		var yOffset = recHeight + instHeight + vidHeight;
		
		ERRORS = [];

		this.elid = uniqueID();
		
		//put stuff in them
		var eList;
		var ndv;
		var index;
		var type;
		for (var i=0; i<list.length; i++) {
			var mb = list[i];
			var meas = mb.measure;
			var beat = mb.beat;
			var iBeat = mb.iBeat;
			var stf = '';
			if (!this.measures[meas].obs[iBeat]) continue; //isnt one
			//if (missingBeat(GS.MEASURES[meas][stf],mb.beat)) {
			//	continue;
			//}
			var x = this.measures[meas].obs[iBeat].x;
			var mbi = meas+'|'+beat;
			eList = document.getElementById('e'+this.elid+mbi);
			if (!eList) {
				var ediv = document.createElement('div');
				ediv.className = 'errorList';
				ediv.id = 'e'+this.elid+mbi;
				this.container.appendChild(ediv);
				eList = ediv;
				new this.makeErrorButton(x,eList,meas,beat);
			}
			
			var yAdjust = 45;
			var svgPoint = this.paper.node.createSVGPoint();
			svgPoint.x = x;
			svgPoint.y = (8*17.75 + 15);
			var xey = svgPoint.matrixTransform(this.whole.node.getCTM());
			eList.style.left = (20+xey.x)+'px'; //20 is from padding-left
			eList.keepLeft = (20+xey.x);
			eList.style.top = (xey.y+yAdjust+yOffset)+'px'; //y from matrix, yAdjust is custom, yOffset is height of instructions and recording

			if (ERRORS.indexOf(eList)==-1)
				ERRORS.push(eList);
			ndv = document.createElement('div');
			ndv.className = 'errorItem';
			eList.appendChild(ndv);
			ndv.innerHTML = list[i].text;
		}
	}

	var hideAllErrorButtons = function() {
		var ary = dis.errorButtons;
		for (var i=0; i<ary.length; i++)
			ary[i].hide();
	}
	this.hideAllErrorButtons = hideAllErrorButtons;

	this.clearErrors = function() {
		this.made = [];
		var errorList = this.container.getElementsByClassName('errorList');
		while(errorList.length>0) {
			this.container.removeChild(errorList[0]);
		}
		//remove buttons
		for (var i=0; i<this.errorButtons.length; i++)
			this.errorButtons[i].remove();
		this.errorButtons = [];
	}

	this.made = [];
	this.errorButtons = [];
	this.makeErrorButton = function(x,ele,meas,beat) {
		if (dis.made.indexOf(x)!=-1) return;
		dis.made.push(x);
		
		var y = 8*17.75;
		var bg = dis.whole.circle(x,y,15).attr({fill:rnGrad2,strokeWidth:1});
		var bgt = dis.whole.text(x,y+8,'!').attr({fontSize:'26px',fontWeight:'bold',fill:'#E60000'});
		bgt.transform('t'+(-bgt.getBBox().width/2)+' 0');
		var bgc = dis.whole.circle(x,y,15).attr({opacity:0});
		bgc.node.id="errorBtn";
		var eg = dis.whole.group(bg,bgt,bgc);
		bg.tog = false;
		eg.click(
			function() {
				bg.tog=!bg.tog;
				switch(bg.tog) {
					case true:
						dis.hideAllErrorButtons();
						//GS.BS.closePrompts();
						ele.style.display='';
						bg.attr({stroke:'black'});
						bg.tog = true;
						break;
					case false:
						ele.style.display='none';
						bg.attr({stroke:'none'});
						break;
				}
			}
		)
		eg.transform('t16 0');

		//accessibility
		eg.node.tabIndex = "0";
		eg.node.ariaLabel = "Error button, measure "+(meas+1)+", beat "+beat+", press e to hear the errors";
		eg.node.onkeyup = function(m) {
			if (m.key=='e') {
				bg.tog=!bg.tog;
				switch(bg.tog) {
					case true:						
						//announce errors to screenreader
						var elefart = document.getElementById(dis.container.id+'-notechange');	
						var eText = 'Error list';
						for (var z=0; z<ele.children.length; z++) {
							eText+=(', error '+(z+1)+', ');
							eText+=ele.children[z].innerHTML;
						}
						elefart.innerHTML = eText;

						dis.hideAllErrorButtons();
						//GS.BS.closePrompts();
						ele.style.display='';
						bg.attr({stroke:'black'});
						bg.tog = true;
						break;
					case false:
						ele.style.display='none';
						bg.attr({stroke:'none'});
						break;
				}
			}
		}
		
		this.remove = function() {
			eg.remove();
		}
		
		this.hide = function() {
			ele.style.display = 'none';
			bg.attr({stroke:'none'});
			bg.tog = false;
		}
		
		this.tog = function() {
			return bg.tog;
		}
		
		dis.errorButtons.push(this);
	}

	/*this.displayErrors = function(errors) {
		this.disabled = true;
		this.DB.whole.attr({display:'none'});
		this.errorRects = [];
		var ems = [];
		var xs = [this.measures[0].left-5];
		for (var i=0; i<this.barlines.length; i++) {
			xs.push(this.barlines[i].x);
		}
		xs.push(this.lines[5].getBBox().x);
		for (var i=0; i<errors.length; i++) {
			if (errors[i].meas==undefined) continue;
			if (ems.indexOf(errors[i].meas)==-1) {
				this.errorRects.push(this.whole.rect(xs[errors[i].meas],0,xs[errors[i].meas+1]-xs[errors[i].meas],17.75*4).attr({fill:'red',opacity:0.1}));
				ems.push(errors[i].meas);
			}
		}
	}

	this.clearErrors = function() {
		this.disabled = false;
		this.DB.whole.attr({display:''});
		for (var i=0; i<this.errorRects.length; i++)
			this.errorRects[i].remove();
		this.errorRects = [];
	}*/
	
	//notes
	var hnotes1 = ['F6','E6','D6','C6','B5','A5','G5','F5','E5','D5','C5','B4','A4','G4','F4','E4','D4','C4','B3','A3','G3','F3'];
	var hnotes2 = ['A4','G4','F4','E4','D4','C4','B3','A3','G3','F3','E3','D3','C3','B2','A2','G2','F2','E2','D2','C2','B1','A1'];
	var hnotes3 = ['G5','F5','E5','D5','C5','B4','A4','G4','F4','E4','D4','C4','B3','A3','G3','F3','E3','D3','C3','B2','A2','G2'];
	
	//id
	this.id = id;
	
	//object with answers in it?
	this.answers = {};
	
	//save container div
	this.container = container;
	
	//dis variable for use inside functions
	var dis = this;
	
	this.timeSpace = function() { //width of tsig
		return this.timeSignature.getBBox().width;
	}
	this.timeRight = function() { //right of tsig, where the notes start
		var bb = this.timeSignature.getBBox();
		return bb.x+bb.width;
	}
	this.timeLeft = function() { //right of tsig, where the notes start
		var bb = this.timeSignature.getBBox();
		return bb.x;
	}
	//move to right of key signature
	this.moveTSIG = function() {
		var sigRight;
		if (this.keyAx.length==0) {
			sigRight = this.clefRight();
		} else {
			var lx = this.keyAx[this.keyAx.length-1];
			var bb = lx.getBBox();
			sigRight = bb.x + bb.width;
		}
		
		var dx = this.timeLeft() - sigRight - 10;
		moveEle(this.timeSignature,-dx,0);
	}
	
	//BARLINES==========================================================
	this.drawBarline = function(x) { //after last chord
		var bl = new barline(x);
		this.barlines.push(bl);
		return bl;
	}
	
	var barlineMARGIN = 25;
	var barline = function(x,w) {
		var sw = w ? w : 1;
		this.x = x;
		this.barline = dis.whole.line(x,0,x,17.75*4).attr({stroke:'black',strokeWidth:sw});
		this.remove = function() {
			this.barline.remove();
		}
	}
	
	//MEASURES ROUTINES=================================================
	var insertMeasureBeat = function(ary,index,type,staff) {
		var eMB = ary[index];
		var ex = eMB.x;
		//new beat
		var nb = eMB.beat + rBeat(dis,eMB.dur);
		if (Math.abs( nb - (Math.floor(nb)+0.5) ) < 0.05)
			nb = Math.floor(nb) + 0.5;
		if (Math.abs( nb - (Math.floor(nb)+0.333) ) < 0.05)
			nb = Math.floor(nb) + 0.333;
		//new x
		var nx = ex + noteW(eMB.dur) + newX(eMB.dur);
		
		var mb = new measureBeat(type,nx,nb,eMB.measure);
		
		ary.splice(index+1,0,mb);
	}
	this.insertMeasureBeat = insertMeasureBeat;
	
	var removeMeasureBeat = function(ary,index,type) {
		//remove next beat(s) depending on rhythm of existing one
		//for now try removing one quarter note
		ary.splice(index+1,1);
	}
	this.removeMeasureBeat = removeMeasureBeat;
	
	var measureBeat = function(dur,x,beat,meas,iBeat) {
		this.dur = dur;
		this.beat = beat;
		this.measure = meas;
		this.iBeat = iBeat;
		this.x = x;
		this.voice = 1;
	}

	var getDuration = function(ary) {
		var dur = 0;
		for (var i=0; i<ary.length; i++) {
			dur+=rBeat(dis,ary[i].dur);
		}
		return dur;
	}
	
	var measureObj = function(ary,x,meas,bstart) {
		//ary is array of durations
		this.obs = [];
		
		this.left = x;

		if (dis.params.pickup) {
			this.duration = getDuration(ary);
		} else {
			this.duration = parseInt(dis.params.tsig.split('/')[0]);
		}
		
		//track x values
		var beat = bstart;
		var nobj;
		for (var i=0; i<ary.length; i++) {
			nobj = ary[i];
			this.obs.push(new measureBeat(nobj.dur,x,beat,meas,i));
			
			beat+=rBeat(dis,nobj.dur);
			beat = quantBeat(beat);
			
			//update x
			x += noteW(nobj.dur) + newX(nobj.dur);
		}
		
		//put cx on
		for (var i=1; i<this.obs.length; i++) {
			this.obs[i-1].cx = ( this.obs[i-1].x + this.obs[i].x ) / 2;
		}
		
		this.x = function() {
			return x;
		}
		
		this.right = x;
	}
	//==================================================================
	
	var wholeMeasure = function() {
		var tsig = dis.params.tsig;
		switch(tsig) {
			case '2/2':
				return [{dur:'2',name:'rest'},{dur:'2',name:'rest'}];
				break;
			case '3/2':
				return [{dur:'2',name:'rest'},{dur:'2',name:'rest'},{dur:'2',name:'rest'}];
				break;
			case '4/2':
				return [{dur:'1',name:'rest'},{dur:'1',name:'rest'}];
				break;
			case '2/4':
				return [{dur:'2',name:'rest'}];
				break;
			case '3/4':
				return [{dur:'2.',name:'rest'}];
				break;
			case '4/4':
				return [{dur:'1',name:'rest'}];
				break;
			case '5/4':
				return [{dur:'2',name:'rest'},{dur:'2',name:'rest'},{dur:'4',name:'rest'}];
				break;
			case '6/4':
				return [{dur:'1.',name:'rest'}];
				break;
			case '7/4':
				return [{dur:'2',name:'rest'},{dur:'2',name:'rest'},{dur:'2',name:'rest'},{dur:'4',name:'rest'}];
				break;
			case '3/8':
				return [{dur:'4.',name:'rest'}];
				break;
			case '6/8':
				return [{dur:'4.',name:'rest'},{dur:'4.',name:'rest'}];
				break;
			case '6/16':
				return [{dur:'8.',name:'rest'},{dur:'8.',name:'rest'}];
				break;
			case '9/8':
				return [{dur:'4.',name:'rest'},{dur:'4.',name:'rest'},{dur:'4.',name:'rest'}];
				break;
			case '12/8':
				return [{dur:'2.',name:'rest'},{dur:'2.',name:'rest'}];
				break;
		}
	}

	var findBeatStart = function() {
		var beats = 0;
		for (var i=0; i<dis.pickup.length; i++) {
			beats+=rBeat(dis,dis.pickup[i].dur);
		}
		beats = quantBeat(beats);
		var ts = parseInt(dis.params.tsig.split('/')[0]);

		return 1 + (ts - beats);
	}
	
	//INTERACTIVITY
	//var dcxs = [];
	this.findMB = function(cp) {
		//for (var i=0; i<dcxs.length; i++) {
		//	dcxs[i].remove();
		//}
		var x = cp.x;
		var ms = this.measures; //array of measures
		var lastMB = {}; //last measure-beat
		var meas;
		for (var i=0; i<ms.length; i++) {
			meas = ms[i]; //a measure
			//lastMB.meas = i; //keep measure
			for (var j=0; j<meas.obs.length; j++) { //going through the treble staff measure-beats
				//lastMB.beat = j; //save beat
				//lastMB.x = meas.obs[j].x; //save x
				//lastMB.dur = meas.obs[j].dur; //save duration
				//dcxs.push(dis.whole.rect(meas.obs[j].cx,0,1,5).attr({fill:'red'}))
				if (meas.obs[j].cx > x) return meas.obs[j]; //return measure-beat
			}
		}
		return meas.obs[meas.obs.length-1];
	}
	
	this.removeTester = function() {
		if (testNote) {
			if (testNote.stem)
				testNote.stem.remove();
			if (testNote.flag)
				testNote.flag.remove();
			if (testNote.dot)
				testNote.dot.remove();
			if (testNote.axe)
				testNote.axe.remove();
			if (testNote.t3)
				testNote.t3.remove();
			if (testNote.ledgers)
				for (var k=0; k<testNote.ledgers.length; k++)
					testNote.ledgers[k].remove();
			testNote.remove();
		}
	}
	
	var copyObject = function(obj) {
		var nbj = {};
		for (var prop in obj) {
			nbj[prop] = obj[prop];
		}
		return nbj;
	}

	var testNote;
	this.placeTester = function(obj,name) {
		var nt, dur;
		nt = name;
		dur = '4';
		
		//var axeIM = axeInMeas(obj);
		
		//remove existing
		this.removeTester();
		
		//name gives y
		nt = nt.replace('\u0231','');
		nt = nt.replace('♯','');
		nt = nt.replace('bb','');
		nt = nt.replace('x','');
		
		var x = obj.x;
		var lnsp = this.lnsp;
		var base = 14*lnsp/2;
		var ndx = nts.indexOf(nt);
		var lndx = ndx;
		var iSv = ndx;
		ndx *= lnsp/2;
		
		var sH = 40;
		var sW = 2;
		x-=4; //adjust x
		var vc = 4;
		switch(dur) {
			case '4':
				//x-=4;
				testNote = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				break;
		}
		
		if (lndx<5 || lndx>15) this.drawLedger(base,lndx,null,x-123,testNote); //depends on duration
		
		testNote.attr({opacity:0.5});
		this.whole.prepend(testNote);
	}

	this.placeNote = function(obj,keep,noStem) {
		if (!obj.name) return;
		var nt, dur;
		nt = obj.name;
		if (!keep)
			dur = '4'; //dummy note is quarter
		else
			dur = obj.dur;
		
		var axeIM = axeInMeas(obj);
		
		//remove existing
		this.removeTester();
		
		var ntSv = nt;
		if (axeIM) {
			if (axeIM!='n')
				ntSv = ntSv[0] + axeIM + ntSv[ntSv.length-1];
			else
				ntSv = ntSv[0] + ntSv[ntSv.length-1];
		}

		obj.name = ntSv;
		
		//name gives y
		nt = nt.replace('\u0231','');
		nt = nt.replace('♯','');
		nt = nt.replace('bb','');
		nt = nt.replace('x','');
		
		var x = obj.x;
		var lnsp = this.lnsp;
		var base = 14*lnsp/2;
		var ndx = nts.indexOf(nt);
		var midi = mids[ndx];
		var lndx = ndx;
		var iSv = ndx;
		ndx *= lnsp/2;
		
		var sH = 40;
		var sW = 2;
		var note;
		x-=4; //adjust x
		var vc = 4;
		switch(dur) {
			case '32':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = !(iSv>9) ? this.whole.path(thirtyTwoFlagPath).transform('t'+(x-65)+' '+(base-ndx-sH-318.75+782)+' s0.06 -0.06') : this.whole.path(thirtyTwoFlagPath).transform('t'+(x-86)+' '+(base-ndx-221+800)+' s0.06 0.06');
				obj.flag = flag;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				break;
			case '16':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = !(iSv>9) ? this.whole.path(sixFlagPath).transform('t'+(x-65)+' '+(base-ndx-sH-318.75+782)+' s0.06 -0.06') : this.whole.path(sixFlagPath).transform('t'+(x-86)+' '+(base-ndx-331+800)+' s0.06 0.06');
				obj.flag = flag;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				break;
			case '16.':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = !(iSv>9) ? this.whole.path(sixFlagPath).transform('t'+(x-65)+' '+(base-ndx-sH-318.75+782)+' s0.06 -0.06') : this.whole.path(sixFlagPath).transform('t'+(x-86)+' '+(base-ndx-331+800)+' s0.06 0.06');
				obj.flag = flag;
				var dot = this.whole.circle(x+34,base-ndx-9,3);
				if (iSv%2) dot.transform('t0 9');
				obj.dot = dot;
				this.whole.prepend(dot);
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				break;
			case 's16':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = !(iSv>9) ? this.whole.path(sixFlagPath).transform('t'+(x-65)+' '+(base-ndx-sH-318.75+782)+' s0.06 -0.06') : this.whole.path(sixFlagPath).transform('t'+(x-86)+' '+(base-ndx-331+800)+' s0.06 0.06');
				obj.flag = flag;
				var x3 = x+10;
				var y3 = base - ndx - 15;//(iSv>9) ? base-ndx-15 : base-ndx-sH;
				var t3 = this.whole.text(x3,y3,'6').attr({fontStyle:'italic'});
				this.whole.prepend(t3);
				obj.t3 = t3;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				break;
			case '8':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = (iSv>9) ? this.whole.path(eighthFlagPath).transform('t'+(x-114.9)+' '+(base-ndx-368.75+15+sH)+' s0.06 -0.06') : this.whole.path(eighthFlagPath).transform('t'+(x-94)+' '+(base-ndx-379-15)+' s0.06 0.06');
				obj.flag = flag;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				break;
			case '8.':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = (iSv>9) ? this.whole.path(eighthFlagPath).transform('t'+(x-114.9)+' '+(base-ndx-368.75+sH)+' s0.06 -0.06') : this.whole.path(eighthFlagPath).transform('t'+(x-94)+' '+(base-ndx-379)+' s0.06 0.06');
				obj.flag = flag;
				var dot = this.whole.circle(x+34,base-ndx-9,3);
				if (iSv%2) dot.transform('t0 9');
				obj.dot = dot;
				this.whole.prepend(dot);
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				break;
			case 't8':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = !(vc%2) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = !(vc%2) ? this.whole.path(eighthFlagPath).transform('t'+(x-114.9)+' '+(base-ndx-368.75+sH)+' s0.06 -0.06') : this.whole.path(eighthFlagPath).transform('t'+(x-94)+' '+(base-ndx-379)+' s0.06 0.06');
				obj.flag = flag;
				var x3 = x+10;
				var y3 = base-ndx-15;
				var t3 = this.whole.text(x3,y3,'3').attr({fontStyle:'italic'});
				this.whole.prepend(t3);
				obj.t3 = t3;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				if (iSv%2) t3.transform('t0 -9');
				break;
			case 'd8':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = (iSv>9) ? this.whole.path(eighthFlagPath).transform('t'+(x-114.9)+' '+(base-ndx-368.75+sH)+' s0.06 -0.06') : this.whole.path(eighthFlagPath).transform('t'+(x-94)+' '+(base-ndx-379)+' s0.06 0.06');
				obj.flag = flag;
				var x3 = x+10;
				var y3 = base - ndx - 15;//(iSv>9) ? base-ndx-15 : base-ndx-sH;
				var t3 = this.whole.text(x3,y3,'2').attr({fontStyle:'italic'});
				this.whole.prepend(t3);
				obj.t3 = t3;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				//if (iSv%2) t3.transform('t0 -9');
				break;
			case 'f8':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				var flag = (iSv>9) ? this.whole.path(eighthFlagPath).transform('t'+(x-114.9)+' '+(base-ndx-368.75+sH)+' s0.06 -0.06') : this.whole.path(eighthFlagPath).transform('t'+(x-94)+' '+(base-ndx-379)+' s0.06 0.06');
				obj.flag = flag;
				var x3 = x+10;
				var y3 = base - ndx - 15;//(iSv>9) ? base-ndx-15 : base-ndx-sH;
				var t3 = this.whole.text(x3,y3,'4').attr({fontStyle:'italic'});
				this.whole.prepend(t3);
				obj.t3 = t3;
				this.whole.prepend(obj.stem);
				this.whole.prepend(obj.flag);
				//if (iSv%2) t3.transform('t0 -9');
				break;
			case '4':
				//x-=4;
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				if (!noStem) obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				this.whole.prepend(obj.stem);
				break;
			case 't4':
				//x-=4;
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				if (!noStem) obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				this.whole.prepend(obj.stem);
				var x3 = x+10;
				var y3 = base - ndx - 15;//(iSv>9) ? base-ndx-15 : base-ndx-sH;
				var t3 = this.whole.text(x3,y3,'3').attr({fontStyle:'italic'});
				this.whole.prepend(t3);
				obj.t3 = t3;
				break;
			case 'd4':
				//x-=4;
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				if (!noStem) obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				this.whole.prepend(obj.stem);
				var x3 = x+10;
				var y3 = base - ndx - 15;//(iSv>9) ? base-ndx-15 : base-ndx-sH;
				var t3 = this.whole.text(x3,y3,'2').attr({fontStyle:'italic'});
				this.whole.prepend(t3);
				obj.t3 = t3;
				break;
			case '4.':
				sH = 55;
				note = this.whole.path(closedPath).transform('t'+(x-150)+' '+(base-ndx)+' s0.07 -0.07'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				//var bb = note.getBBox();
				var dot = this.whole.circle(x+34,base-ndx-9,3);
				if (iSv%2) dot.transform('t0 9');
				obj.dot = dot;
				this.whole.prepend(dot);
				this.whole.prepend(obj.stem);
				break;
			case '2':
				sH = 55;
				note = this.whole.path(openPath).transform('t'+(x-160+sW-0.5)+' '+(base-ndx)+' s0.067 -0.067'); //notehead
				if (!noStem) obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				this.whole.prepend(obj.stem);
				break;
			case '2.':
				sH = 55;
				note = this.whole.path(openPath).transform('t'+(x-160+sW-0.5)+' '+(base-ndx)+' s0.067 -0.067'); //notehead
				obj.stem = (iSv>9) ? this.whole.rect(x+3.05,base-ndx+1.75,sW,sH) : this.whole.rect(x+23.95,base-ndx-sH-1.95,sW,sH);
				//var bb = note.getBBox();
				var dot = this.whole.circle(x+34,base-ndx-9,3);
				if (iSv%2) dot.transform('t0 9');
				obj.dot = dot;
				this.whole.prepend(dot);
				this.whole.prepend(obj.stem);
				break;
			case '1':
				note = this.whole.path(wholePath).transform('t'+(x-233)+' '+(base-ndx)+' s0.0635 -0.0635');
				break;
			case '1.':
				note = this.whole.path(wholePath).transform('t'+(x-233)+' '+(base-ndx)+' s0.0635 -0.0635');
				var dot = this.whole.circle(x+37.5,base-ndx-9,3);
				if (iSv%2) dot.transform('t0 9');
				obj.dot = dot;
				this.whole.prepend(dot);
				break;
		}
		
		if (lndx<5 || lndx>15) this.drawLedger(base,lndx,null,x-123,obj); //depends on duration
		
		//note.midi = midi;
		//note.name = ntSv;
		note.x = obj.x;

		obj.y = base-ndx;
		obj.i = iSv;

		var bb = note.getBBox();
		obj.by = bb.y;
		obj.height = bb.height;
		obj.width = bb.width;
		
		obj.type = 'note';

		note.node.onfocus = function() {
			note.attr({fill:'rgb(99, 21, 255)'});
		}
		note.node.onblur = function() {
			note.attr({fill:'black'});
		}

		obj.staff = this.params.clef;
		
		//keep it
		note.keep = keep;
		
		if (!keep) {
			if (obj.stem)
				obj.stem.attr({opacity:0});
			if (obj.flag)
				obj.flag.attr({opacity:0});
			if (obj.t3)
				obj.t3.attr({opacity:0});
			note.attr({opacity:0.5});
			if (note.dot)
				note.dot.attr({opacity:0.5});
		}

		//put in tab order
		note.node.tabIndex = "0";
		//note.node.ariaLabel = nType(obj.dur)+" note, "+accessibleName(obj.name)+", measure "+(obj.measure+1)+", beat "+(obj.beat);
		
		this.whole.prepend(note);
		
		//make the axeMenu, keep the obj
		if (keep) {
			obj.axeMenu = new axeMenu(obj);
			//note.obj = {};
			//note.obj.dur = obj.dur;
			//note.obj.note = ntSv;
			//obj.note = ntSv;
			//note.obj.index = obj.index;
			//note.obj.MB = copyObject(MB);
			
			note.move = function(dx) {
				moveEle(note,dx,0);
				if (obj.stem)
					moveEle(obj.stem,dx,0);
			}
		}
		
		if (!keep) {
			testNote = note;
			testNote.obj = obj;
		} else {
			obj.note = note;
		}
	}
	
	this.axeOpen = function(mb) {
		//var note = this.measures[mb.measure].obs[mb.iBeat].note;
		mb.axeMenu.show();
	}
	
	var drawAccidental = function(mb,type) {
		if (mb.axe) mb.axe.remove();
		var axe;
		var adds=0;
		if (mb.ledgers)
			if (mb.ledgers.length!=0) adds-=3;
		var y = mb.y;
		var x = mb.x;
		x-=4;
		switch(type) {
			case '\u0231':
				axe = S.path(flatPath).transform('t'+(x+12-106)+' '+(y-160.5)+' s0.062 -0.062');
				//note.midi--;
				break;
			case '♯':
				axe = S.path(sharpPath).transform('t'+(x+adds-146)+' '+y+' s0.062 -0.062');
				//note.midi++;
				break;
			case 'n':
				axe = S.path(naturalPath).transform('t'+(x-90)+' '+y+' s0.062 -0.062');
				break;
			case 'bb':
				axe = S.path(doubleflatPath).transform('t'+(x+32-125)+' '+(y-260.5-17.75*4.5)+' s0.32 0.32');
				break;
			case 'x':
				axe = S.path(doublesharpPath).transform('t'+(adds+x+78-125)+' '+(y-306.875)+' s0.32 -0.32');
				break;
		}
		mb.axe = axe;
		axe.type = type;
		dis.whole.prepend(axe);
	}
	
	var axeHandle = function(mb,type) {
		var num = retNum(mb.name);
		var base = retBase(mb.name);
		if (type=='n') {
			mb.name = base+num;
		} else {
			mb.name = base+type+num;
		}
		if (mb.axe) {
			mb.axe.remove();
			delete mb.axe;
		}
		if (needDraw(mb,type))
			drawAccidental(mb,type);
	}
	
	var axeUpdate = function(mb) {
		if (mb.axe) {
			mb.axe.remove();
			delete mb.axe;
		}
		var num = retNum(mb.name);
		var base = retBase(mb.name);
		var nm = mb.name.replace(num,'').replace(base,'');
		var type = nm == '' ? 'n' : nm;
		if (needDraw(mb,type))
			drawAccidental(mb,type);
	}
	
	this.updateAxe = function(mb) {
		//go through the next notes til end of measure
		var ary = dis.measures[mb.measure].obs;
		for (var i=mb.iBeat+1; i<ary.length; i++) {
			if (ary[i].note) {
				axeUpdate(ary[i]);
			}
		}
	}
	
	var printNotes = function() {
		return;
		for (var i=0; i<dis.measures.length; i++) {
			var obs = dis.measures[i].obs;
			for (var j=0; j<obs.length; j++) {
				console.log(obs[j].snapNote?obs[j].snapNote.name:'');
			}
		}
	}
	
	var axeMenu = function(mb) {
		var xN = mb.x - 80;
		var yN = mb.y + 20;
		var vmrg = 5;
		var bw = 25;
		
		var num = retNum(mb.name);
		var base = retBase(mb.name);
		
		var rct = dis.whole.rect(mb.x+23,mb.y-60,24,155,5).attr({fill:'#E0E5E6',stroke:'black'});
		
		var axes = ['x','♯','n','\u0231','bb'];
		var axHov = function(rct,ax,i) {
			rct.node.id = 'pointer';
			var axr = dis.whole.group(ax);
			var axg = dis.whole.group(axr,rct);
			axg.hover(
				function() {axr.transform('s1.2');},
				function() {axr.transform('s1');}
			)
			
			axg.click(
				function() {
					if (mb.tieF||mb.tieB) return;
					if (mb.axe) {
						if (mb.axe.type==axes[i]) {hide(); return;}
					} else {
						if (mb.name.indexOf(axes[i])!=-1) {hide(); return;}
					}
					axeClick(axes[i]);
					printNotes();
				}
			)
			
			return axg;
		}
		
		var axeClick = function(type) {
            if (dis.disabled || dis.isMeasureLocked(mb.measure)) return;
			axeHandle(mb,type);
			hide();
			
			//update all following
			dis.updateAxe(mb);
			
			//remove rests
			dis.removeRests();
			
			//recalc display
			dis.recalculateDisplay();
            dis.emitChange();
		}
		
		var eles = [];
		
		//double sharp
		var yDraw;
		var doubleSharp = dis.whole.path(doublesharpPath).transform('t'+(xN+79)+' '+(yN-373)+' s0.2 -0.2');
		var bb1 = doubleSharp.getBBox();
		yDraw = bb1.y-vmrg;
		var dsr = dis.whole.rect(bb1.x+bb1.width/2-bw/2,yDraw,bw,bb1.height+2*vmrg).attr({opacity:0});//,stroke:'black',fill:'none'});
		eles.push(axHov(dsr,doubleSharp,0));
		
		yDraw+=(bb1.height+2*vmrg);
		
		var sharp = dis.whole.path(sharpPath).transform('t'+(xN-22)+' '+(yN-38)+' s0.032 -0.032');
		var bb2 = sharp.getBBox();
		var sr = dis.whole.rect(bb2.x+bb2.width/2-bw/2,yDraw,bw,bb2.height+2*vmrg).attr({opacity:0});//,stroke:'black',fill:'none'});
		eles.push(axHov(sr,sharp,1));
		
		yDraw+=(bb2.height+2*vmrg);
		
		var natural = dis.whole.path(naturalPath).transform('t'+(xN+32)+' '+(yN-4)+' s0.032 -0.032');
		var bb3 = natural.getBBox();
		var nr = dis.whole.rect(bb2.x+bb2.width/2-bw/2,yDraw,bw,bb3.height+2*vmrg).attr({opacity:0});//,stroke:'black',fill:'none'});
		eles.push(axHov(nr,natural,2));
		
		yDraw+=(bb3.height+2*vmrg);
		
		var flat = dis.whole.path(flatPath).transform('t'+(xN+29)+' '+(yN-122.5)+' s0.032 -0.032');
		var bb4 = flat.getBBox();
		var fr = dis.whole.rect(bb2.x+bb2.width/2-bw/2,yDraw,bw,bb4.height+2*vmrg).attr({opacity:0});//,stroke:'black',fill:'none'});
		eles.push(axHov(fr,flat,3));
		
		yDraw+=(bb4.height+2*vmrg);
		
		var doubleFlat = dis.whole.path(doubleflatPath).transform('t'+(xN+40)+' '+(yN-272)+' s0.15 0.15');
		var bb5 = doubleFlat.getBBox();
		var dfr = dis.whole.rect(bb2.x+bb2.width/2-bw/2,yDraw,bw,bb5.height+2*vmrg).attr({opacity:0});//,stroke:'black',fill:'none'});
		eles.push(axHov(dfr,doubleFlat,4));
		
		var menu = dis.whole.group(rct);
		for (var z=0; z<eles.length; z++)
			menu.append(eles[z]);
		dis.whole.append(menu);
		
		//transform to middle of note
		menu.transform('t12 '+((mb.y+mb.height/2)-(menu.getBBox().y+menu.getBBox().height/2)));
		
		if (mb.i<3) moveEle(menu,0,(3-mb.i)*dis.lnsp/2); //if too high
		
		this.remove = function() {
			menu.remove();
		}
		
		this.move = function(dx) {
			moveEle(menu,dx,0);
		}
		
		this.show = function() {
			if (dis.axeMenuIsOpen)
				dis.axeMenuIsOpen.hide();
            if (dis.isMeasureLocked(mb.measure)) return;
			menu.attr({display:''});
			dis.axeMenuIsOpen = this;
			dis.whole.append(menu);
			
			dis.removeTester();
		}
		this.hide = function() {
			menu.attr({display:'none'});
			dis.axeMenuIsOpen = null;
			if (dis.removeTupletIsOpen) {
				dis.removeTupletIsOpen.remove();
				dis.removeTupletIsOpen = null;
			}
		}
		var hide = this.hide;
		this.hide();
	}
	
	var axeInMeas = function(note) {
		var ary = dis.measures[note.measure].obs;
		var start = note.iBeat - 1;
		for (var i=start; i>-1; i--) {
			if (!ary[i]) continue;
			if (!ary[i].note) continue;
			if (ary[i].axe && ary[i].name[0]==note.name[0] && retNum(ary[i].name)==retNum(note.name))
				return ary[i].axe.type;
		}
		return false;
	}
	
	var needDraw = function(note,type) {
		//if (cI==0) return false;
		//need to draw the accidental?
		//draw it when:
		//	another accidental in measure, keysig
		var key = dis.params.key.replace('♭','\u0231');
		var mode = dis.params.mode;
		var ksig = keySig(key,mode)[0];
		var nt = note.name;
		var xim;
		switch(type) {
			case '\u0231': //flat
				//if note before it in measure with accidental
				xim = axeInMeas(note);
				if (xim) {
					switch(xim) {
						case '\u0231':
							//do nothing
							break;
						case '♯':
							return true;
							break;
						case 'n':
							return true;
							break;
						case 'bb':
							return true; //also need natural
							break;
						case 'x':
							return true; //not sure what else to do
							break;
					}
				} else {
					if (ksig.indexOf(noNum(nt))!=-1) return false;
					else return true;
				}
				break;
			case '♯':
				//if note before it in measure with accidental
				xim = axeInMeas(note);
				if (xim) {
					switch(xim) {
						case '\u0231':
							return true;
							break;
						case '♯':
							//do nothing
							break;
						case 'n':
							return true;
							break;
						case 'bb':
							return true; //not sure what else to do
							break;
						case 'x':
							return true; //also need natural
							break;
					}
				} else {
					if (ksig.indexOf(noNum(nt))!=-1) return false;
					else return true;
				}
				break;
			case 'bb':
				//if note before it in measure with accidental
				xim = axeInMeas(note);
				if (xim) {
					switch(xim) {
						case '\u0231':
							return true;
							break;
						case '♯':
							return true;
							break;
						case 'n':
							return true;
							break;
						case 'bb':
							//do nothing
							break;
						case 'x':
							return true;
							break;
					}
				} else {
					return true;
				}
				break;
			case 'x':
				//if note before it in measure with accidental
				xim = axeInMeas(note);
				if (xim) {
					switch(xim) {
						case '\u0231':
							return true;
							break;
						case '♯':
							return true;
							break;
						case 'n':
							return true;
							break;
						case 'bb':
							return true;
							break;
						case 'x':
							//do nothing
							break;
					}
				} else {
					return true;
				}
				break;
			case 'n':
				//if note before it in measure with accidental
				xim = axeInMeas(note);
				if (xim) {
					switch(xim) {
						case '\u0231':
							return true;
							break;
						case '♯':
							return true;
							break;
						case 'n':
							//do nothing
							break;
						case 'bb':
							return true; //not sure what else to do
							break;
						case 'x':
							return true; //not sure what else to do
							break;
					}
				} else {
					for (var z=0; z<ksig.length; z++) {
						if (ksig[z][0]==nt[0]) {
							return true;
						}
					}
					return false;
				}
				break;
		}
	}
	
	//this.ledgers = [];
	this.drawLedger = function(base,rand,dx,DX,mb) {
		var xsp = 50;
		var dx = dx ? xsp : 0;
		var delta = DX ? DX : 0;
		var lnsp = 17.75;
		var line = function(n,dir) {
			var yf = dir?(2-n):(8+n);
			var y = base-yf*lnsp;
			var lx = 120 + dx + delta;
			if (dx)
				var lw = 35;
			else
				var lw = 35;
			var lxr = lx + lw;
			if (mb.dur=='1') {
				lx-=3;
				lxr+=3;
			}
			var ll = S.line(lx,y,lxr,y).attr({stroke:'black'});
			if (!mb.ledgers) mb.ledgers = [];
			mb.ledgers.push(ll);
			//if (!dis.ledgers[cI])
			//	dis.ledgers[cI] = [];
			//dis.ledgers[cI].push(ll);
			dis.whole.prepend(ll);
		}
		
		if (rand<5) line(0,1);
		if (rand<3) line(1,1);
		if (rand<1) line(2,1);
		if (rand>15) line(0);
		if (rand>17) line(1);
		if (rand>19) line(2);
	}
	
	function tupMultiple(dur) {
		if (dur.indexOf('t')!=-1) return 3;
		if (dur.indexOf('d')!=-1) return 2;
		if (dur.indexOf('f')!=-1) return 4;
		if (dur.indexOf('s')!=-1) return 6;
	}
	
	function checkConversion(mb,cdur) {
		var dur = mb.dur;
		var meas = mb.meas;
		var tupM = tupMultiple(cdur);
		var mbDur = rBeat(dis,dur);
		var tpDur = tupM*rBeat(dis,cdur);
		var diff = Math.abs(mbDur-tpDur);
		if (diff<0.1) return true;
		return {error:'Cannot convert into tuplet.'}
	}
	
	function findRemainder(rem,meas) { //converting beats normally
		var durs = ['1','2','4','8','16'];
		var ts = dis.params.tsig;
		if (ts.indexOf('/8')!=-1) {
			durs = ['2.','4.','8','16'];
		}
		if (ts.indexOf('/16')!=-1) {
			durs = ['4.','8','16'];
		}
		var ary = [];
		var prop = 0;
		var pdur;
		var pbeat;
		while(rem!=0) {
			if (!durs[prop]) break;
			pdur = durs[prop]; //proposed dur to put in array
			pbeat = rBeat(dis,pdur);
			if (pbeat<=rem) {
				ary.push(pdur);
				rem-=pbeat;
			} else {
				prop++;
			}
		}
		ary=ary.sort(function(a,b){return parseInt(b)-parseInt(a);})
		return ary;
	}
	
	this.handleTupletChange = function(eis,nis,lastDur,newDur,ary,index) {
		var eDur = lastDur;
		var nDur = newDur;
		//var ary = this.measures[MB.meas].obs;
		//var index = MB.beat;
		var eMB = ary[index];
		var eNum = rBeat(this,eDur);
		var nNum = rBeat(this,nDur);
		
		var ts = this.params.tsig;
		
		if (eNum > nNum) { //existing is greater than new duration
			//if both tuplets, see if they play well together
			if (eis&&nis) {
				//pure tuplets only
			}
			
			//if existing is tuplet and new is not, no allow
			if (eis&&!nis) {
				//not allowed to do anything
			}
			
			//if existing is not tuplet and new is tuplet
			if (!eis&&nis) {
				var tN = tupMultiple(nDur);
				
				ary[index].dur = nDur;
				//convert one beat to tuplet
				var beatGroup = tN*rBeat(this,nDur);
				beatGroup = Math.round(10*beatGroup)/10;
				var numToAdd = Math.round(beatGroup / nNum) - 1;
				for (var i=0; i<numToAdd; i++) {
					this.insertMeasureBeat(ary,index+i,nDur);
				}
				var rem = findRemainder(eNum - beatGroup,eMB.measure);
				for (var i=0; i<rem.length; i++) {
					this.insertMeasureBeat(ary,index+i+numToAdd,rem[i]);
				}
			}
		} else {
			//if both tuplets, see if they play well together
			if (eis&&nis) {
				//pure tuplets only
			}
			
			//if existing is tuplet and new is not, no allow
			if (eis&&!nis) {
				//not allowed to do anything
			}
			
			//if existing is not tuplet and new is tuplet
			if (!eis&&nis) {
				var tN = tupMultiple(nDur);
				
				ary[index].dur = nDur;
				//convert one beat to tuplet
				var beatGroup = tN*rBeat(this,nDur);
				if (ts.indexOf('/8')!=-1) beatGroup = 3;
				var numToAdd = Math.round(beatGroup / nNum) - 1;
				for (var i=0; i<numToAdd; i++) {
					this.insertMeasureBeat(ary,index+i,nDur);
				}
				var rem = findRemainder(eNum - beatGroup,eMB.measure);
				for (var i=0; i<rem.length; i++) {
					this.insertMeasureBeat(ary,index+i+numToAdd,rem[i]);
				}
			}
		}

		for (var i=0; i<ary.length; i++)
			ary[i].iBeat = i;
	}
	
	this.handleChange = function(inputMB,lastDur) { //handles the changes in MB array
		var newDur = this.currentDUR;
		var ary = this.measures[inputMB.measure].obs;
		var index = inputMB.iBeat;
		var eMB = ary[index];

        if (this.isMeasureLocked(inputMB.measure)) return;
		
		//if a tuplet, use a different function
		var eis = isTuplet(lastDur);
		var nis = isTuplet(newDur);
		if (eis||nis) {
			this.handleTupletChange(eis,nis,lastDur,newDur,ary,index);
			return;
		}
		
		//else proceed
		var eNum = rBeat(this,lastDur);
		var nNum = rBeat(this,newDur);
		var meas = eMB.measure + 1;
		if (eNum > nNum) { //existing duration is greater than the new one
			//change existing dur to new one
			ary[index].dur = newDur;
			
			var rem = findRemainder(eNum-nNum,eMB.measure);
			for (var i=0; i<rem.length; i++) {
				this.insertMeasureBeat(ary,index+i,rem[i]);
			}

		} else { //existing duration is smaller than the new one
			//change quarter to dotted quarter
			ary[index].dur = newDur;
			
			//check for removes
			var rms = [];
			var cb = ary[index].beat + nNum; //calculate the changed beat's window
			var nb;
			for (var i=index+1; i<ary.length; i++) {
				nb = ary[i];
				if (( nb.beat + rBeat(this,nb.dur) ) <= cb)
					rms.push(i);
			}
			//remove the svgs
			for (var i=0; i<rms.length; i++) {
				if (ary[rms[i]].note)
					removeMBNote(ary[rms[i]]);
			}
			ary.splice(rms[0],rms.length); //get out of array
			
			//revert notes
			var noteAry = [];
			for (var i=0; i<ary.length; i++) {
				if (ary[i].note)
					noteAry.push(ary[i].note);
			}
			this.revertNotes(noteAry);
			
			//check for a convert
			var cv;
			for (var i=index+1; i<ary.length; i++) {
				nb = ary[i];
				if (( nb.beat < cb ) && ( nb.beat + rBeat(this,nb.dur) > cb ))
					cv = i;
			}
			if (cv!=undefined) {
				var meas = ary[cv].measure;
				ary[cv].dur = numToDur(this,ary[cv].beat + rBeat(this,ary[cv].dur) - cb,meas); //new duration minus the converted one gives the remainder
				
				for (var i=cv; i<ary.length; i++) {
					ary[i].beat = ary[i-1].beat + rBeat(this,ary[i-1].dur);
				}
				//if has note, remove it
				if (ary[cv].note) {
					removeMBNote(ary[cv]); //remove existing note		
				}
			}
		}

		for (var i=0; i<ary.length; i++)
			ary[i].iBeat = i;
	}
	
	this.getMelody = function() {
		var ary = [];
		var mAry;
		var nobj;
		for (var i=0; i<this.measures.length; i++) {
			mAry = [];
			for (var j=0; j<this.measures[i].obs.length; j++) {
				nobj = {};
				if (this.measures[i].obs[j].snapNote) { //has a note
					nobj.dur = this.measures[i].obs[j].dur;
					nobj.name = this.measures[i].obs[j].snapNote.name;
					nobj.meas = i;
					nobj.beat = this.measures[i].obs[j].beat;
					nobj.iBeat = j;
					nobj.type = 'note';
					if (this.measures[i].obs[j].snapNote.tieF)
						nobj.tie = {meas:i,beat:j};
				}
				if (this.measures[i].obs[j].rest) { //has a rest
					nobj.dur = this.measures[i].obs[j].dur+'r';
					nobj.name = 'rest';
				}
				mAry.push(nobj);
			}
			ary.push(mAry);
		}
		
		return ary;
	}
	
	this.keepNote = function(note,lastDur) {
		this.placeNote(note,true);
		//save note in measures
		//var nbj = {};
		//nbj.dur = note.dur;
		//nbj.note = note.note;
		//nbj.x = note.x;
		//if (note.type!='rest')
		//	this.measures[MB.meas].obs[MB.beat].note = nbj;
		
		//printNotes();
		
		//if the existing MB rhythm is different from GS.currentDUR, adjust the measure-beats array
		if (lastDur!=this.currentDUR && !this.params.lockRhythm) {
			this.removeRests(); //remove all rests before changing the MB arrays
			
			//HANDLE THE CHANGE TO MB ARRAYS
			this.handleChange(note,lastDur);
			
			//CALCULATE NEW Xs FOR EVERYBODY
			this.recalculateDisplay();

			this.emitChange();
			
			return;
		}
		
		this.removeRests();
		
		this.beamNotes();
		
		this.drawRests();

		this.appendAll();

		this.emitChange();
	}
	
	function scaleMod(nts) {
		var scale = scaleMaker(dis.params.key,dis.params.mode);
		for (var i=0; i<nts.length; i++) {
			for (var j=0; j<scale.length; j++) {
				if (nts[i][0]==scale[j][0])
					nts[i]=scale[j]+retNum(nts[i]);
			}
		}
		return nts;
	}
	
	/*function findNote(y,vc) {
		//vc is 1,2 => treble
		//vc is 3,4 => bass
		
		var nts;
		var strt;
		var sttp;
		if (vc<3) {
			nts = ['F6','E6','D6','C6','B5','A5','G5','F5','E5','D5','C5','B4','A4','G4','F4','E4','D4','C4','B3','A3','G3','F3','E3'];
			strt = -7;
			sttp = 0;
		} else {
			nts = ['A4','G4','F4','E4','D4','C4','B3','A3','G3','F3','E3','D3','C3','B2','A2','G2','F2','E2','D2','C2','B1','A1','G1'];
			strt = -7;
			sttp = 12*17.75;
			sttp = 0;
		}
		
		//edit notes based on scale
		nts = scaleMod(nts);
		
		//only returning bare notes, based on y-value
		var lnsp = 17.75/2;
		var ys = [];
		for (var i=strt; i<nts.length; i++) {
			if (sttp+lnsp*(i+0.5)+strt*lnsp > y) return nts[i];
		}
		return false;
	}*/
	
	var findNote = function(cp) {
		var y = cp.y;
		var nd = 0;
		for (var i=0; i<hnotes1.length; i++) {
			if (y>(i*dis.lnsp/2-29-2*dis.lnsp)) nd = i;
		}
		var nts = scaleMod(copyAry(hnotes));
		return nts[nd];
	}
	
	function noteExists(MB) {
		var nt = dis.measures[MB.measure].obs[MB.iBeat];
		
		if (nt.note) return true;
		return false;
	}
	
	var CANEDIT = true;
	var TIETIME = false;
	var inputNote;
	this.currentDUR = '4';
	function inputMove(m,r) {
		if (!CANEDIT) return;
		if (!inputNote) inputNote = {};
		if (dis.axeMenuIsOpen) return;
		//else removeInput();
		var cp = cursorPoint(m,S,r); //x,y of mouse
		var inputMB;
		inputMB = dis.findMB(cp); //index in measure, which beat or part of beat we're on
		//var newName = findNote(cp);// || testNote.name;
		//if (!newName) return;
        var newName;
        if (dis.fixedPitch) {
            newName = dis.fixedPitch;
        } else {
            newName = findNote(cp);
        }
        if (!newName) return;
        
        if (dis.isMeasureLocked(inputMB.measure)) return;
		
		if (noteExists(inputMB)) return;
		//inputMB.dur = retDur(dis.currentDUR);
		
		//if TIETIME don't draw
		if (TIETIME) {
			return;
		}
		
		dis.placeTester(inputMB,newName);
	}

	function inputD() {
		if (dis.disabled) return;
		var m = key_coord.m;
		var b = key_coord.b;
		var inputMB = dis.measures[m].obs[b];
		var tuplet = clickTuplet(inputMB);
		if (tuplet) {
			var checkFirst = onFirstBeat(inputMB);
			if (!checkFirst) return;
			removeTupletBeat(inputMB);
			dis.placeTester(inputMB,key_coord.n);
			refocus(inputMB);
		}
	}

	function inputAxe(type) {
		if (dis.disabled) return;
		var m = key_coord.m;
		var b = key_coord.b;
		var inputMB = dis.measures[m].obs[b];
		if (clickExisting(inputMB,inputNote.voice)) {
			if (dis.measures[inputMB.measure].obs[inputMB.iBeat].tieF || dis.measures[inputMB.measure].obs[inputMB.iBeat].tieB) {
				alert('Can\'t add accidental to a tied note!'); return;
			}
			axeHandle(inputMB,type);
			
			//update all following
			dis.updateAxe(inputMB);
			
			//remove rests
			dis.removeRests();
			
			//recalc display
			dis.recalculateDisplay();

			//update aria label
			//inputMB.note.node.ariaLabel = nType(inputMB.dur)+" note, "+accessibleName(inputMB.name)+", measure "+(inputMB.measure+1)+", beat "+(inputMB.beat);

			refocus(inputMB);
		} else {
			//alert, cant do it
		}
	}

	var key_coord = {m:0,b:-1,n:'B4'};
	function inputUp() {
		if (!CANEDIT) return;
		if (dis.disabled) return;
		if (!inputNote) inputNote = {};
		var m = key_coord.m;
		var b = key_coord.b;
		if (b<0) return;
		var inputMB = dis.measures[m].obs[b];
		if (noteExists(inputMB)) {
			dis.removeTester();
			return;
		}
		
		//if TIETIME don't draw
		if (TIETIME) {
			return;
		}

		var n = key_coord.n;
		var nDX = nts.indexOf(n);
		nDX++;
		n = nts[nDX];
		if (!n) n = nts[nDX-1];
		//increase by 1
		key_coord.n = n;
		
		dis.placeTester(inputMB,key_coord.n);

		return n;
	}

	function inputDown() {
		if (!CANEDIT) return;
		if (dis.disabled) return;
		if (!inputNote) inputNote = {};
		var m = key_coord.m;
		var b = key_coord.b;
		if (b<0) return;
		var inputMB = dis.measures[m].obs[b];
		if (noteExists(inputMB)) {
			dis.removeTester();
			return;
		}
		
		//if TIETIME don't draw
		if (TIETIME) {
			return;
		}

		var n = key_coord.n;
		var nDX = nts.indexOf(n);
		nDX--;
		n = nts[nDX];
		if (!n) n = nts[nDX+1];
		//increase by 1
		key_coord.n = n;
		
		dis.placeTester(inputMB,key_coord.n);

		return n;
	}

	function inputTab() {
		if (!CANEDIT) return;
		if (dis.disabled) return;
		if (!inputNote) inputNote = {};
		console.log('starting');
		console.log(key_coord);
		
		var m = key_coord.m;
		var b = key_coord.b;
		b++;
		if (b==dis.measures[m].obs.length) {
			m = m + 1;
			b = 0;
			console.log('next measure');
		}
		if (m==dis.measures.length) {
			m--;
			b = dis.measures[m].obs.length-1;
			dis.removeTester();
			console.log('end of score');
			return;
		}
		key_coord.m = m;
		key_coord.b = b;
		console.log('ending');
		console.log(key_coord);
		
		var inputMB = dis.measures[m].obs[b];
		if (noteExists(inputMB)) {
			key_coord.n = inputMB.name.replace('♯','').replace('\u0231','').replace('x','').replace('bb','');
			dis.removeTester();
			return;
		}
		
		//if TIETIME don't draw
		if (TIETIME) {
			return;
		}
		
		dis.placeTester(inputMB,key_coord.n);
	}

	function backTab() {
		if (!CANEDIT) return;
		if (dis.disabled) return;
		if (!inputNote) inputNote = {};
		
		var m = key_coord.m;
		var b = key_coord.b;
		b--;
		if (b==-2) return;
		if (b==-1) {
			m = m - 1;
			if (m==-1) {
				m = 0;
				b = 0;
				dis.removeTester();
				console.log('start of score');
				return;
			} else {
				b = dis.measures[m].obs.length-1;
			}
		}
		if (m==-1) {
			m++;
			b = 0;
			dis.removeTester();
			console.log('start of score');
			return;
		}
		key_coord.b = b;
		key_coord.m = m;
		console.log(key_coord);
		
		var inputMB = dis.measures[m].obs[b];
		if (noteExists(inputMB)) {
			key_coord.n = inputMB.name.replace('♯','').replace('\u0231','').replace('x','').replace('bb','');
			dis.removeTester();
			return;
		}
		
		//if TIETIME don't draw
		if (TIETIME) {
			return;
		}
		
		dis.placeTester(inputMB,key_coord.n);
	}

	function inputSpace() {
		var element = document.activeElement;
		if (element.className=="inputstaff") return;
		if (dis.disabled) return;
		if (dis.removeTupletIsOpen) {
			dis.removeTupletIsOpen.remove();
			dis.removeTupletIsOpen = null;
			return;
		}

		var m = key_coord.m;
		var b = key_coord.b;
		var inputMB = dis.measures[m].obs[b];
		
		if (TIETIME) { //handle drawing of ties
			handleTie(dis,inputMB);
			refocus(inputMB);
			return;
		}
		
		//remove
		if (clickExisting(inputMB)) {
			key_coord.n = inputMB.name.replace('♯','').replace('\u0231','').replace('x','').replace('bb','');
			removeMBNote(inputMB); //removes note and all its stuff
			
			dis.recalculateDisplay();
			
			dis.removeTester();

			refocus(inputMB);

			return;
		}
		
		//check if have enough beats left in measure
		if (!checkRoom(inputMB,dis.currentDUR)) {
			alert('Not enough room in measure.');
			refocus(inputMB);
			return;
		}
		
		//if tuplet, check to see if the conversion is correct
		if (isTuplet(dis.currentDUR)&&inputMB.dur!=dis.currentDUR) {
			var conversion = checkConversion(inputMB,dis.currentDUR);
			if (conversion.error) {
				alert(conversion.error);
				refocus(inputMB);
				return;
			}
		}
		
		//if tuplet there, check to see if can put GS.currentDUR
		if (isTuplet(inputMB.dur)&&dis.currentDUR!=inputMB.dur) {
			//check if ok to continue
			
			//for now, no
			alert('Cannot place this note type into tuplet.');
			refocus(inputMB);
			return;
		}

		//keep it
		var lastDur = inputMB.dur;
		inputMB.dur = dis.currentDUR;
		inputMB.name = key_coord.n;
		dis.keepNote(inputMB,lastDur);

		refocus(inputMB);
	}

	var refocus = function(inputMB) {
		if (inputMB.note) inputMB.note.node.focus();
		if (inputMB.rest) inputMB.rest.node.focus();
	}
	
	function clickExisting(mb) {
		var nt = dis.measures[mb.measure].obs[mb.iBeat].note;
		
		//not note there
		if (!nt) return false;
		else return true;
	}
	
	function removeMBNote(mb) {
		if (mb.flag) {
			mb.flag.remove();
			delete mb.flag;
		}
		if (mb.stem) {
			mb.stem.remove();
			delete mb.stem;
		}
		if (mb.dot) {
			mb.dot.remove();
			delete mb.dot;
		}
		if (mb.beam) {
			mb.beam.remove();
			delete mb.beam;
		}
		if (mb.beams) {
			for (var i=0; i<mb.beams.length; i++)
				mb.beams[i].remove();
			delete mb.beams;
		}
		if (mb.beam2) {
			mb.beam2.remove();
			delete mb.beam2;
		}
		if (mb.axe) {
			mb.axe.remove();
			delete mb.axe;
		}
		if (mb.axeMenu) {
			mb.axeMenu.remove();
			delete dis.axeMenuIsOpen;
		}
		if (mb.tieF) {
			var tie = mb.tieF;

			delete tie.n2.tieB;
			
			tie.remove();
			
			delete mb.tieF;
			delete mb.tied;
		}
		if (mb.tieB) {
			var tie = mb.tieB;

			delete tie.n1.tieF;
			delete tie.n1.tied;
			
			tie.remove();
			
			delete mb.tieB;
		}
		if (mb.t3) {
			mb.t3.remove();
			delete mb.t3;
		}
		if (mb.ledgers) {
			for (var i=0; i<mb.ledgers.length; i++) {
				mb.ledgers[i].remove();
			}
			delete mb.ledgers;
		}

		if (mb.stemBuddies) {
			revertNotes(mb.stemBuddies);
			for (var zz=0; zz<mb.stemBuddies.length; zz++)
				delete mb.stemBuddies[zz].stemBuddies;
			delete mb.stemBuddies;
		}
		
		mb.note.remove();

		//delete all other properties
		delete mb.note;
		delete mb.by;
		delete mb.height;
		delete mb.y;
		delete mb.name;
		delete mb.i;
		delete mb.diff;
		delete mb.width;
		delete mb.axeMenu;
	}
	
	function removeNote(note) {
		if (note.flag)
			note.flag.remove();
		if (note.stem)
			note.stem.remove();
		if (note.dot)
			note.dot.remove();
		if (note.beam)
			note.beam.remove();
		if (note.beams) {
			for (var i=0; i<note.beams.length; i++)
				note.beams[i].remove();
			note.beams = [];
		}
		if (note.beam2)
			note.beam2.remove();
		if (note.axe)
			note.axe.remove();
		if (note.axeMenu) {
			note.axeMenu.remove();
			dis.axeMenuIsOpen = null;
		}
		if (note.tieF) {
			var tie = note.tieF;
			tie.n1 = null;
			tie.n2.tieB = null;
			//update aria-label
			//note.node.ariaLabel = nType(note.dur)+" note, "+accessibleName(note.name)+", measure "+(note.measure+1)+", beat "+(note.beat);
			var secondNote = tie.n2;
			//secondNote.node.ariaLabel = nType(secondNote.dur)+" note, "+accessibleName(secondNote.name)+", measure "+(secondNote.measure+1)+", beat "+(secondNote.beat);
			
			tie.remove();
			
			note.tieF = null;
		}
		if (note.tieB) {
			var tie = note.tieB;
			tie.n2 = null;
			tie.n1.tieF = null;
			//update aria-label
			//note.node.ariaLabel = nType(note.dur)+" note, "+accessibleName(note.name)+", measure "+(note.measure+1)+", beat "+(note.beat);
			var secondNote = tie.n2;
			//secondNote.node.ariaLabel = nType(secondNote.dur)+" note, "+accessibleName(secondNote.name)+", measure "+(secondNote.measure+1)+", beat "+(secondNote.beat);
			
			tie.remove();
			
			note.tieB = null;
		}
		if (note.t3)
			note.t3.remove();
		if (note.ledgers) {
			for (var i=0; i<note.ledgers.length; i++)
				note.ledgers[i].remove();
		}
		note.ledgers = [];
		
		note.remove();
	}
	
	function revertNotes(ary) {
		for (var i=0; i<ary.length; i++) {
			if (ary[i].dur=='16') {
				var x = ary[i].x;			
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				var flag = !( ary[i].i>9 ) ? dis.whole.path(sixFlagPath).transform('t'+(x-68)+' '+(ary[i].y-55-318.75+782)+' s0.06 -0.06') : dis.whole.path(sixFlagPath).transform('t'+(x-89.5)+' '+(ary[i].y-331+800)+' s0.06 0.06');
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,55) : dis.whole.rect(x+20.95,ary[i].y-55-1.95,2,55);
				
				ary[i].flag = flag;
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
			if (ary[i].dur=='s16') {
				
				var x = ary[i].x;			
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				if (ary[i].t3) ary[i].t3.remove();
				var flag = !( ary[i].i>9 ) ? dis.whole.path(sixFlagPath).transform('t'+(x-68)+' '+(ary[i].y-55-318.75+782)+' s0.06 -0.06') : dis.whole.path(sixFlagPath).transform('t'+(x-89.5)+' '+(ary[i].y-331+800)+' s0.06 0.06');
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,55) : dis.whole.rect(x+20.95,ary[i].y-55-1.95,2,55);
				
				ary[i].flag = flag;
				
				var x3 = x+10;
				var y3 = ary[i].y-40;
				var t3 = dis.whole.text(x3,y3,'6').attr({fontStyle:'italic'});
				ary[i].t3 = t3;
				if (ary[i].i%2) t3.transform('t0 -9');
				
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
			if (ary[i].dur=='8') {
				
				var x = ary[i].x;
				var flag = ( ary[i].i>9 ) ? dis.whole.path(eighthFlagPath).transform('t'+(x-117.9)+' '+(ary[i].y-368.75+70)+' s0.06 -0.06') : dis.whole.path(eighthFlagPath).transform('t'+(x-97)+' '+(ary[i].y-379-15)+' s0.06 0.06');
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,55) : dis.whole.rect(x+20.95,ary[i].y-55-1.95,2,55);
				
				ary[i].flag = flag;
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
			if (ary[i].dur=='8.') {
				
				var x = ary[i].x;
				var flag = ( ary[i].i>9 ) ? dis.whole.path(eighthFlagPath).transform('t'+(x-117.9)+' '+(ary[i].y-368.75+40)+' s0.06 -0.06') : dis.whole.path(eighthFlagPath).transform('t'+(x-97)+' '+(ary[i].y-379)+' s0.06 0.06');
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,40) : dis.whole.rect(x+20.95,ary[i].y-40-1.95,2,40);
				
				ary[i].flag = flag;
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
			if (ary[i].dur=='t8') {
				
				var x = ary[i].x;
				var flag = ( ary[i].i>9 ) ? dis.whole.path(eighthFlagPath).transform('t'+(x-117.9)+' '+(ary[i].y-368.75+40)+' s0.06 -0.06') : dis.whole.path(eighthFlagPath).transform('t'+(x-97)+' '+(ary[i].y-379)+' s0.06 0.06');
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				if (ary[i].t3) ary[i].t3.remove();
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,40) : dis.whole.rect(x+20.95,ary[i].y-40-1.95,2,40);
				
				ary[i].flag = flag;
				
				var x3 = x+10;
				var y3 = ary[i].y-15;
				var t3 = dis.whole.text(x3,y3,'3').attr({fontStyle:'italic'});
				ary[i].t3 = t3;
				if (ary[i].i%2) t3.transform('t0 -9');
				
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
			if (ary[i].dur=='d8') {
				
				var x = ary[i].x;
				var flag = ( ary[i].i>9 ) ? dis.whole.path(eighthFlagPath).transform('t'+(x-117.9)+' '+(ary[i].y-368.75+40)+' s0.06 -0.06') : dis.whole.path(eighthFlagPath).transform('t'+(x-97)+' '+(ary[i].y-379)+' s0.06 0.06');
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				if (ary[i].t3) ary[i].t3.remove();
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,40) : dis.whole.rect(x+20.95,ary[i].y-40-1.95,2,40);
				
				ary[i].flag = flag;
				
				var x3 = x+10;
				var y3 = ary[i].y-15;
				var t3 = dis.whole.text(x3,y3,'2').attr({fontStyle:'italic'});
				ary[i].t3 = t3;
				if (ary[i].i%2) t3.transform('t0 -9');
				
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
			if (ary[i].dur=='f8') {
				
				var x = ary[i].x;
				var flag = ( ary[i].i>9 ) ? dis.whole.path(eighthFlagPath).transform('t'+(x-117.9)+' '+(ary[i].y-368.75+40)+' s0.06 -0.06') : dis.whole.path(eighthFlagPath).transform('t'+(x-97)+' '+(ary[i].y-379)+' s0.06 0.06');
				if (ary[i].stem) ary[i].stem.remove();
				if (ary[i].flag) ary[i].flag.remove();
				if (ary[i].t3) ary[i].t3.remove();
				ary[i].stem = ( ary[i].i>9 ) ? dis.whole.rect(x+0.05,ary[i].y+1.75,2,40) : dis.whole.rect(x+20.95,ary[i].y-40-1.95,2,40);
				
				ary[i].flag = flag;
				
				var x3 = x+10;
				var y3 = ary[i].y-15;
				var t3 = dis.whole.text(x3,y3,'4').attr({fontStyle:'italic'});
				ary[i].t3 = t3;
				if (ary[i].i%2) t3.transform('t0 -9');
				
				dis.whole.prepend(flag);
				dis.whole.prepend(ary[i].stem);
			}
		}
	}
	this.revertNotes = revertNotes;
	
	function isTuplet(dur) {
		var ts = ['t','f','s','d'];
		for (var i=0; i<ts.length; i++)
			if (dur.indexOf(ts[i])!=-1) return true;
		return false;
	}

	function checkRoom(mb,dur) {
		var measures = dis.measures;
		var duration = measures[mb.measure].duration; //var duration = measures[measures.length-1].duration;
		if (dis.params.pickup && mb.measure==0) {
			duration = parseInt(dis.params.tsig.split('/')[0]);
		}
		var meas = measures[mb.measure];
		var note = meas.obs[mb.iBeat];
		var beat = note.beat;
		if (beat+rBeat(dis,dur) > (duration+1)) return false;
		return true;
	}

	var cr;
	this.interactiveMeasures = function() {
		//clear rect
		cr = S.rect(0,-100,100,200+17.75*4).attr({opacity:0});
		this.cr = cr;
		cr.click(
			function(m) {
				if (dis.disabled) return;
				if (dis.removeTupletIsOpen) {
					dis.removeTupletIsOpen.remove();
					dis.removeTupletIsOpen = null;
					return;
				}
				
				if (dis.axeMenuIsOpen) {
					dis.axeMenuIsOpen.hide();
					dis.axeMenuIsOpen = null;
					return;
				}

				var cp = cursorPoint(m,S,cr); //x,y of mouse
				var inputMB = dis.findMB(cp); //index in measure, which beat or part of beat we're on

                if (dis.isMeasureLocked(inputMB.measure)) return;
				
				if (TIETIME) { //handle drawing of ties
					handleTie(dis,inputMB);
					return;
				}
				
				//remove
				if (clickExisting(inputMB)) {
					removeMBNote(inputMB); //removes note and all its stuff
					
					dis.updateAxe(inputMB);
					
					dis.recalculateDisplay();
					
					dis.removeTester();

					return;
				}
				
				//check if have enough beats left in measure
				var crr = dis.currentDUR;
				if (dis.params.lockRhythm) crr = inputMB.dur;
				if (!checkRoom(inputMB,crr)) {
					alert('Not enough room in measure.');
					return;
				}
				
				//if tuplet, check to see if the conversion is correct
				if (isTuplet(dis.currentDUR)&&inputMB.dur!=dis.currentDUR) {
					var conversion = checkConversion(inputMB,dis.currentDUR);
					if (conversion.error) {
						alert(conversion.error);
						return;
					}
				}
				
				//if tuplet there, check to see if can put GS.currentDUR
				if (isTuplet(inputMB.dur)&&dis.currentDUR!=inputMB.dur) {
					//check if ok to continue
					
					//for now, no
					alert('Cannot place this note type into tuplet.');
					return;
				}

				//keep it
				var lastDur = inputMB.dur;
				if (!dis.params.lockRhythm) {
					inputMB.dur = dis.currentDUR;
				}
				if (dis.fixedPitch) {
					inputMB.name = dis.fixedPitch;
				} else {
					inputMB.name = findNote(cp) || inputMB.name;
				}
				//inputMB.name = findNote(cp) || inputMB.name;
				dis.keepNote(inputMB,lastDur);
			}
		)
		cr.node.onmousemove = function(m) {
			if (dis.disabled) return;
			inputMove(m,cr);
		}
		cr.hover(
			function() {if (dis.disabled) return;},
			function() {if (dis.disabled) return; dis.removeTester();}
		)
        cr.node.addEventListener('contextmenu', function(ev) {
            ev.preventDefault();
            if (dis.disabled || dis.fixedPitch ||
                !(dis.authoring || dis.params.allowAccidentals === true)) return;
            var cp = cursorPoint(ev,S,cr);
            var inputMB = dis.findMB(cp);
            if (!inputMB || dis.isMeasureLocked(inputMB.measure) ||
                !clickExisting(inputMB)) return;
            if (inputMB.tieF || inputMB.tieB) {
                alert('Can\'t add accidental to a tied note!');
                return;
            }
            dis.axeOpen(inputMB);
        });
		this.whole.append(cr);
	}
	
	//tuplet shit
	function onFirstBeat(mb) {
		var nt = dis.measures[mb.measure].obs[mb.iBeat];
		if (nt.beat==Math.floor(nt.beat)) return true;
		return false;
	}
	
	function removeTuplet(mb,tog) {
		//if one open
		if (dis.removeTupletIsOpen)
			dis.removeTupletIsOpen.remove();
		
		var ele = tog ? mb.note : mb.rest;
		var x = mb.x - 55 + 12;
		var y = -70;//tog ? mb.snapNote.getBBox().y-70 : -18;
		var stf = dis.whole;
		var bg = stf.rect(x,y,111,24,5).attr({fill:'#E0E5E6',stroke:'black'});
		var text = stf.text(x+4,y+18,'Remove tuplet').attr({fontFamily:'lato'});
		var bgclr = stf.rect(x,y,111,24).attr({opacity:0});
		bgclr.node.id = 'pointer';
		var bgr = stf.group(bg,text,bgclr);
		dis.whole.append(bgr);
		bgr.click(function(){
			removeTupletBeat(mb);
			
			if (dis.removeTupletIsOpen) {
				dis.removeTupletIsOpen.remove();
				dis.removeTupletIsOpen = null;
			}
			
			dis.removeTester();
		})
		bgr.hover(function(){
			text.attr({fill:'white'});
		},function(){
			text.attr({fill:'black'});
		})
		dis.removeTupletIsOpen = bgr;
	}

	function findFirstBeat(beat,meas) {
		var time = dis.params.tsig;
		if (time.indexOf('/4')!=-1) return Math.floor(beat);
		if (time.indexOf('/8')!=-1) {
			if (beat<4) return 1;
			if (beat<7) return 4;
			if (beat<10) return 7;
			return 10;
		}
		if (time.indexOf('/2')!=-1) {
			return Math.floor(2*beat)/2;
		}
	}

	function removeTupletBeat(mb) {
		//remove all tuplet members from MB array
		var ary = dis.measures[mb.measure].obs;
		
		//remove rests
		dis.removeRests();
		
		//remove notes in the beat
		var tupM = tupMultiple(mb.dur);
		var tupletDuration = tupM*rBeat(dis,mb.dur,mb.measure);
		if (Math.abs(tupletDuration-Math.round(tupletDuration))<0.1) tupletDuration = Math.round(tupletDuration);
		if (Math.abs(tupletDuration-(Math.floor(tupletDuration)+0.5))<0.1) tupletDuration = Math.floor(tupletDuration)+0.5;
		var firstBeat = findFirstBeat(mb.beat,mb.measure);
		var fI;
		for (var i=0; i<ary.length; i++) {
			if (ary[i].beat==firstBeat) fI = i;
			if (ary[i].beat>=firstBeat&&ary[i].beat<(firstBeat+tupletDuration)) {
				if (ary[i].note) {
					removeMBNote(ary[i]);
					ary[i].note = null;
				}
			}
		}
		
		//first beat gets dur set to full duration of tuplet
		var fB = ary[fI];
		fB.dur = numToDur(dis,tupletDuration,mb.measure);
		ary[fI] = fB;
		
		//splice the tuplets out of ary
		tupM--;
		while(tupM) {
			ary.splice(fI+1,1);
			tupM--;
		}

		for (var i=0; i<ary.length; i++)
			ary[i].iBeat = i;
		
		dis.recalculateDisplay();
	}

	function clickTuplet(mb) {
		var nt = dis.measures[mb.measure].obs[mb.iBeat];
		
		var tups = ['t8','d8','f8','t4','d4','s16'];
		if (tups.indexOf(nt.dur)!=-1) return nt;
		return false;
	}
	
	//beaming
	var beatBuckets = function(m) {
		var ts = dis.params.tsig.split('/');
		var num = parseInt(ts[0]);
		var base = ts[1];
		
		var wdw;
		if (base=='4') wdw = 1;
		if (base=='2') wdw = 1;
		if (base=='8') wdw = 3;
		if (base=='16') wdw = 3;
		
		//6/4 shit...
		
		//num = num / wdw; //number of windows to look in, 4/4 should give 4, 6/8 should give two
		
		var bucks = [];
		var bw;
		for (var i=0; i<num; i+=wdw) {
			bw = [i+1,i+1+wdw];
			bucks.push(bw);
		}
		return bucks;
	}

	var lessClose = function(target,num) {
		//test if num is less than or very close to target
		var rnd = Math.round(num);
		if (Math.abs(rnd-num)<0.05) num = rnd;
		
		if (target==num) return true; //basically equal to it
		
		if (num < target) return true;
		
		return false;
	}

	var getInWindow = function(nts,wnd,m) {
		var left = wnd[0];
		var right = wnd[1];
		
		var ary = [];
		for (var i=0; i<nts.length; i++) {
			if (nts[i].beat>=left && lessClose(right,nts[i].beat+rBeat(dis,nts[i].dur)))
				ary.push(nts[i]);
		}
		return ary;
	}

	var tooLong = function(mb) {
		var dur = mb.dur;
		if (dur.indexOf('8')==-1&&dur.indexOf('16')==-1) return true;
		return false;
	}
	
	function handleBeaming(measure,indices) {
		var bsNotes = copyAry(hnotes).reverse();
		var middleN;
		switch(dis.params.clef) {
			case 'treble':
				middleN = 'B4';
				break;
			case 'bass':
				middleN = 'D3';
				break;
			case 'alto':
				middleN = 'C4';
				break;
		}
		
		var grp;
		var notes;
		var beam;
		var note;
		var type;
		var tsig = dis.params.tsig;
		for (var z=0; z<indices.length; z++) {
			grp = indices[z]; //a group of notes
			notes = [];
			beam = true; //yes beam
			type = '';
			for (var j=0; j<grp.length; j++) { //loop through the group of notes
				if (!measure[grp[j]].note) {beam = false; continue;} //missing a drawn note, so no beaming
				if (measure[grp[j]].dur=='4'&&tsig.indexOf('/8')!=-1) {beam = false; continue;}
				if (measure[grp[j]].dur=='4'&&tsig.indexOf('/2')!=-1) {beam = false; continue;}
				note = measure[grp[j]];//.note;
				notes.push(note);
			}
			if (beam) {
				for (var j=0; j<notes.length; j++) {
					cleanNote(notes[j]); //remove stem, flag, beam(s)
					type += notes[j].dur;
					if ( j < (notes.length-1) )
						type += ',';
				}
				
				//find stem direction
				var nms = [];
				var diff;
				var nm;
				var negMax = 1000000, posMax = -1000000;
				for (var i=0; i<notes.length; i++) {
					if (!notes[i]) continue; //hopefully rests
					nm = cleanName(notes[i].name);
					diff = bsNotes.indexOf(nm) - bsNotes.indexOf(middleN);
					notes[i].diff = Math.abs(diff);
					if (diff < negMax) negMax = diff;
					if (diff > posMax) posMax = diff;
				}
				
				if (Math.abs(negMax) > Math.abs(posMax)) { //maximum below B4
					drawStems(dis,notes,type,'up');
				}
				
				if (Math.abs(posMax) > Math.abs(negMax)) { //maximum above B4
					drawStems(dis,notes,type,'down');
				}
				
				if (Math.abs(posMax) == Math.abs(negMax)) {
					if (posMax==negMax) { //same note
						if (posMax>=0) drawStems(dis,notes,type,'down');
						else drawStems(dis,notes,type,'up');
					} else { //same distance from middle
						drawStems(dis,notes,type,'down');
					}
				}
			}
		}
	}
	
	this.beamNotes = function(n) {
		var rtms, nts;
		var ms;
		for (var m=0; m<this.measures.length; m++) {
			rtms = [];
			nts = [];
			ms = this.measures[m].obs;
			for (var b=0; b<ms.length; b++) {
				rtms.push(ms[b].dur); //all rhythms in measure
				nts.push(ms[b]);
			}
			
			var bmg = []; //group of indices
			var bbs = beatBuckets(m); //maximum beats to beam
			var bg;
			var bwd;
			for (var i=0; i<bbs.length; i++) {
				bwd = getInWindow(nts,bbs[i],m);
				bg = [];
				for (var j=0; j<bwd.length; j++) {
					if (bwd[j].rest||!bwd[j].note||tooLong(bwd[j])) { //run into a rest
						if (bg.length>1) bmg.push(bg);
						bg = [];
						continue;
					}
					
					bg.push(nts.indexOf(bwd[j]));
				}
				if (bg.length>1) bmg.push(bg); //done with loop
			}
			
			handleBeaming(ms,bmg);
		}
	}
	
	// //DUR BUTTON
	// var DB;
	// var TRIP = false;
	// var DUP = false;
	// var DURbutton = function(x,y) {
	// 	var S = dis.paper;
	// 	var bg = S.group();
	// 	dis.whole.append(bg);
	// 	var yst = y;//17.75*8 + 17.75*8 + 130;
	// 	var xst = x+25;//290;
		
	// 	var pRs = [];
	// 	var hideAllRs = function() {
	// 		for (var i=0; i<pRs.length; i++) {
	// 			if ( ( pRs[i].rt+dotted() )!=dis.currentDUR || TIETIME)
	// 				pRs[i].attr({opacity:0});
	// 		}
	// 	}
		
	// 	var dotted = function() {
	// 		if (rtog) return '.';
	// 		return '';
	// 	}
		
	// 	var cdurs = ['16','8','4','2','1'];
	// 	var clicker = function(ele,rt,ry) {
	// 		var bb = ele.getBBox();
	// 		var h = 80;
	// 		if (rt=='1w') ry-=14;
	// 		ry+=10;
			
	// 		var r = S.rect(bb.x-25,ry+25,bb.width+50,h).attr({opacity:0});
	// 		var ts = dis.params.tsig;
			
	// 		if (rt=='1q')
	// 			r.attr({opacity:0.1});
			
	// 		//make keyboard label
	// 		var lbl = bg.text(bb.x+bb.width/2,yst,'[ '+( rtms.indexOf(rt) + 1 )+' ]');
	// 		lbl.attr({fontSize:'30px',fontFamily:'lato'});
	// 		lbl.transform('t'+(-lbl.getBBox().width/2)+' 0 s0.4');
			
	// 		ele.append(r);
	// 		r.rt = cdurs[rtms.indexOf(rt)];
	// 		pRs.push(r);
			
	// 		r.click(
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
					
	// 				//clear out tuple select
	// 				TUP = false;
	// 				hideAllTupRs();
					
	// 				dis.currentDUR = cdurs[rtms.indexOf(rt)];
	// 				dis.DB.dotted = false;
					
	// 				//if (inputNote) {
	// 				//	inputNote.dur = dis.currentDUR;
	// 					//if (MB) {
	// 					//	if (!dis.measures[MB.meas].obs[MB.beat].note)
	// 					//		dis.placeNote(MB,inputNote);
	// 					//}
	// 				//}
					
	// 				hideAllRs();
	// 			}
	// 		)
	// 		r.node.id = 'pointer';
	// 		r.hover(
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
	// 				if (cdurs[rtms.indexOf(rt)]+dotted()==dis.currentDUR) return;
	// 				r.attr({opacity:0.1});
	// 			},
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
	// 				if (rt=='1e'&&dis.currentDUR=='t8') return;
	// 				if (cdurs[rtms.indexOf(rt)]+dotted()==dis.currentDUR) return;
	// 				r.attr({opacity:0});
	// 			}
	// 		)
	// 	}
		
	// 	//background
	// 	var bgr = S.rect(xst,yst,488,50,5).attr({fill:'#E0E5E6'});
	// 	bg.append(bgr);
		
	// 	//draw rhythms
	// 	var rtms = ['1s','1e','1q','1h','1w'];
	// 	var drx = xst-150;
	// 	var apvg;
	// 	for (var i=0; i<rtms.length; i++) {
	// 		apvg = paletteRhythm(dis,rtms[i],drx,yst+48);
	// 		bg.append(apvg);
			
	// 		apvg.transform('s0.5');
			
	// 		drx+=45;

	// 		//make clicker
	// 		new clicker(apvg,rtms[i],yst-48);
	// 	}
		
	// 	var tieReturn = function() {
	// 		ttog = false;
	// 		tieR.attr({opacity:0});	
	// 		TIETIME = false;
	// 	}
		
	// 	var rtog;
	// 	var dotR;
	// 	var dotClicker = function(ele,x,y) {
	// 		var w = 30;
	// 		var h = 30;
	// 		dotR = bg.rect(x-w/2,y-h/2,30,30).attr({opacity:0});
			
	// 		//make keyboard label
	// 		var lbl = bg.text(x-w/2,yst,'[ 6 ]').attr({fontSize:'30px',fontFamily:'lato'});
	// 		lbl.transform('t0 0 s0.4');
	// 		moveEle(lbl,-lbl.getBBox().width/2,0);
			
	// 		var r = dotR;
	// 		r.hover(
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
	// 				r.attr({opacity:0.1});
	// 			},
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
	// 				if (!rtog)
	// 					r.attr({opacity:0});
	// 			}
	// 		)
	// 		r.click(
	// 			function() {
	// 				//DB.tied = false;
	// 				if (dis.disabled) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
					
	// 				if (dis.currentDUR=='t8') return;
	// 				if (dis.currentDUR=='16') return;
	// 				if (dis.currentDUR=='d8') return;
	// 				if (dis.currentDUR=='t4') return;
	// 				if (dis.currentDUR=='d4') return;
	// 				//if (GS.currentDUR=='1') return;
					
	// 				//clear out trip, dup stuff
	// 				TUP = false;
	// 				hideAllTupRs();
					
	// 				dis.currentDUR = dis.currentDUR.replace('t','').replace('s','');
					
	// 				rtog = !rtog;
	// 				switch(rtog) {
	// 					case true:
	// 						dis.currentDUR = dis.currentDUR + '.';
	// 						r.attr({opacity:0.1});
	// 						break;
	// 					case false:
	// 						dis.currentDUR = dis.currentDUR.replace('.','');
	// 						r.attr({opacity:0});
	// 						break;
	// 				}
	// 			}
	// 		)
	// 		r.node.id = 'pointer';
	// 	}
		
	// 	Object.defineProperty(this, "dotted", {
	// 		get: function() {return rtog;},
	// 		set: function(v) {rtog = v; if (v) dotR.attr({opacity:0.1}); else dotR.attr({opacity:0});}
	// 	})
		
	// 	//dot
	// 	apvg = bg.circle(drx+160,yst+30,4);
	// 	apvg.transform('s0.5');
	// 	new dotClicker(apvg,drx+160,yst+30);
		
	// 	var ttog;
	// 	var tieR;
	// 	var tieClicker = function(ele,x,y) {
	// 		var w = 30;
	// 		var h = 30;
	// 		tieR = bg.rect(x-w/2,y-h/2,30,30).attr({opacity:0});
			
	// 		//make keyboard label
	// 		var lbl = bg.text(x-w/2,yst,'[ 7 ]').attr({fontSize:'30px',fontFamily:'lato'});
	// 		lbl.transform('t0 0 s0.4');
	// 		moveEle(lbl,-lbl.getBBox().width/2,0);
			
	// 		var r = tieR;
	// 		r.hover(
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (!CANEDIT) return;
	// 				r.attr({opacity:0.1});
	// 			},
	// 			function() {
	// 				if (!CANEDIT) return;
	// 				if (!ttog)
	// 					r.attr({opacity:0});
	// 			}
	// 		)
	// 		r.click(
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (!CANEDIT) return;
	// 				dis.DB.dotted = false;
	// 				dis.DB.tied = !dis.DB.tied;
	// 			}
	// 		)
	// 		r.node.id = 'pointer';
	// 	}
		
	// 	Object.defineProperty(this, "tied", {
	// 		get: function() {return ttog;},
	// 		set: function(v) {
	// 			ttog = v;
				
	// 			if (v) tieR.attr({opacity:0.1});
	// 			else tieR.attr({opacity:0});
				
	// 			TIETIME = v;
				
	// 			if (v) {
	// 				hideAllRs();
	// 				dis.removeTester()
	// 			} else {
	// 				dis.DB.setDur(dis.currentDUR);
					
	// 				/*if (inputNote) {
	// 					inputNote.dur = dis.currentDUR;
	// 					if (MB) {
	// 						if (!dis.measures[MB.meas].obs[MB.beat].note)
	// 							dis.placeNote(MB,inputNote);
	// 					}
	// 				}*/
	// 			}
	// 		}
	// 	})
		
	// 	//tie
	// 	var tx = drx+185;
	// 	var ty = yst+15;
	// 	apvg = genTie(bg,tx,ty,tx+30,ty,1);
	// 	new tieClicker(apvg,tx+15,ty+15);
		
	// 	//divider
	// 	var dvd = bg.rect(tx+35,yst,2,50);
	// 	//var tpt = bg.text(tx+40,yst-5,'Tuplets').attr({fontFamily:'lato'});
		
	// 	var getTuplet = function(type) {
	// 		switch(type) {
	// 			case '2':
	// 				if (dis.currentDUR=='8') return 'd8';
	// 				if (dis.currentDUR=='4') return 'd4';
	// 				break;
	// 			case '3':
	// 				if (dis.currentDUR=='8') return 't8';
	// 				if (dis.currentDUR=='4') return 't4';
	// 				break;
	// 			case '4':
	// 				if (dis.currentDUR=='8') return 'f8';
	// 				break;
	// 			case '6':
	// 				if (dis.currentDUR=='16') return 's16';
	// 				break;
	// 		}
	// 	}
		
	// 	var checkTuplet = function(type) {
	// 		var ts = dis.params.tsig;
	// 		//var mb = MB;
	// 		//if (!MB) { mb = {}; mb.meas = 0; }
	// 		var base = ts.split('/')[1];
	// 		switch(type) {
	// 			case '2':
	// 				if (dis.currentDUR!='8') return 'no'; //only duple eighth notes
	// 				if (base!='8') return 'tsig'; //only allowed in compound time
	// 				break;
	// 			case '3':
	// 				if (dis.currentDUR!='8'&&dis.currentDUR!='4') return 'no'; //only eighth or quarter
	// 				if (base=='8') return 'tsig'; //not allowed in compound time
	// 				if (base=='16') return 'tsig'; //only allowed in compound time
	// 				//if (dis.currentDUR=='4'&&base=='4') return 'tsig'; //not allowed in x/4
	// 				break;
	// 			case '4':
	// 				if (dis.currentDUR!='8') return 'no'; //only quadruplet eighth notes
	// 				if (base!='8') return 'tsig'; //only allowed in compound time
	// 				break;
	// 			case '6':
	// 				if (dis.currentDUR!='16') return 'no'; //only sextuplet 16ths
	// 				if (base=='8') return 'tsig'; //not allowed in compound
	// 				if (base=='16') return 'tsig'; //only allowed in compound time
	// 				break;
	// 		}
	// 		return true;
	// 	}
		
	// 	var hideAllTupRs = function() {
	// 		for (var i=0; i<tupRs.length; i++) {
	// 			tupRs[i].attr({opacity:0});
	// 			tupRs[i].tog = false;
	// 		}
	// 	}
		
	// 	//now the tuplets
	// 	var tupletFunction = function(type,r) {
	// 		if (dis.disabled) return;
	// 		if (TIETIME) return;
	// 		if (!CANEDIT) return;
			
	// 		//check for not allowed
	// 		var chk = checkTuplet(type);
	// 		if (chk=='no') {alert('This type of tuplet is not allowed.\nCurrently allowed types are:\nTriplet 8th, Duple 8th, Triplet Quarter, Quadruplet 8th, Sextuplet 16th'); return;}
	// 		if (chk=='tsig') {alert('This type of tuplet is not allowed in the current time signature.'); return;}
			
	// 		r.tog = !r.tog;
			
	// 		switch(r.tog) {
	// 			case true:
	// 				dis.currentDUR = getTuplet(type);
	// 				dis.DB.dotted = false;
					
	// 				hideAllRs();
	// 				hideAllTupRs();
					
	// 				r.tog = true;
					
	// 				var prIndex;
	// 				if (dis.currentDUR.indexOf('16')!=-1) prIndex = 0;
	// 				if (dis.currentDUR.indexOf('8')!=-1) prIndex = 1;
	// 				if (dis.currentDUR.indexOf('4')!=-1) prIndex = 2;
	// 				pRs[prIndex].attr({opacity:0.1});
					
	// 				r.attr({opacity:0.1});
	// 				break;
	// 			case false:
	// 				dis.currentDUR = '8';
					
	// 				hideAllRs();
	// 				break;
	// 		}
	// 	}

	// 	var TUP = false;
	// 	var tupR;
	// 	var tupRs = [];
	// 	var tptogs = [];
	// 	var tupleClicker = function(ele,x,y,type) {
	// 		var w = 45;
	// 		var h = 45;
	// 		var r = bg.rect(x-w/2,y-h/2,w,h).attr({opacity:0});
	// 		var diz = this;
	// 		tupRs.push(r);
	// 		r.hover(
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TUP) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
	// 				r.attr({opacity:0.1});
	// 			},
	// 			function() {
	// 				if (dis.disabled) return;
	// 				if (TUP) return;
	// 				if (TIETIME) return;
	// 				if (!CANEDIT) return;
	// 				if (!r.tog)
	// 					r.attr({opacity:0});
	// 			}
	// 		)
	// 		r.click(
	// 			function() {
	// 				tupletFunction(type,r);
	// 			}
	// 		)
	// 		r.node.id = 'pointer';
	// 	}
		
	// 	//tuplets
	// 	tx+=5;
	// 	var trpX = tx+60;
	// 	var trpY = yst+25;
	// 	apvg = bg.text(trpX,trpY+10,'2').attr({fontStyle:'italic',fontSize:'26px'});
	// 	apvg.transform('t'+(-apvg.getBBox().width/2)+' 0');
	// 	bg.append(apvg);
	// 	new tupleClicker(apvg,trpX,trpY,'2');
	// 	//make keyboard label
	// 	var lbl = bg.text(trpX-45/2+8,yst,'[ 8 ]').attr({fontSize:'30px',fontFamily:'lato'});
	// 	lbl.transform('t0 0 s0.4');
	// 	moveEle(lbl,-lbl.getBBox().width/2,0);
		
	// 	trpX+=45;
	// 	apvg = bg.text(trpX,trpY+10,'3').attr({fontStyle:'italic',fontSize:'26px'});
	// 	apvg.transform('t'+(-apvg.getBBox().width/2)+' 0');
	// 	bg.append(apvg);
	// 	new tupleClicker(apvg,trpX,trpY,'3');
	// 	//make keyboard label
	// 	var lbl = bg.text(trpX-45/2+8,yst,'[ 9 ]').attr({fontSize:'30px',fontFamily:'lato'});
	// 	lbl.transform('t0 0 s0.4');
	// 	moveEle(lbl,-lbl.getBBox().width/2,0);
		
	// 	trpX+=45;
	// 	apvg = bg.text(trpX,trpY+10,'4').attr({fontStyle:'italic',fontSize:'26px'});
	// 	apvg.transform('t'+(-apvg.getBBox().width/2)+' 0');
	// 	bg.append(apvg);
	// 	new tupleClicker(apvg,trpX,trpY,'4');
	// 	//make keyboard label
	// 	var lbl = bg.text(trpX-45/2+8,yst,'[ 0 ]').attr({fontSize:'30px',fontFamily:'lato'});
	// 	lbl.transform('t0 0 s0.4');
	// 	moveEle(lbl,-lbl.getBBox().width/2,0);
		
	// 	trpX+=45;
	// 	apvg = bg.text(trpX,trpY+10,'6').attr({fontStyle:'italic',fontSize:'26px'});
	// 	apvg.transform('t'+(-apvg.getBBox().width/2)+' 0');
	// 	bg.append(apvg);
	// 	new tupleClicker(apvg,trpX,trpY,'6');
	// 	//make keyboard label
	// 	var lbl = bg.text(trpX-45/2+8,yst,'[ - ]').attr({fontSize:'30px',fontFamily:'lato'});
	// 	lbl.transform('t0 0 s0.4');
	// 	moveEle(lbl,-lbl.getBBox().width/2,0);
		
	// 	this.setDur = function(d) {
	// 		if (d.indexOf('.')==-1) dis.DB.dotted = false;
	// 		else dis.DB.dotted = true;
	// 		for (var i=0; i<pRs.length; i++)
	// 			if (pRs[i].rt==dis.currentDUR.replace('.',''))
	// 				pRs[i].attr({opacity:0.1});
	// 		hideAllRs();
	// 		hideAllTupRs();
	// 	}
		
	// 	bg.transform('t0 0');
	// 	this.whole = bg;
		
	// 	this.move = function(x) {
	// 		bg.transform('t'+x+' 0');
	// 	}
		
	// 	this.width = bg.getBBox().width;
		
	// 	var wc = dis.container;
	// 	wc.onkeydown = function(evt) {
	// 		if (!CANEDIT) return;
	// 		if (TIETIME&&evt.key!='7') {
	// 			if (evt.key==' ') {inputSpace(); evt.preventDefault();}
	// 			return;
	// 		}
	// 		switch(evt.keyCode) {
	// 			case 38:
	// 				inputUp();
	// 				evt.preventDefault();
	// 				return;
	// 			case 40:
	// 				inputDown();
	// 				evt.preventDefault();
	// 				return;
	// 			default:
	// 				break;
	// 		}
	// 		switch(evt.key) {
	// 			case 'Tab':
	// 				if (evt.shiftKey)
	// 					backTab();
	// 				else
	// 					inputTab();
	// 				return;
	// 			case ' ':
	// 				inputSpace();
	// 				evt.preventDefault();
	// 				return;
	// 			case 'o':
	// 				var newNote = inputUp();
	// 				noteChange(newNote);
	// 				return;
	// 			case 'l':
	// 				var newNote = inputDown();
	// 				noteChange(newNote);
	// 				return;
	// 			case 'd':
	// 				inputD();
	// 				return;
	// 			case 's':
	// 				inputAxe('♯');
	// 				return;
	// 			case 'f':
	// 				inputAxe('\u0231');
	// 				return;
	// 			case 'x':
	// 				inputAxe('x');
	// 				return;
	// 			case 'w':
	// 				inputAxe('bb');
	// 				return;
	// 			case 'n':
	// 				inputAxe('n');
	// 				return;
	// 			case '1':
	// 				dis.currentDUR = '16';
	// 				DB.dotted = false;
	// 				durationChange(dis.currentDUR);
	// 				break;
	// 			case '2':
	// 				dis.currentDUR = '8';
	// 				DB.dotted = false;
	// 				durationChange(dis.currentDUR);
	// 				break;
	// 			case '3':
	// 				dis.currentDUR = '4';
	// 				DB.dotted = false;
	// 				durationChange(dis.currentDUR);
	// 				break;
	// 			case '4':
	// 				dis.currentDUR = '2';
	// 				DB.dotted = false;
	// 				durationChange(dis.currentDUR);
	// 				break;
	// 			case '5':
	// 				dis.currentDUR = '1';
	// 				DB.dotted = false;
	// 				durationChange(dis.currentDUR);
	// 				break;
	// 			case '6':
	// 				if (dis.currentDUR=='t8') return;
	// 				if (dis.currentDUR=='16') return;
	// 				if (dis.currentDUR=='d8') return;
	// 				if (dis.currentDUR=='t4') return;
	// 				if (dis.currentDUR=='d4') return;
	// 				DB.dotted = !DB.dotted;
	// 				switch(DB.dotted) {
	// 					case true:
	// 						dis.currentDUR = dis.currentDUR + '.';
	// 						break;
	// 					case false:
	// 						dis.currentDUR = dis.currentDUR.replace('.','');
	// 						break;
	// 				}
	// 				durationChange(dis.currentDUR);
	// 				break;
	// 			case '7':
	// 				DB.dotted = false;
	// 				DB.tied = !DB.tied;
	// 				tieChange(DB.tied);
	// 				return;
	// 				break;
	// 			case '8':
	// 				tupletFunction('2',tupRs[0]);
	// 				if (inputNote) {
	// 					inputNote.dur = dis.currentDUR;
	// 				}
	// 				durationChange(dis.currentDUR);
	// 				return;
	// 				break;
	// 			case '9':
	// 				tupletFunction('3',tupRs[1]);
	// 				if (inputNote) {
	// 					inputNote.dur = dis.currentDUR;
	// 				}
	// 				durationChange(dis.currentDUR);
	// 				return;
	// 				break;
	// 			case '0':
	// 				tupletFunction('4',tupRs[2]);
	// 				if (inputNote) {
	// 					inputNote.dur = dis.currentDUR;
	// 				}
	// 				durationChange(dis.currentDUR);
	// 				return;
	// 				break;
	// 			case '-':
	// 				tupletFunction('6',tupRs[3]);
	// 				if (inputNote) {
	// 					inputNote.dur = dis.currentDUR;
	// 				}
	// 				durationChange(dis.currentDUR);
	// 				return;
	// 				break;
	// 			default:
	// 				return;
	// 		}
			
	// 		if (evt.key!='7') {
	// 			DB.setDur(dis.currentDUR);
				
	// 			if (inputNote) {
	// 				inputNote.dur = dis.currentDUR;
	// 			}
	// 		}
	// 	}

	// 	//help button
	// 	var qc = this.whole.circle(xst+this.width+30,yst+25,16,16).attr({fill:rnGrad2});
	// 	var qm = this.whole.text(xst+this.width+30,yst+25,'?').attr({fontSize:'22px'});
	// 	qm.transform('t'+(-qm.getBBox().width/2)+' '+qm.getBBox().height/4);
	// 	var qc2 = this.whole.circle(xst+this.width+30,yst+25,16,16).attr({opacity:0});
	// 	qc2.node.id = 'pointer';
	// 	qc2.hover(
	// 		function() {
	// 			qc.attr({strokeWidth:1,stroke:'black'});
	// 		},
	// 		function() {
	// 			qc.attr({strokeWidth:1,stroke:'none'});
	// 		}
	// 	)
	// 	qc2.click(
	// 		function() {
	// 			reactParent.help.current.help.current.setOpen(true);
	// 		}
	// 	)
	// }
    var DURbutton = function (x, y, options = {}) {
        var S = dis.paper;

        // ROOT
        var bg = S.group();
        dis.whole.append(bg);

        // CONTENT (drives width)
        var content = S.group();
        bg.append(content);

        var DURATIONS = options.durations || [];
        var TUPLETS = options.tuplets || [];

        var yst = y;
        var xst = x + 25;

        var pRs = [];
        var tupRs = [];
        var TUP = false;
        var TIETIME = false;

        var rtog = false;
        var ttog = false;

        var PAD_X = 10;
        var PAD_Y = 5;

        function hideAllRs() {
            pRs.forEach(r => r.attr({ opacity: 0 }));
        }

        function syncSelectedDuration() {
            pRs.forEach(r => {
                if (r.durId === dis.currentDUR) {
                r.attr({ opacity: 0.1 });
                } else {
                r.attr({ opacity: 0 });
                }
            });
        }


        function hideAllTupRs() {
            tupRs.forEach(r => {
            r.attr({ opacity: 0 });
            r.tog = false;
            });
        }

        /* ───────── BACKGROUND (auto-sized later) ───────── */
        var bgr = S.rect(0, 0, 10, 10, 5).attr({ fill: "#E0E5E6" });
        bg.prepend(bgr);

        /* ───────── DURATIONS ───────── */
        var drx = xst - 150;

        DURATIONS.forEach((dur) => {
            var glyph = paletteRhythm(dis, dur.glyph, drx, yst + 48);
            content.append(glyph);
            glyph.transform("s0.5");

            var bb = glyph.getBBox();
            var r = S.rect(bb.x - 10, yst - 5, bb.width + 20, 50)
            .attr({ opacity: 0.1 });

            r.durId = dur.id;
            r.node.setAttribute("data-duration", dur.id);
            r.node.setAttribute("role", "button");
            r.node.setAttribute("aria-label", nType(dur.id) + " note");
            pRs.push(r);
            content.append(r);

            var selectDuration = function () {
                if (!CANEDIT || TIETIME || dis.disabled) return;
                TUP = false;
                hideAllTupRs();
                dis.currentDUR = dur.id;
                DB.dotted = false;
                syncSelectedDuration();
            };

            // iPad/Safari can treat the first tap on an element with hover
            // handlers as a hover-only interaction. Commit the duration on
            // touch/pen pointer-down so one tap both selects and highlights it.
            if (r.node && window.PointerEvent) {
                r.node.style.touchAction = "manipulation";
                r.node.addEventListener("pointerdown", function (evt) {
                    if (evt.pointerType === "touch" || evt.pointerType === "pen") {
                        evt.preventDefault();
                        selectDuration();
                    }
                }, { passive: false });

                // Use pointer hover only for actual mouse-like pointers. This
                // prevents a touch tap from leaving a second hover highlight.
                r.node.addEventListener("pointerenter", function (evt) {
                    if (evt.pointerType === "touch" || evt.pointerType === "pen") return;
                    if (CANEDIT) r.attr({ opacity: 0.1 });
                });
                r.node.addEventListener("pointerleave", function (evt) {
                    if (evt.pointerType === "touch" || evt.pointerType === "pen") return;
                    if (dis.currentDUR !== dur.id) r.attr({ opacity: 0 });
                });
            } else {
                r.hover(
                    () => CANEDIT && r.attr({ opacity: 0.1 }),
                    () => dis.currentDUR !== dur.id && r.attr({ opacity: 0 })
                );
            }

            r.click(selectDuration);

            drx += 45;
        });

        /* ───────── DOT ───────── */
        if (options.allowDotted !== false) {
            var dot = content.circle(drx + 160, yst + 30, 4).transform("s0.5");
            var dotR = content.rect(drx + 145, yst + 15, 30, 30).attr({ opacity: 0 });

            dotR.hover(
            () => CANEDIT && dotR.attr({ opacity: 0.1 }),
            () => !rtog && dotR.attr({ opacity: 0 })
            );

            dotR.click(() => {
            if (!CANEDIT || TIETIME) return;
            rtog = !rtog;
            dis.currentDUR = rtog
                ? dis.currentDUR + "."
                : dis.currentDUR.replace(".", "");
            dotR.attr({ opacity: rtog ? 0.1 : 0 });
            });
        }

        /* ───────── TIE ───────── */
        if (options.allowTie !== false) {
            var tx = drx + 185;
            var ty = yst + 15;

            var tie = genTie(content, tx, ty, tx + 30, ty, 1);
            var tieR = content.rect(tx, ty, 30, 30).attr({ opacity: 0 });

            tieR.hover(
            () => CANEDIT && tieR.attr({ opacity: 0.1 }),
            () => !ttog && tieR.attr({ opacity: 0 })
            );

            tieR.click(() => {
            if (!CANEDIT) return;
            ttog = !ttog;
            TIETIME = ttog;
            tieR.attr({ opacity: ttog ? 0.1 : 0 });
            });
        }

        /* ───────── TUPLETS ───────── */
        var trpX = drx + 250;
        var trpY = yst + 25;

        TUPLETS.forEach((tup, i) => {
            var x = trpX + i * 45;

            var txt = content.text(x, trpY + 10, tup.label)
            .attr({ fontStyle: "italic", fontSize: "26px" });

            var r = content.rect(x - 20, trpY - 20, 40, 40).attr({ opacity: 0 });
            r.tog = false;
            tupRs.push(r);

            r.hover(
            () => CANEDIT && !TUP && r.attr({ opacity: 0.1 }),
            () => !r.tog && r.attr({ opacity: 0 })
            );

            r.click(() => {
            if (!CANEDIT || TIETIME) return;

            if (!tup.allowed(dis.params.tsig)) {
                alert("Tuplet not allowed in this time signature.");
                return;
            }

            if (!tup.appliesTo.includes(dis.currentDUR)) {
                alert("Tuplet not allowed for this duration.");
                return;
            }

            r.tog = !r.tog;

            if (r.tog) {
                dis.currentDUR = tup.result(dis.currentDUR);
                syncSelectedDuration();
                //hideAllRs();
                hideAllTupRs();
                r.attr({ opacity: 0.1 });
            } else {
                dis.currentDUR = tup.appliesTo[0];
                syncSelectedDuration();
                //hideAllRs();
            }
            });
        });

        /* ───────── KEYBOARD ───────── */
        dis.container.onkeydown = function (evt) {
            if (!CANEDIT) return;

            DURATIONS.forEach(d => {
            if (evt.key === d.key) {
                dis.currentDUR = d.id;
                DB.dotted = false;
            }
            });

            TUPLETS.forEach((t, i) => {
            if (evt.key === t.key) {
                tupRs[i].click();
            }
            });
        };

        this.setDur = function (d) {
            rtog = d.includes(".");
            syncSelectedDuration();
            //hideAllRs();
            hideAllTupRs();
        };

        /* ───────── FINAL LAYOUT ───────── */
        var bb = content.getBBox();

        bgr.attr({
            x: bb.x - PAD_X,
            y: bb.y - PAD_Y,
            width: bb.width + PAD_X * 2,
            height: bb.height + PAD_Y * 2
        });

        this.width = bb.width + PAD_X * 2;
        this.whole = bg;

        // Keep the duration palette pinned to the visible portion of the
        // horizontally scrolling score. The container scroll handler calls
        // this with wc.scrollLeft.
        this.move = function (x) {
            bg.transform("t" + x + " 0");
        };

        // ensure default duration is visibly selected
        syncSelectedDuration();
    };



	var keyChangeAlert;
	var durationChange = function(dur) {
		if (keyChangeAlert) {
			document.body.removeChild(keyChangeAlert);
		}
		keyChangeAlert = document.createElement("p");
		keyChangeAlert.setAttribute("role", "alert");
		var keyChangeAlertText = document.createTextNode("Duration set to "+nType(dur)+" note");
		keyChangeAlert.appendChild(keyChangeAlertText);
		document.body.appendChild(keyChangeAlert);
		keyChangeAlert.style.left = '-99999px';
		keyChangeAlert.style.position = 'absolute';
	}

	var noteChangeAlert;
	var noteChange = function(note) {
		var ele = document.getElementById(dis.container.id+'-notechange');
		ele.innerHTML = "Input note set to "+accessibleName(note);
	}

	var accessAlert;
	var tieChange = function(tieState) {
		if (accessAlert) {
			document.body.removeChild(accessAlert);
		}
		accessAlert = document.createElement("p");
		accessAlert.setAttribute("role", "alert");
		var text = tieState ? "on" : "off";
		var accessAlertText = document.createTextNode("Tied note input toggled "+text);
		accessAlert.appendChild(accessAlertText);
		document.body.appendChild(accessAlert);
		accessAlert.style.left = '-99999px';
		accessAlert.style.position = 'absolute';
	}
	
	var wc = this.container;//getByClass(this.container,'widget-holder-input');
	var ERRORS = [];
	wc.onscroll = function(dx) {
		if (dis.DB.move) dis.DB.move(wc.scrollLeft);
		for (var i=0; i<ERRORS.length; i++) {
			ERRORS[i].style.left = (ERRORS[i].keepLeft-wc.scrollLeft)+'px';
		}
	}
	wc.onmousemove = function() {
		wc.focus();
	}
	wc.onmouseover = function() {
		wc.focus();
	}
	wc.onmouseenter = function() {
		wc.focus();
	}
	wc.onmouseout = function() {
		wc.blur();
	}

	wc.onfocus = function() {
		key_coord = {m:0,b:-1,n:'B4'};
		//console.log('resetting shit');
	}
	
	//DISPLAY SHIT
	this.drawRests = function() {
		var obs;
		for (var i=0; i<this.measures.length; i++) {
			obs = this.measures[i].obs;
			for (var j=0; j<obs.length; j++) {
				if (obs[j].rest) {
					obs[j].rest.remove();
					delete obs[j].rest;
				}
				if (!obs[j].note)
					drawRest(this,this.whole,obs[j],i);
			}
		}
	}
	
	this.removeRests = function() {
		var ts, bs;
		for (var i=0; i<this.measures.length; i++) {
			bs = this.measures[i].obs;
			for (var j=0; j<bs.length; j++) {
				if (bs[j].rest) {
					bs[j].rest.remove();
					delete bs[j].rest;
				}
			}
		}
	}
	
	function axeWidth(mb) {
		if (!mb.note) return 0;
		if (!mb.axe) return 0;
		return mb.axe.getBBox().width;
	}
	
	this.recalculateXs = function() { //calculates the Xs for spacing
		var tB = 1, bB = 1;
		var tI = 1, bI = 1;
		var tD, bD;
		var beatX;
		var tLMB, bLMB;
		
		var curB = 0; //if start at 0, then in while loop can just start indices at 0
		
		//while still have members of array
		var tbs, bbs;
		var tsig = this.params.tsig; //initial time sig
		for (var i=0; i<this.measures.length; i++) { //loop through measures
			bbs = this.measures[i].obs;
			
			bI = 1;
			
			//if start of a new measure
			if (i>0) {
				bLMB = this.measures[i-1].obs[this.measures[i-1].obs.length-1];
				bbs[0].x = bLMB.x + noteW(bLMB.dur) + newX(bLMB.dur) + barlineMARGIN + 1 + axeWidth(bbs[0]);
			}
			
			while( bbs[bI] ) { //while there is a treble or bass measure-beat
				bbs[bI].x = bbs[bI-1].x + noteW(bbs[bI-1].dur) + newX(bbs[bI-1].dur) + axeWidth(bbs[bI]);
				bI++;
			}
			
			this.measures[i].left = bbs[0].x; //update left of measure
			
			if (i==this.measures.length-1) {
				bLMB = this.measures[i].obs[this.measures[i].obs.length-1];
				this.measures[i].right = bLMB.x + noteW(bLMB.dur) + newX(bLMB.dur) + barlineMARGIN + 1 + axeWidth(bLMB);
			} else {
				bLMB = this.measures[i].obs[this.measures[i].obs.length-1];
				this.measures[i].right = bLMB.x + noteW(bLMB.dur) + newX(bLMB.dur) + 1 + axeWidth(bLMB);
			}
		}
	}
	
	this.recalculateCXs = function() { //calculates the CXs for placing notes
		var ary;
		var ms = this.measures;
		var eleW;
		for (var i=0; i<ms.length; i++) {
			
				ary = ms[i].obs;
				for (var k=1; k<ary.length; k++) { //looping through measure-beats
					eleW = 0;//noteW(ary[i].dur) + newX(ary[i].dur);
					if (ary[k-1].rest) eleW = ary[k-1].rest.getBBox().width;
					if (ary[k-1].snapNote) eleW = ary[k-1].snapNote.getBBox().width;
					ary[k-1].cx = ( ary[k-1].x + eleW + ary[k].x ) / 2;
				}
				if (ms[i+1])
					ary[ary.length-1].cx = ms[i+1].obs[0].x - (barlineMARGIN+1);
		}
	}
	
	this.redrawBarlines = function() { //draws the barlines and sizes the staffs
		var blns = this.barlines;
		for (var i=0; i<blns.length; i++) {
			blns[i].remove();
		}
		blns = [];
		this.barlines = [];
		
		for (var i=1; i<this.measures.length; i++) {
			this.drawBarline(this.measures[i].left-(barlineMARGIN+1+axeWidth(this.measures[i].obs[0])));
		}
	}
	
	this.transformNote = function(mb) {
		var note = mb.note;
		var x = mb.note.x;
		var nx = mb.x;
		var dx = nx - x;
		
		moveEle(note,dx,0);
		if (mb.stem)
			moveEle(mb.stem,dx,0);
		if (mb.flag)
			moveEle(mb.flag,dx,0);
		if (mb.axe)
			moveEle(mb.axe,dx,0);
		if (mb.beam)
			moveEle(mb.beam,dx,0);
		if (mb.beam2)
			moveEle(mb.beam2,dx,0);
		if (mb.ledgers) {
			for (var i=0; i<mb.ledgers.length; i++)
				moveEle(mb.ledgers[i],dx,0);
		}
		if (mb.axeMenu) {
			mb.axeMenu.move(dx);
		}
		if (mb.tieF) {
			if (TIESMOVED.indexOf(mb.tieF)==-1) {
				moveEle(mb.tieF,dx,0);
				TIESMOVED.push(mb.tieF);
			}
		}
		if (mb.tieB) {
			if (TIESMOVED.indexOf(mb.tieB)==-1) {
				moveEle(mb.tieB,dx,0);
				TIESMOVED.push(mb.tieB);
			}
		}
		if (mb.t3) {
			if (THREESMOVED.indexOf(mb.t3)==-1) {
				moveEle(mb.t3,dx,0);
				THREESMOVED.push(mb.t3);
			}
		}
		if (mb.dot)
			moveEle(mb.dot,dx,0);
		
		mb.note.x = nx;
		mb.x = nx;
	}
	
	this.transformAllNotes = function() {
		var ary;
		TIESMOVED = [];
		THREESMOVED = [];
		for (var i=0; i<this.measures.length; i++) {
			ary = this.measures[i].obs;
			for (var k=0; k<ary.length; k++) {
				if (ary[k].note) {
					this.transformNote(ary[k]);
				}
			}
		}
	}
	
	this.clearMeasureNumbers = function() {
		if (!this.measureNumberElements) {
			this.measureNumberElements = [];
			return;
		}

		for (var i=0; i<this.measureNumberElements.length; i++) {
			this.measureNumberElements[i].remove();
		}
		this.measureNumberElements = [];
	}

	this.drawMeasureNumbers = function() {
		this.clearMeasureNumbers();

		// Opt-in only. Existing melody questions remain unchanged unless
		// config.measureNumbers is explicitly true.
		if (this.params.measureNumbers !== true) return;

		var hasPickup = !!this.params.pickup;
		var start = Number(this.params.measureNumberStart);
		if (!Number.isFinite(start)) start = 1;

		for (var i=0; i<this.measures.length; i++) {
			// Treat an anacrusis as unnumbered; measure 1 is the first full measure.
			if (hasPickup && i===0) continue;

			var logicalIndex = i - (hasPickup ? 1 : 0);
			var label = start + logicalIndex;

			// Center the number over the barline that begins this measure.
			// Measure 1 without a pickup has no drawn opening barline, so use
			// the beginning of its music as the visual start position.
			var firstBeat = this.measures[i].obs[0];
			var x = i === 0
				? this.measures[i].left
				: this.measures[i].left - (barlineMARGIN + 1 + axeWidth(firstBeat));
			var y = -12;

			var number = this.whole.text(x,y,String(label)).attr({
				fontSize: "16px",
				fontWeight: "600",
				fill: "#333",
				"pointer-events": "none"
			});
			number.node.setAttribute("class","melody-measure-number");
			this.measureNumberElements.push(number);
		}
	}

	this.recalculateDisplay = function() {
		//calculate xs
		this.recalculateXs();
		
		width = this.measures[this.measures.length-1].right;
		//staff line
		drawStaffLines(this,width);
		
		//move all existing notes
		this.transformAllNotes();
		
		//barlines
		this.redrawBarlines();
		
		//beam notes
		this.beamNotes();
		
		//draw rests
		this.drawRests();
		
		//calculate cxs
		this.recalculateCXs();
		
		//clear cover for interactivity
		this.cr.attr({width:width});

		//put everything in the correct tab order (append to main svg from left to right), then append cover
		this.appendAll();

		// Optional measure numbers are redrawn after spacing changes so they stay
		// attached to the current left edge of each measure.
		this.drawMeasureNumbers();
		
		S.attr({width:Math.max(width,dis.DB.width+25)});
	}

	var nprops = ['beat','iBeat','measure','dur','voice','name','staff','type'];
	var rprops = ['beat','dur','iBeat','measure','voice','type'];
	this.save = function() {
		var obj = JSON.parse(JSON.stringify(this.params));
		obj.melody = [];
		obj.type = this.type;
		for (var i=0; i<this.measures.length; i++) {
			obj.melody.push([]);
			for (var j=0; j<this.measures[i].obs.length; j++) {
				var ob = this.measures[i].obs[j];
				var nbj = {};
				if (ob.note) {
					for (var k=0; k<nprops.length; k++)
						nbj[nprops[k]] = ob[nprops[k]];
					if (ob.tied) nbj.tied = true;
				}
				if (ob.rest) {
					for (var k=0; k<rprops.length; k++)
						nbj[rprops[k]] = ob[rprops[k]];
				}
				obj.melody[i].push(nbj);
			}
		}
		return obj;
	}

	this.promptMelody = function() {
		var melody = [];
		var ary = [];
		var obs = this.measures[0].obs; //stuff in first measure
		var ob;
		var nbj;

		//find first note in measure
		var beat = obs[0].beat;
		var dur = 0;
		for (var i=0; i<obs.length; i++) {
			ob = obs[i];
			nbj = {};
			//if rest, put in
			if (ob.rest) {
				for (var k=0; k<rprops.length; k++)
					nbj[rprops[k]] = ob[rprops[k]];
				beat += rBeat(dis,nbj.dur);
				dur += rBeat(dis,nbj.dur);

				beat = quantBeat(beat);
				dur = quantBeat(dur);

				ary.push(nbj);
			}

			//if note, put in and stop
			if (ob.note) {
				for (var k=0; k<nprops.length; k++)
					nbj[nprops[k]] = ob[nprops[k]];
				beat += rBeat(dis,nbj.dur);
				dur += rBeat(dis,nbj.dur);

				beat = quantBeat(beat);
				dur = quantBeat(dur);

				ary.push(nbj);
				i = 1000000;
			}
		}

		//check if has tuplet
		var tupTypes = ['s16','t8','t4','d4','d8','f8'];
		var hasT = false;
		for (var i=0; i<ary.length; i++) {
			if (tupTypes.indexOf(ary[i].dur)!=-1) {
				hasT = true; //has a tuplet
			}
		}
		if (hasT) { //if we has tuplet, fill with rests to next integer beat, track dur
			var beatRemain = quantBeat(1 - (beat-Math.floor(beat)));
			var iBeat = ary.length-1;
			var lastNote = ary[iBeat];
			if (beatRemain<1) {
				while(beatRemain>0) {
					nbj = {type:'rest',dur:lastNote.dur,beat:beat,iBeat:iBeat,voice:ary[0].voice,measure:0};
					beat += rBeat(dis,lastNote.dur);
					dur += rBeat(dis,lastNote.dur);
					beatRemain -= rBeat(dis,lastNote.dur);

					beat = quantBeat(beat);
					dur = quantBeat(dur);
					beatRemain = quantBeat(beatRemain);
					ary.push(nbj);
				}
			}
		}

		var remainder = findRemainder(this.measures[0].duration-dur);
		var iBeat = ary.length-1;
		var voice = ary[0].voice;
		for (var i=0; i<remainder.length; i++) {
			ary.push({beat:beat,iBeat:iBeat,measure:0,dur:remainder[i],voice:voice,type:'rest'});
			beat += rBeat(dis,remainder[i]);
			iBeat++;
		}

		melody.push(ary);

		if (this.measures.length==1) return melody;
		//all other measures are empty

		var fullMeasure = wholeMeasure();
		var mAry;
		for (var i=1; i<this.measures.length; i++) {
			beat = 1;
			mAry = [];

			if (this.params.pickup!=0) {
				if (i==this.measures.length-1) {
					var bts = parseInt(this.params.tsig.split('/')[0]) - this.params.pickup;
					var frm = findRemainder(bts);
					fullMeasure = [];
					for (var z=0; z<frm.length; z++) {
						fullMeasure.push(
							{dur:frm[z],name:'rest'}
						)
					}
				}
			}

			//get full measure, init
			for (var j=0; j<fullMeasure.length; j++) {
				mAry.push({beat:beat,iBeat:j,measure:i,dur:fullMeasure[j].dur,voice:voice,type:'rest'});
				beat += rBeat(dis,fullMeasure[j].dur);
			}

			melody.push(mAry);
		}

		return melody;
	}

	this.blankMelody = function() {
		var melody = [];

		var mAry;
		var pOff = 0;
		var beat, iBeat;
		var voice = this.measures[0].obs[0].voice;
		if (this.params.pickup!=0) {
			mAry = [];
			pOff = 1;
			beat = findBeatStart();
			var remainder = findRemainder(this.measures[0].duration);
			iBeat = 0;
			for (var i=0; i<remainder.length; i++) {
				mAry.push({beat:beat,iBeat:iBeat,measure:0,dur:remainder[i],voice:voice,type:'rest'});
				beat += rBeat(dis,remainder[i]);
				iBeat++;
			}

			melody.push(mAry);
		}

		var fullMeasure = wholeMeasure();
		for (var i=pOff; i<this.measures.length; i++) {
			beat = 1;
			mAry = [];

			if (this.params.pickup!=0) {
				if (i==this.measures.length-1) {
					var bts = parseInt(this.params.tsig.split('/')[0]) - this.params.pickup;
					var frm = findRemainder(bts);
					fullMeasure = [];
					for (var z=0; z<frm.length; z++) {
						fullMeasure.push(
							{dur:frm[z],name:'rest'}
						)
					}
				}
			}

			//get full measure, init
			for (var j=0; j<fullMeasure.length; j++) {
				mAry.push({beat:beat,iBeat:j,measure:i,dur:fullMeasure[j].dur,voice:voice,type:'rest'});
				beat += rBeat(dis,fullMeasure[j].dur);
			}

			melody.push(mAry);
		}

		return melody;
	}

	this.load = function(parameters) {
		this.loadMeasures(parameters);

		var melody = parameters.melody;
		var props = ['name','staff','type','tied'];
		//melody is array of measurebeats, change measurebeats to what's in melody
		this.removeRests();

		//load notes from the end, because they won't be affected by accidentals before them
		var mlen = this.measures.length-1;
		for (var i=mlen; i>-1; i--) {
			var oblen = this.measures[i].obs.length-1;
			for (var j=oblen; j>-1; j--) {
				
				//get name, staff, and type
				for (var k=0; k<props.length; k++) {
					if (!melody[i][j][props[k]]) continue;
					this.measures[i].obs[j][props[k]] = melody[i][j][props[k]];
				}

				if (this.measures[i].obs[j].type=='note') {
					this.placeNote(this.measures[i].obs[j],true);
				}
			}
		}

		//go through from beginning and update accidentals
		for (var i=0; i<this.measures.length; i++) {
			for (var j=0; j<this.measures[i].obs.length; j++) {
				if (this.measures[i].obs[j].type=='note') {
					//axeUpdate(this.measures[i].obs[j]);
				}
			}
		}

		this.recalculateDisplay();
		this.center();

		//draw ties
		for (var i=0; i<this.measures.length; i++) {
			for (var j=0; j<this.measures[i].obs.length; j++) {
				if (this.measures[i].obs[j].tied)
					handleTie(this,this.measures[i].obs[j]);
			}
		}

		if (this.params.keyText) {
            // Separate only the key token and mode. Descriptive text belongs
            // after the mode, rather than becoming part of the tonic name.
            var label = String(this.params.keyText).trim();
            var labelMatch = label.match(/^([A-Ga-g])([♯♭\u0231#b]{0,2})\s*(Major|minor)?(.*)$/i);
            var baseText = labelMatch ? labelMatch[1] : label;
            var axe = labelMatch ? labelMatch[2].replace(/#/g, '♯').replace(/b|♭/g, '\u0231') : '';
            var mode = labelMatch && labelMatch[3] ? ' ' + labelMatch[3] : '';
            var suffix = labelMatch ? labelMatch[4] : '';
            var keyText = this.whole.text(75, -25 - (this.params.keyTextOffset ? 10 : 0),
                [baseText, axe, mode, suffix]).attr({fontWeight: "bold", fontSize: "23px"});
            var accidentalSpan = keyText.select('tspan:nth-child(2)');
            if (accidentalSpan) accidentalSpan.attr({fontFamily: 'myFirstFont'});
		}	}
	
	//center it
	this.center = function() {
		var bb = this.whole.getBBox();
		var w = bb.width;
		var h = bb.height;
		var botMargin = 0;
		this.whole.transform('t0 '+(100+botMargin));
		
		S.attr('height',h+(botMargin));
	}

	var S;
	var g;
	var hnotes;
	var measures;
	var tsMargin;
	var nts, mids;
	var TIESMOVED;
	var THREESMOVED;
	this.initializeMeasures = function(parameters) {
		this.lnsp = 17.75;
		//keep params
		
		//parse pickup
		parameters.pickup = parseFloat(parameters.pickup);
		
		this.params = parameters;

		//make snap SVG paper - 100 width is just initial, will update down below
		document.getElementById(id).innerHTML = ''; //clear out what's in there
		S = makeSnap(id,100,500);
		this.paper = S;

		//main svg group
		g = S.group();
		this.whole = g;

		//initialize clef
		if (this.params.clef)
			drawClef(this,this.params.clef);
		
		hnotes = hnotes1;
		if (this.params.clef=='bass') hnotes = hnotes2;
		if (this.params.clef=='alto') hnotes = hnotes3;

		//key signature
		this.keyAx = [];
		drawKeySig(this,this.params.clef,this.params.key,this.params.mode);
		
		//time signature
		if (this.params.displayedTimeSig)
			drawTimeSignature(this,this.params.displayedTimeSig);
		else
			drawTimeSignature(this,this.params.tsig);

		this.moveTSIG();

		TIESMOVED = [];
		THREESMOVED = [];

		//INITIALIZE MEASURES
		//initialize measure array
		this.barlines = [];
		
		measures = [];
		//pickup here?
		var beatStart;
		var pickup;
		if (this.params.pickup) {
			this.pickup = findPickup(this,this.params.pickup); //get a blank pickup measure
			measures.push(this.pickup);
			beatStart = findBeatStart();//this.pickup,this.params.tsig);
		}
		var mAry;
		for (var i=0; i<this.params.length; i++) {
			mAry = wholeMeasure();
			measures.push(mAry);
		}
		
		//create measures
		tsMargin = 35;
		var x = this.timeRight()+tsMargin;
		var mbj;
		this.measures = [];
		var bstart;
		for (var i=0; i<measures.length; i++) {
			if (this.params.pickup) {
				if (i==0) bstart = beatStart;
				else bstart = 1;
			} else {
				bstart = 1;
			}

			mbj = new measureObj(measures[i],x,i,bstart);
			this.measures.push(mbj);
			
			x = mbj.right; //end of measure
			
			x+=barlineMARGIN;
		}

		switch(this.params.clef) {
			case 'treble':
				nts = ['F3','G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5','A5','B5','C6','D6','E6','F6']; //treble notes
				mids = [53,55,57,59,60,62,64,65,67,69,71,72,74,76,77,79,81,83,84,86,88,89];
				break;
			case 'bass':
				nts = ['A1','B1','C2','D2','E2','F2','G2','A2','B2','C3','D3','E3','F3','G3','A3','B3','C4','D4','E4','F4','G4','A4']; //bass notes
				mids = [33,35,36,38,40,41,43,45,47,48,50,52,53,55,57,59,60,62,64,65,67,69];
				break;
			case 'alto':
				nts = ['G2','A2','B2','C3','D3','E3','F3','G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5']; //bass notes
				mids = [43,45,47,48,50,52,53,55,57,59,60,62,64,65,67,69,71,72,74,76,77,79];
				break;
		}

		//put rectangle over it for interactivity
		this.interactiveMeasures();

		//rhythm palette
        DB = new DURbutton(0, 200, {
            durations: melodyPaletteDurations(dis.params, dis.authoring),
            tuplets: [],
                /*{
                label: "2",
                key: "8",
                appliesTo: ["8"],
                result: () => "d8",
                allowed: tsig => tsig.split("/")[1] === "8"
                },
                {
                label: "3",
                key: "9",
                appliesTo: ["8","4"],
                result: d => d === "8" ? "t8" : "t4",
                allowed: tsig => tsig.split("/")[1] !== "8"
                },
                {
                label: "4",
                key: "0",
                appliesTo: ["8"],
                result: () => "f8",
                allowed: tsig => tsig.split("/")[1] === "8"
                },
                {
                label: "6",
                key: "-",
                appliesTo: ["16"],
                result: () => "s16",
                allowed: tsig => tsig.split("/")[1] !== "8"
                }*/
            //],
            allowDotted: false,
            allowTie: false
            });

		//DB = new DURbutton(0,180);
		this.DB = DB;

		//recalculate x, cx, etc.
		this.recalculateDisplay();
		this.center();
	}

	this.loadMeasures = function(parameters) {
		this.lnsp = 17.75;
		//keep params
		
		//parse pickup
		parameters.pickup = parseFloat(parameters.pickup);
		
		this.params = parameters;

		var ary = this.params.melody;

		//make snap SVG paper - 100 width is just initial, will update down below
		document.getElementById(id).innerHTML = ''; //clear out what's in there
		S = makeSnap(id,100,500);
		this.paper = S;

		//main svg group
		g = S.group();
		this.whole = g;

		//initialize clef
		if (this.params.clef)
			drawClef(this,this.params.clef);
		
		hnotes = hnotes1;
		if (this.params.clef=='bass') hnotes = hnotes2;
		if (this.params.clef=='alto') hnotes = hnotes3;

		//key signature
		this.keyAx = [];
		drawKeySig(this,this.params.clef,this.params.key,this.params.mode);
		
		//time signature
		// if (!this.params.hideTimeSignature)
		if (this.params.displayedTimeSig)
			drawTimeSignature(this,this.params.displayedTimeSig);
		else
			drawTimeSignature(this,this.params.tsig);

		this.moveTSIG();

		TIESMOVED = [];
		THREESMOVED = [];

		this.barlines = [];

		//INITIALIZE MEASURES
		//initialize measure array
		
		measures = [];
		//pickup here?
		var beatStart;
		var poff = 0;
		if (this.params.pickup) {
			this.pickup = ary[0]; //get first measure stored in melody
			measures.push(this.pickup);
			beatStart = findBeatStart();//pickup,this.params.tsig);
			poff = 1;
		}
		var mAry;
		for (var i=0; i<this.params.length; i++) {
			mAry = ary[i+poff];
			measures.push(mAry);
		}
		
		//create measures
		tsMargin = 35;
		var x = this.timeRight()+tsMargin;
		var mbj;
		this.measures = [];
		var bstart;
		for (var i=0; i<measures.length; i++) {
			if (this.params.pickup) {
				if (i==0) bstart = beatStart;
				else bstart = 1;
			} else {
				bstart = 1;
			}

			mbj = new measureObj(measures[i],x,i,bstart);
			this.measures.push(mbj);
			
			x = mbj.right; //end of measure
			
			x+=barlineMARGIN;
		}

		switch(this.params.clef) {
			case 'treble':
				nts = ['F3','G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5','A5','B5','C6','D6','E6','F6']; //treble notes
				mids = [53,55,57,59,60,62,64,65,67,69,71,72,74,76,77,79,81,83,84,86,88,89];
				break;
			case 'bass':
				nts = ['A1','B1','C2','D2','E2','F2','G2','A2','B2','C3','D3','E3','F3','G3','A3','B3','C4','D4','E4','F4','G4','A4']; //bass notes
				mids = [33,35,36,38,40,41,43,45,47,48,50,52,53,55,57,59,60,62,64,65,67,69];
				break;
			case 'alto':
				nts = ['G2','A2','B2','C3','D3','E3','F3','G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5']; //bass notes
				mids = [43,45,47,48,50,52,53,55,57,59,60,62,64,65,67,69,71,72,74,76,77,79];
				break;
		}

		//put rectangle over it for interactivity
		this.interactiveMeasures();

		//rhythm palette
        DB = new DURbutton(0, 200, {
            durations: melodyPaletteDurations(dis.params, dis.authoring),
            tuplets: [],
                /*{
                label: "2",
                key: "8",
                appliesTo: ["8"],
                result: () => "d8",
                allowed: tsig => tsig.split("/")[1] === "8"
                },
                {
                label: "3",
                key: "9",
                appliesTo: ["8","4"],
                result: d => d === "8" ? "t8" : "t4",
                allowed: tsig => tsig.split("/")[1] !== "8"
                },
                {
                label: "4",
                key: "0",
                appliesTo: ["8"],
                result: () => "f8",
                allowed: tsig => tsig.split("/")[1] === "8"
                },
                {
                label: "6",
                key: "-",
                appliesTo: ["16"],
                result: () => "s16",
                allowed: tsig => tsig.split("/")[1] !== "8"
                }
            ],*/
            allowDotted: false,
            allowTie: false
            });

		//DB = new DURbutton(0,180);
		this.DB = DB;

		this.currentDUR = '4';
	}

	//this.initializeMeasures(this.params);
}

/* Functions and stuff */
function makeSnap(id,width,height) {
	var s = window.Snap(width,height);
	document.getElementById(id).appendChild(s.node);
	return s;
}

var drawClef = function(staff,clef) {
	removeClef(staff);
	switch(clef) {
		case 'treble':
			staff.staffClef = staff.whole.path(treblePath).attr({fill:'black'}).transform('t-290 -247 s0.07 -0.07');
			break;
		case 'bass':
			staff.staffClef = staff.whole.path(bassPath).attr({fill:'black'}).transform('t-290 152.3 s0.074 -0.074');
			break;
		case 'alto':
			staff.staffClef = staff.whole.path(altoPath).attr({fill:'black'}).transform('t-310 36 s0.071 -0.071');
			break;
		case 'rhythm':
			var lnsp = 17.75;
			var l1 = staff.whole.rect(0,lnsp,8,2*lnsp);
			var l2 = staff.whole.rect(12,lnsp,8,2*lnsp);
			staff.staffClef = staff.whole.group(l1,l2);
			staff.staffClef.transform('t8 0');
			break;
		default:
			staff.staffClef = staff.whole.path(treblePath).attr({fill:'black'}).transform('t-290 -247 s0.07 -0.07');
			break;
	}
	staff.clef = clef;

	//accessibility
	//staff.staffClef.node.tabIndex = "0";
	//staff.staffClef.node.ariaLabel = "clef, "+clef;
}
var removeClef = function(staff) {
	if (staff.staffClef) staff.staffClef.remove();
	staff.staffClef = null;
}

//KEY SIG
var drawKeySig = function(staff,clef,key,scale) {
	var lnsp = 17.75;
	key = key.replace('♭','\u0231');
	
	for (var i=0; i<staff.keyAx.length; i++)
		staff.keyAx[i].remove();
	var ks = keySig(key,scale);
	var sig = ks[0];
	staff.staffKeySig = sig;
	var type = ks[1];
	var base = 14*lnsp/2;
	var trebYs = [base-7*lnsp,base-5.5*lnsp,base-7.5*lnsp,base-6*lnsp,base-4.5*lnsp,base-6.5*lnsp,base-5*lnsp];
	var bassYs = [base-6*lnsp,base-4.5*lnsp,base-6.5*lnsp,base-5*lnsp,base-3.5*lnsp,base-5.5*lnsp,base-4*lnsp];
	var altoYs = [base-6.5*lnsp,base-5*lnsp,base-7*lnsp,base-5.5*lnsp,base-4*lnsp,base-6*lnsp,base-4.5*lnsp];
	var trebYf = [base-5*lnsp,base-6.5*lnsp,base-4.5*lnsp,base-6*lnsp,base-4*lnsp,base-5.5*lnsp,base-3.5*lnsp];
	var bassYf = [base-4*lnsp,base-5.5*lnsp,base-3.5*lnsp,base-5*lnsp,base-3*lnsp,base-4.5*lnsp,base-2.5*lnsp];
	var altoYf = [base-4.5*lnsp,base-6*lnsp,base-4*lnsp,base-5.5*lnsp,base-3.5*lnsp,base-5*lnsp,base-3*lnsp];
	
	var ax = [];
	if (type=='sharp') {
		if (clef=='treble')
			ax = trebYs;
		if (clef=='bass')
			ax = bassYs;
		if (clef=='alto')
			ax = altoYs;
	} else {
		if (clef=='treble')
			ax = trebYf;
		if (clef=='bass')
			ax = bassYf;
		if (clef=='alto')
			ax = altoYf;
	}
	staff.KSIGDX = sig.length*18;
	drawKeyAx(staff,type,ax,sig);
}

var drawTimeSignature = function(staff,ts) {
	staff.timeSignature = new timeSignature(staff,ts);

	if (staff.params.hideTimeSignature) staff.timeSignature.attr({opacity:0});
}

function timeSignature(staff,ts,rhythmTog) {
	var S = staff.whole;
	var t1, t2;
	var m = 40; //numspace
	var sp = 225; //staffspace
	var ofs = 80;
	var x=0;
	switch(ts) {
		case "common":
			this.t1 = S.path(commonPath).transform('t'+x+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(commonPath).transform('t'+x+' '+(-ofs)+' s0.081 -0.081').attr({display:'none'});
			break;
		case "7/4":
			this.t1 = S.path(sevenPath).transform('t'+(x+22)+' '+(2-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "6/4":
			this.t1 = S.path(sixPath).transform('t'+(x+28)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "5/4":
			this.t1 = S.path(fivePath).transform('t'+(x+25)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "4/4":
			this.t1 = S.path(fourPath).transform('t'+x+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "25/4":
			this.t1 = S.path(fourPath).transform('t'+x+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "3/4":
			this.t1 = S.path(threePath).transform('t'+(x+34)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "2/4":
			this.t1 = S.path(twoPath).transform('t'+(x+15)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(fourPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "3/8":
			x+=12;
			this.t1 = S.path(threePath).transform('t'+(x+20)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(eightPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "6/8":
			x+=12;
			this.t1 = S.path(sixPath).transform('t'+(x+15)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(eightPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "7/8":
			x+=12;
			this.t1 = S.path(sevenPath).transform('t'+(x+10)+' '+(2-ofs)+' s0.081 -0.081');
			this.t2 = S.path(eightPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "9/8":
			x+=12;
			this.t1 = S.path(ninePath).transform('t'+(x+15)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(eightPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "12/8":
			x+=18;
			this.t1a = S.path(onePath).transform('t'+(x+15)+' '+(-ofs)+' s0.081 -0.081');
			this.t1b = S.path(twoPath).transform('t'+(x+15)+' '+(-ofs)+' s0.081 -0.081');
			this.t1 = S.group(this.t1a,this.t1b);
			this.t2 = S.path(eightPath).transform('t'+x+' '+(m-ofs)+' s0.081 -0.081');
			break;
		case "6/16":
			x+=18;
			this.t1a = S.path(onePath).transform('t'+(x+5)+' '+(m-ofs)+' s0.081 -0.081');
			this.t1b = S.path(sixPath).transform('t'+(x+15)+' '+(m-ofs+1)+' s0.081 -0.081');
			this.t1 = S.group(this.t1a,this.t1b);
			this.t2 = S.path(sixPath).transform('t'+(x+5)+' '+(-ofs)+' s0.081 -0.081');
			break;
		case "2/2":
			this.t1 = S.path(twoPath).transform('t'+(x+15)+' '+(-ofs)+' s0.081 -0.081');
			this.t2 = S.path(twoPath).transform('t'+(x+15)+' '+(40-ofs)+' s0.081 -0.081');
			break;
		case "3/2":
			x+=14;
			this.t1 = S.path(threePath).transform('t'+(x+18)+' '+(0.5-ofs)+' s0.081 -0.081');
			this.t2 = S.path(twoPath).transform('t'+(x+1)+' '+(40.5-ofs)+' s0.081 -0.081');
			break;
		case "4/2":
			x+=14;
			this.t1 = S.path(fourPath).transform('t'+(x-16)+' '+(m-ofs-39.5)+' s0.081 -0.081');
			this.t2 = S.path(twoPath).transform('t'+(x+1)+' '+(40.5-ofs)+' s0.081 -0.081');
			break;
	}
	this.whole = S.group(this.t1,this.t2);

	//this.whole.node.tabIndex = "0";
	//this.whole.node.ariaLabel = "Time signature, "+parseInt(ts.split('/')[0])+", "+parseInt(ts.split('/')[1]);
	
	this.whole.transform('t-150 -155 s0.88');
	return this.whole;
}

var drawKeyAx = function(staff,type,ax,sig) {
	var S = staff.paper;
	var axe;
	var dx = 18;
	switch(type) {
		case 'sharp':
			for (var i=0; i<sig.length; i++) {
				axe = S.path(sharpPath).transform('t'+(dx*i-65)+' '+ax[i]+' s0.062 -0.062');
				staff.whole.append(axe);
				staff.keyAx.push(axe);
				axe.name = sig[i];
			}
			break;
		case 'flat':
			for (var i=0; i<sig.length; i++) {
				axe = S.path(flatPath).transform('t'+(dx*i-15)+' '+(ax[i]-160.5)+' s0.062 -0.062');
				staff.whole.append(axe);
				staff.keyAx.push(axe);
				axe.name = sig[i];
			}
			break;
	}
}

function keySig(key,mode) {
	if (mode.toLowerCase().indexOf('minor')!=-1) key = key[0].toLowerCase() + key.slice(1);
    var sig=[];
    var type;
    switch(key) {
        case "C":
			type='';
            break;
        case "a":
			type='';
			break;
        case "G":
            sig=["F♯"];
            break;
        case "e":
			sig=["F♯"];
			break;
        case "D":
            sig=["F♯","C♯"];
            break;
        case "b":
			sig=["F♯","C♯"];
			break;            
        case "A":
            sig=["F♯","C♯","G♯"];
            break;
        case "f♯":
			sig=["F♯","C♯","G♯"];
			break;             
        case "E":
            sig=["F♯","C♯","G♯","D♯"];
            break;
        case "c♯":
			sig=["F♯","C♯","G♯","D♯"];
			break;            
        case "B":
            sig=["F♯","C♯","G♯","D♯","A♯"];
            break;
        case "g♯":
			sig=["F♯","C♯","G♯","D♯","A♯"];
			break;            
        case "F♯":
            sig=["F♯","C♯","G♯","D♯","A♯","E♯"];
            break;
        case "d♯":
            sig=["F♯","C♯","G♯","D♯","A♯","E♯"];
            break;
        case "C♯":
            sig=["F♯","C♯","G♯","D♯","A♯","E♯","B♯"];
            break;
        case "a♯":
			sig=["F♯","C♯","G♯","D♯","A♯","E♯","B♯"];
            break;
        case "F":
            sig=["B\u0231"];
            break;
        case "d":
			sig=["B\u0231"];
			break;            
        case "B\u0231":
            sig=["B\u0231","E\u0231"];
            break;
        case "g":
			sig=["B\u0231","E\u0231"];
			break;            
        case "E\u0231":
            sig=["B\u0231","E\u0231","A\u0231"];
            break;
        case "c":
			sig=["B\u0231","E\u0231","A\u0231"];
			break;
        case "A\u0231":
            sig=["B\u0231","E\u0231","A\u0231","D\u0231"];
            break;
        case "f":
			sig=["B\u0231","E\u0231","A\u0231","D\u0231"];
			break;            
        case "D\u0231":
            sig=["B\u0231","E\u0231","A\u0231","D\u0231","G\u0231"];
            break;
        case "b\u0231":
			sig=["B\u0231","E\u0231","A\u0231","D\u0231","G\u0231"];
			break;            
        case "G\u0231":
            sig=["B\u0231","E\u0231","A\u0231","D\u0231","G\u0231","C\u0231"];
            break;
        case "e\u0231":
			sig=["B\u0231","E\u0231","A\u0231","D\u0231","G\u0231","C\u0231"];
			break;            
        case "C\u0231":
            sig=["B\u0231","E\u0231","A\u0231","D\u0231","G\u0231","C\u0231","F\u0231"];
            break;
        case "a\u0231":
            sig=["B\u0231","E\u0231","A\u0231","D\u0231","G\u0231","C\u0231","F\u0231"];
            break;
    }
    if (sig.indexOf("F♯")!=-1)
		type='sharp';
	if (sig.indexOf("B\u0231")!=-1)
		type='flat';
    return [sig,type];
}

function handleTrans(t,e,dx,dy) { //for safari bullshit
	if (!t) {
		e.node.setAttribute('transform','translate('+dx+', '+dy+')');
		return;
	}
	if (t.indexOf('matrix')!=-1) {
		var ary = t.split(',');
		var txt = ary[0]+','+ary[1]+','+ary[2]+','+ary[3]+','+(parseFloat(ary[4])+dx)+','+(parseFloat(ary[5].replace(')',''))+dy)+')';
		e.node.setAttribute('transform',txt);
	}
	if (t.indexOf('translate')!=-1) {
		var ary = t.split(',');
		var x = parseFloat(ary[0].replace('translate(',''))+dx;
		var y = parseFloat(ary[1].replace(' ','').replace(')',''))+dy;
		e.node.setAttribute('transform','translate('+x+', '+y+')');
	}
}

function moveEle(e, dx, dy) {
	if (navigator.platform.indexOf('Mac')!=-1) {
		var t = e.node.getAttribute('transform');
		handleTrans(t,e,dx,dy);
	} else {
		if (e.node.transform.baseVal[0]) {
			e.node.transform.baseVal[0].matrix.e += dx;
			e.node.transform.baseVal[0].matrix.f += dy;
		} else {
			e.transform('t'+dx+' '+dy);
		}
	}
}

function paletteRhythm(staff,type,x,y) {
	var S = staff.paper;
	var svg=S.group();
	var note1, note2;
	var sdx = 2.2;
	var sdy = 3.2;
	var stemW = 2;
	var stemH = 50;
	if (!y)
		var y=215;
	//type = '3t';
	switch(type) {
		case '1z':
			note1 = S.path(closedPath).transform('t'+(x)+' '+y+' s0.07 -0.07');
			svg.append(note1);
			
			var flag = S.path(thirtyTwoFlagPath).transform('t'+(x+85.5)+' '+(y+509)+' s0.07 -0.07')
			svg.append(flag);
			
			var bb = note1.getBBox();
			var stem = S.rect(bb.x+bb.width-sdx,bb.y-stemH+sdy,stemW,stemH);
			svg.append(stem);
			break;
		case '1s':
			note1 = S.path(closedPath).transform('t'+(x)+' '+y+' s0.07 -0.07');
			svg.append(note1);
			
			var flag = S.path(sixFlagPath).transform('t'+(x+85.5)+' '+(y+413)+' s0.07 -0.07')
			svg.append(flag);
			
			var bb = note1.getBBox();
			var stem = S.rect(bb.x+bb.width-sdx,bb.y-stemH+sdy,stemW,stemH);
			svg.append(stem);
			break;
		case '1de':
		case '1e':
			var flag = S.path(eighthFlagPath).transform('t'+(x+53.5)+' '+(y-381)+' s0.07 0.07');
			svg.append(flag);
			var note = S.path(closedPath).transform('t'+(x-4)+' '+(y)+' s0.07 -0.07');
			svg.append(note);
			var bb = note.getBBox();
			var stem = S.rect(bb.x+bb.width-sdx,bb.y-stemH+sdy,stemW,stemH);
			svg.append(stem);
			if (type === '1de') svg.append(S.circle(bb.x + bb.width + 9, bb.y + bb.height / 2, 3));
			//qsvg=S.group(note,flag,stem);
			//dis.whole.append(qsvg);
			break;
		case '1dq':
		case '1q':
			note1 = S.path(closedPath).transform('t'+(x)+' '+y+' s0.07 -0.07');
			svg.append(note1);
			var bb = note1.getBBox();
			var stem = S.rect(bb.x+bb.width-sdx,bb.y-stemH+sdy,stemW,stemH);
			svg.append(stem);
			if (type === '1dq') svg.append(S.circle(bb.x + bb.width + 9, bb.y + bb.height / 2, 3));
			break;
		case '1h':
			note1 = S.path(openPath).transform('t'+(x-9)+' '+y+' s0.07 -0.07');
			svg.append(note1);
			var bb = note1.getBBox();
			var stem = S.rect(bb.x+bb.width-sdx,bb.y-stemH+sdy,stemW,stemH);
			svg.append(stem);
			break;
		case '1dh':
			note1 = S.path(openPath).transform('t'+(x-9)+' '+y+' s0.07 -0.07');
			svg.append(note1);
			var bb = note1.getBBox();
			var stem = S.rect(bb.x+bb.width-sdx,bb.y-stemH+sdy,stemW,stemH);
			svg.append(stem);
			var dot = S.circle(x+185,y,3,3);
			svg.append(dot);
			break;
		case '1w':
			var note = S.path(wholePath).transform('t'+(x-81.5)+' '+(y-11)+' s0.068 -0.068');
			svg.append(note);
			break;
	}
	return svg;
}

function genTie(paper,x1,y1,x2,y2,dir) {
	var first_x_px;
	var last_x_px;
	var first_ys;
	var last_ys;
	var stem_direction;
	
	first_x_px = x1;
	stem_direction = dir;
	first_ys = y1;

	last_x_px = x2;
	stem_direction = dir;
	last_ys = y2;

	var path = renderTie({
	  first_x_px,
	  last_x_px,
	  first_ys,
	  last_ys,
	  direction: stem_direction,
	  cp1: 8,
	  cp2: 12
	});
	
	var tie = paper.path(path);
	tie.transform('t0 5');
	
	return tie;
}

function drawTie(paper,n1,n2,dir) {
	var x1 = n1.x + n1.width/2;
	
	var x2 = n2.x + n2.width/2;
	
	var first_x_px;
	var last_x_px;
	var first_ys;
	var last_ys;
	var stem_direction;
	if (n1) {
	  first_x_px = x1+2;
	  stem_direction = dir;
	  first_ys = n1.y;
	}

	if (n2) {
	  last_x_px = x2-2;
	  stem_direction = dir;
	  last_ys = n2.y;
	}

	var path = renderTie({
	  first_x_px,
	  last_x_px,
	  first_ys,
	  last_ys,
	  direction: stem_direction
	});
	
	var tie = paper.path(path);
	tie.transform('t0 '+(dir*5));
	
	return tie;
}

function renderTie(params) {
	var render_options = {
	  cp1: params.cp1 ? params.cp1 : 21,      // Curve control point 1
	  cp2: params.cp2 ? params.cp2 : 26,      // Curve control point 2
	  text_shift_x: 0,
	  first_x_shift: 0,
	  last_x_shift: 0,
	  y_shift: 7,
	  tie_spacing: 0
	};

	var cp1 = render_options.cp1;
	var cp2 = render_options.cp2;

	if (Math.abs(params.last_x_px - params.first_x_px) < 10) {
	  cp1 = 2; cp2 = 8;
	}

	var first_x_shift = render_options.first_x_shift;
	var last_x_shift = render_options.last_x_shift;
	var y_shift = render_options.y_shift * params.direction;

	//for (var i = 0; i < 1; i++) {
	var cp_x = ((params.last_x_px + last_x_shift) +
	  (params.first_x_px + first_x_shift)) / 2;
	var first_y_px = params.first_ys + y_shift;
	var last_y_px = params.last_ys + y_shift;

	var top_cp_y = ((first_y_px + last_y_px) / 2) + (cp1 * params.direction);
	var bottom_cp_y = ((first_y_px + last_y_px) / 2) + (cp2 * params.direction);
	
	var path = "M"+params.first_x_px+','+first_y_px+' Q'+cp_x+','+top_cp_y+' '+params.last_x_px+','+last_y_px+' Q'+cp_x+','+bottom_cp_y+' '+params.first_x_px+','+first_y_px;
	return path;

	console.log(cp_x);
	console.log(top_cp_y);
	console.log(bottom_cp_y);
	  /*ctx.beginPath();
	  ctx.moveTo(params.first_x_px + first_x_shift, first_y_px);
	  ctx.quadraticCurveTo(cp_x, top_cp_y, params.last_x_px + last_x_shift, last_y_px);
	  ctx.quadraticCurveTo(cp_x, bottom_cp_y, params.first_x_px + first_x_shift, first_y_px);
	  ctx.closePath();
	  ctx.fill();*/
	//}
}

function rBeat(staff,type) {
	var tsig = staff.params.tsig;
	var fac = 1;
	if (tsig.indexOf('/8')!=-1)
		fac = 2;
	if (tsig.indexOf('/2')!=-1)
		fac = 0.5;
	if (tsig.indexOf('/16')!=-1)
		fac = 4;
	type = type.replace('r','');
	switch(type) {
		case '64':
			return fac*0.0625;
			break;
		case '32':
			return fac*0.125;
			break;
		case '16':
			return fac*0.25;
			break;
		case 'v16':
			return fac*0.143;
			break;
		case 'q16':
			return fac*0.2;
			break;
		case 's16':
			return fac*0.166;
			break;
		case 't16':
			return fac*0.166;
			break;
		case '16.':
			return fac*0.375;
			break;
		case '8':
			return fac*0.5;
			break;
		case '8.':
			return fac*0.75;
			break;
		case 't8':
			return fac*0.333;
			break;
		case 't4':
			return fac*0.666;
			break;
		case 'd8':
			return fac*0.75;
			break;
		case 'd4':
			return fac*1.5;
			break;
		case 'f8':
			return fac*0.375;
			break;
		case '4':
			return fac*1;
			break;
		case '2':
			return fac*2;
			break;
		case '4.':
			return fac*1.5;
			break;
		case '2.':
			return fac*3;
			break;
		case '1':
			return fac*4;
			break;
		case '1.':
			return fac*6;
			break;
	}
}

function quantBeat(b) {
	var quants = [0,0.083,0.125,0.143,0.166,0.2,0.25,0.286,0.333,0.375,0.4,0.416,0.429,0.5,0.572,0.583,0.6,0.625,0.666,0.715,0.75,0.8,0.833,0.858,0.875,0.916,1];
	//var quants = [0.083,0.125,0.143,0.166,0.25,0.333,0.375,0.416,0.5,0.583,0.666,0.75,0.833,0.916,1];
	var base = 0.083;
	
	var tol = 0.01;
	for (var i=0; i<quants.length; i++) {
		if (Math.abs( b - (Math.floor(b)+quants[i]) ) < tol)
			b = Math.floor(b) + quants[i];
	}
	
	return b;
}

function numToDur(staff,num) {
	console.log(num);
	var fac = 1;
	var ts = staff.params.tsig;
	if (ts.indexOf('/16')!=-1)
		fac = 4;
	if (ts.indexOf('/8')!=-1)
		fac = 2;
	if (ts.indexOf('/2')!=-1)
		fac = 0.5;
	num = num/fac;
	num = quantBeat(num);
	switch(num) {
		case 0.125:
			return '32';
			break;
		case 0.143:
			return 'v16';
			break;
		case 0.166:
			return 's16';
			break;
		case 0.2:
			return 'q16';
			break;
		case 0.25:
			return '16';
			break;
		case 0.333:
			return 't8';
			break;
		case 0.375:
			return '16.';
			break;
		case 0.5:
			return '8';
			break;
		case 0.625:
			return '32,8';
			break;
		case 0.666:
			return 't4';
			break;
		case 0.75:
			return '8.';
			break;
		case 0.875:
			return '32,8.';
			break;
		case 1:
			return '4';
			break;
		case 1.125:
			return '32,4';
			break;
		case 1.25:
			return '16,4';
			break;
		case 1.5:
			return '4.';
			break;
		case 1.75:
			return '8.,4';
			break;
		case 1.875:
			return '16.,8,4';
			break;
		case 2:
			return '2';
			break;
		case 2.125:
			return '32,2';
			break;
		case 2.25:
			return '16,2';
			break;
		case 2.5:
			return '8,8,4.';
			break;
		case 2.75:
			return '8.,2';
			break;
		case 2.875:
			return '16.,8,2';
			break;
		case 3:
			return '2.';
			break;
		case 3.125:
			return '32,2.';
			break;
		case 3.25:
			return '16,2.';
			break;
		case 3.5:
			return '8,2.';
			break;
		case 3.75:
			return '8.,2.';
			break;
		case 3.875:
			return '16.,8,2.';
			break;
		case 4:
			return '1';
			break;
		case 4.125:
			return '32,1';
			break;
		case 4.25:
			return '16,1';
			break;
		case 4.5:
			return '8,1';
			break;
		case 4.75:
			return '8.,1';
			break;
		case 4.875:
			return '16.,8,1';
			break;
		case 5:
			return '4,1';
			break;
		case 5.125:
			return '32,4,1';
			break;
		case 5.25:
			return '16,4,1';
			break;
		case 5.5:
			return '8,4,1';
			break;
		case 5.75:
			return '8.,4,1';
			break;
		case 5.875:
			return '16.,8,4,1';
			break;
	}
}

function retDur(dur) {
	switch(dur) {
		case '1':
			return '1';
			break;
		case '1.':
			return '1.';
			break;
		case '2':
			return '2';
			break;
		case '4':
			return '4';
			break;
		case '2.':
			return '2.';
			break;
		case '4.':
			return '4.';
			break;
		case '8':
			return '8';
			break;
		case '8.':
			return '8.';
			break;
		case '16':
			return '16';
			break;
		case '16.':
			return '16.';
			break;
		case '32':
			return '32';
			break;
		case 'q16':
			return 'q16';
			break;
		case 'v16':
			return 'v16';
			break;
		case 's16':
			return 's16';
			break;
		case 'f8':
			return 'f8';
			break;
		case 'd8':
			return 'd8';
			break;
		case 't8':
			return 't8';
			break;
		case 't4':
			return 't4';
			break;
		case 'd4':
			return 'd4';
			break;
	}
}

function newX(dur) {
	dur = dur.replace('r','');
	switch(dur) {
		case '1':
			return 70;
			break;
		case '1.':
			return 70;
			break;
		case '2':
			return 45;
			break;
		case '4':
			return 25;
			break;
		case 't4':
			return 25;
			break;
		case 'd4':
			return 50;
			break;
		case '2.':
			return 55;
			break;
		case '4.':
			return 70;
			break;
		case '8':
			return 27;
			break;
		case 'd8':
			return 45;
			break;
		case '8.':
			return 35;
			break;
		case '16':
			return 20;
			break;
		case '16.':
			return 28;
			break;
		case '32':
			return 15;
			break;
		case 's16':
			return 15;
			break;
		case 'v16':
			return 14;
			break;
		case 'q16':
			return 18;
			break;
		case 't8':
			return 15;
			break;
		case 'f8':
			return 15;
			break;
		default:
			return 30;
			break;
	}
}

function noteW(dur) {
	dur = dur.replace('r','');
	switch(dur) {
		case '1':
			return 42.5;
			break;
		case '1.':
			return 42.5;
			break;
		case '2':
			return 42.5;
			break;
		case '4':
			return 32.5;
			break;
		case 't4':
			return 27.5;
			break;
		case 'd4':
			return 27.5;
			break;
		case '2.':
			return 42.5;
			break;
		case '4.':
			return 42.5;
			break;
		case '8':
			return 20;
			break;
		case 'd8':
			return 20;
			break;
		case '8.':
			return 25;
			break;
		case '16':
			return 20;
			break;
		case '16.':
			return 25;
			break;
		case '32':
			return 15;
			break;
		case 's16':
			return 15;
			break;
		case 'v16':
			return 14;
			break;
		case 'q16':
			return 18;
			break;
		case 't8':
			return 25;
			break;
		case 'f8':
			return 15;
			break;
		default:
			return 42.5;
			break;
	}
}

var drawStaffLines = function(staff,width,endType,connector) {
	if (staff.lines) {
		for (var i=0; i<staff.lines.length; i++)
			staff.lines[i].remove();
	}
	if (staff.endLineGroup) staff.endLineGroup.remove();
	staff.lines = [];
	staff.lnsp = 17.75;
	var r;
	for (var i=0; i<5; i++) {
		if (endType=='rhythm') {
			if (i!=2) continue;
		}
		r = staff.whole.rect(0,i*staff.lnsp,width,1);
		staff.lines.push(r);
		staff.whole.prepend(r);
	}
	//end lines
	var barlineGroup = staff.whole.group();
	if (!endType) {
		r = staff.whole.rect(width-15,0,3,4*staff.lnsp);
		staff.lines.push(r);
		barlineGroup.append(r);
		
		r = staff.whole.rect(width-8,0,8,4*staff.lnsp);
		staff.lines.push(r);
		barlineGroup.append(r);

		staff.whole.prepend(barlineGroup);
	} else {
		switch(endType) {
			case 'bar':
				r = staff.whole.rect(width-1.2,0,1.2,4*staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);

				staff.whole.prepend(barlineGroup);

				if (connector) {
					staff.whole.prepend(staff.whole.rect(width-1.2,0,1.2,12*staff.lnsp))
				}
				break;
			case '|':
				r = staff.whole.rect(width-1.2,0,1.2,4*staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);

				staff.whole.prepend(barlineGroup);

				if (connector) {
					staff.whole.prepend(staff.whole.rect(width-1.2,0,1.2,12*staff.lnsp))
				}
				break;
			case '- - -':
				r = staff.whole.line(width-1.2,0,width-1.2,4*staff.lnsp).attr({stroke:'black',strokeWidth:1,strokeDasharray:'4',opacity:0.2});
				barlineGroup.append(r);
				staff.lines.push(r);

				staff.whole.prepend(barlineGroup);

				if (connector) {
					staff.whole.prepend(staff.whole.line(width-1.2,0,width-1.2,12*staff.lnsp).attr({stroke:'black',strokeWidth:1,strokeDasharray:'4',opacity:0.2}))
				}
				break;
			case 'double-thin':
				r = staff.whole.rect(width-7.2,0,1.2,4*staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);
				
				r = staff.whole.rect(width-1.2,0,1.2,4*staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);

				staff.whole.prepend(barlineGroup);
				break;
			case '||':
				r = staff.whole.rect(width-7.2,0,1.2,4*staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);
				
				r = staff.whole.rect(width-1.2,0,1.2,4*staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);

				staff.whole.prepend(barlineGroup);
				break;
			case 'grand':
				r = staff.whole.rect(width-15,0,3,8*staff.lnsp+staff.staffSpace);
				staff.lines.push(r);
				barlineGroup.append(r);
				
				r = staff.whole.rect(width-8,0,8,8*staff.lnsp+staff.staffSpace);
				staff.lines.push(r);
				barlineGroup.append(r);
				
				staff.whole.prepend(barlineGroup);
				break;
			case "grand-||":
				r = staff.whole.rect(width - 7.2, 0, 1.2, 12 * staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);
		
				r = staff.whole.rect(width - 1.2, 0, 1.2, 12 * staff.lnsp);
				barlineGroup.append(r);
				staff.lines.push(r);
		
				staff.whole.prepend(barlineGroup);
				break;
			case 'none':
				break;
			case 'rhythm':
				var lnsp = 17.75;
				var l1 = staff.whole.rect(width-15,lnsp,3,2*lnsp);
				var l2 = staff.whole.rect(width-8,lnsp,8,2*lnsp);
				barlineGroup.append(l1);
				barlineGroup.append(l2);
				staff.whole.prepend(barlineGroup);
				staff.lines.push(l1);
				staff.lines.push(l2);
				break;
		}
	}

	/*if (barlineGroup) {
		staff.endLineGroup = barlineGroup;
		barlineGroup.node.tabIndex = "0";
		barlineGroup.node.ariaLabel = "Bar line, end of piece";
	}*/
}

function copyAry(ary) {
	var nAry=[];
	for (var i=0; i<ary.length; i++)
		nAry.push(ary[i]);
	return nAry;
}

function drawRest(staff,S,mb,meas,topbot,rop,partwriting) {
	var svg = S.group();
	var ele;
	var x = mb.x;
	var y;
	var dur = mb.dur ? mb.dur.replace('r','') : '4';
	var vc = mb.vc;
	switch(dur) {
		case '4':
			y = 17.75*4;
			if (partwriting) {
				if (vc=='t') y-=2*17.75;
				if (vc=='b') y+=2*17.75;
			}
			ele = S.path(quarterRestPath).transform('t'+(x-100)+' '+(y-75)+' s0.07 -0.07');
			svg.append(ele);
			break;
		case '4.':
			y = 17.75*4;
			ele = S.path(quarterRestPath).transform('t'+(x-100)+' '+(y-75)+' s0.07 -0.07');
			var dot = S.circle(x+28,y-44,3.5);
			svg.append(dot);
			svg.append(ele);
			break;
		case '8':
			y = 17.75*4;
			ele = S.path(eighthRestPath).transform('t'+(x-113)+' '+(y-9.75)+' s0.06 -0.06');
			svg.append(ele);
			break;
		case '8.':
			y = 17.75*4;
			ele = S.path(eighthRestPath).transform('t'+(x-113)+' '+(y-9.75)+' s0.06 -0.06');
			var dot = S.circle(x+28,y-44,3.5);
			svg.append(dot);
			svg.append(ele);
			break;
		case '32':
			y = 17.75*3;
			ele = S.path(thirtyTwoRestPath).transform('t'+(x-128)+' '+(y-3)+' s0.06 -0.06');
			svg.append(ele);
			break;
		case '16':
			y = 17.75*3;
			ele = S.path(sixteenthRestPath).transform('t'+(x-128)+' '+(y+126)+' s0.06 -0.06');
			svg.append(ele);
			break;
		case '16.':
			y = 17.75*3;
			ele = S.path(sixteenthRestPath).transform('t'+(x-128)+' '+(y+126)+' s0.06 -0.06');
			var dot = S.circle(x+28,y-44,3.5);
			svg.append(dot);
			svg.append(ele);
			break;
		case 'q16':
			y = 17.75*3;
			ele = S.path(sixteenthRestPath).transform('t'+(x-128)+' '+(y+126)+' s0.06 -0.06');
			var t3 = S.text(x+10,y-56.5,'5').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 'v16':
			y = 17.75*3;
			ele = S.path(sixteenthRestPath).transform('t'+(x-128)+' '+(y+126)+' s0.06 -0.06');
			var t3 = S.text(x+10,y-56.5,'7').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 's16':
			y = 17.75*3;
			ele = S.path(sixteenthRestPath).transform('t'+(x-128)+' '+(y+126)+' s0.06 -0.06');
			var t3 = S.text(x+10,y-56.5,'6').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 't8':
			y = 17.75*4;
			ele = S.path(eighthRestPath).transform('t'+(x-113)+' '+(y-9.75)+' s0.06 -0.06');
			var t3 = S.text(x+10,y-56.5,'3').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 'd8':
			y = 17.75*4;
			ele = S.path(eighthRestPath).transform('t'+(x-113)+' '+(y-9.75)+' s0.06 -0.06');
			var t3 = S.text(x+10,y-56.5,'2').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 'f8':
			y = 17.75*4;
			ele = S.path(eighthRestPath).transform('t'+(x-113)+' '+(y-9.75)+' s0.06 -0.06');
			var t3 = S.text(x+10,y-56.5,'4').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 't4':
			y = 17.75*4;
			ele = S.path(quarterRestPath).transform('t'+(x-100)+' '+(y-75)+' s0.07 -0.07');
			var t3 = S.text(x+10,y-56.5,'3').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case 'd4':
			y = 17.75*4;
			ele = S.path(quarterRestPath).transform('t'+(x-100)+' '+(y-75)+' s0.07 -0.07');
			var t3 = S.text(x+10,y-56.5,'2').attr({fontStyle:'italic'});
			svg.append(t3);
			svg.append(ele);
			break;
		case '2':
			y = 17.75*2;
			ele = S.path(halfRestPath).transform('t'+(x-176)+' '+(y-83.5)+' s0.07 -0.07');
			svg.append(ele);
			break;
		case '2.':
			y = 17.75 * 2;

			// Full-measure rest in 3/4 uses whole-rest symbol
			if (staff.params.tsig === '3/4') {
				if (staff.type !== 'rhythm') y -= 17.75;
				ele = S.path(wholeRestPath)
					.transform('t'+(x-177)+' '+(y+84)+' s0.07 -0.07');
				svg.append(ele);
			} else {
				ele = S.path(halfRestPath)
					.transform('t'+(x-176)+' '+(y-83.5)+' s0.07 -0.07');
				var dot = S.circle(x+33, y-11, 3.5);
				svg.append(dot);
				svg.append(ele);
			}
			break;

		case '1':
			y = 17.75*2;
			if (staff.type!='rhythm') y-=17.75;
			ele = S.path(wholeRestPath).transform('t'+(x-177)+' '+(y+84)+' s0.07 -0.07');
			svg.append(ele);
			break;
		case '1.':
			y = 17.75*2;
			if (staff.type!='rhythm') y-=17.75;
			ele = S.path(wholeRestPath).transform('t'+(x-177)+' '+(y+84)+' s0.07 -0.07');
			var dot = S.circle(x+33,y-9,3.5);
			svg.append(dot);
			svg.append(ele);
			break;
	}
	mb.rest = svg;
	mb.type = 'rest';
	if (topbot)
		mb.staff = topbot;
	if (rop) svg.attr({opacity:rop});
	staff.whole.prepend(svg);

	svg.node.onfocus = function() {
		svg.attr({fill:'rgb(99, 21, 255)'});
	}
	svg.node.onblur = function() {
		svg.attr({fill:'black'});
	}

	svg.node.tabIndex = "0";
	//console.log(mb);
	if (partwriting) {
		svg.node.ariaLabel = 'quarter rest, chord '+(mb.index+1)+', '+accessibleVoice({topbot:mb.staff,voice:mb.vc});
	} else {
		if (topbot) {
			var stext = topbot=='top' ? 'top staff':'bottom staff';
			svg.node.tabIndex = "0";
			svg.node.ariaLabel = stext+', '+nType(mb.dur)+" rest, measure "+(mb.measure+1)+", beat "+(mb.beat);
		} else {
			svg.node.ariaLabel = nType(mb.dur)+" rest, measure "+(mb.measure+1)+", beat "+mb.beat;
		}
	}
	
	return svg;
}

function nType(dur) {
    switch(dur) {
		case '32':
			return 'thirty second';
			break;
        case '16':
            return 'sixteenth';
            break;
		case '16.':
            return 'dotted sixteenth';
            break;
        case 's16':
            return 'sextuplet';
            break;
		case 'v16':
            return 'septuplet';
            break;
		case 'q16':
            return 'quintuplet';
            break;
        case '8':
            return 'eighth';
            break;
        case '8.':
            return 'dotted eighth';
            break;
        case 't8':
            return 'triplet eighth';
            break;
        case 't4':
            return 'triplet quarter';
            break;
        case 'd8':
            return 'duple eighth';
            break;
		case 'd4':
			return 'duple quarter';
			break;
        case 'f8':
            return 'quadruple eighth';
            break;
        case '4':
            return 'quarter';
            break;
        case '2':
            return 'half';
            break;
        case '4.':
            return 'dotted quarter';
            break;
        case '2.':
            return 'dotted half';
            break;
        case '1':
            return 'whole';
            break;
        case '1.':
            return 'dotted whole';
            break;
    }
}

var svgPoint                    // cursorPoint Global SVG Reference Point 
function cursorPoint(evt,paper,ele) {     // Call this with the CLICK/DBLCLICK event arg 
    //console.log('Event: ' + evt.x + ',' + evt.y) 
    if (!svgPoint)   
        svgPoint = paper.node.createSVGPoint() 
    svgPoint.x = evt.x; svgPoint.y = evt.y 
    return svgPoint.matrixTransform(ele.node.getScreenCTM().inverse()) 
}

function staff2Global(staff,x) {
	if (!svgPoint)
		svgPoint = staff.paper.node.createSVGPoint();
	svgPoint.x = x; svgPoint.y = 0;
	return svgPoint.matrixTransform(staff.whole.node.getScreenCTM())
}

function staff2Global2(staff,y) {
	if (!svgPoint)
		svgPoint = staff.paper.node.createSVGPoint();
	svgPoint.x = 0; svgPoint.y = y;
	return svgPoint.matrixTransform(staff.whole.node.getScreenCTM())
}

function scaleMaker(tonic,type,direction) {
	tonic = tonic.replace('♭','\u0231');
	type = type.toLowerCase();
	if (type=='augmented') { //augmented scale, for interval naming
		tonic = tonic.replace('y','');
		return [tonic,noteM(noteM(notem(noteM(tonic)))),notea(notem(noteM(tonic))),noteM(noteM(notem(notem(noteM(tonic))))),noteM(noteM(tonic)),notea(tonic),null,notea(notem(tonic))];
	}
	if (type=='diminished') { //diminished scale, for interval naming
		tonic = tonic.replace('x','');
		return [tonic,null,null,notem(notem(notem(notem(noteM(tonic))))),notem(notem(tonic)),null,notem(notem(notem(tonic))),notem(noteM(notem(notem(notem(notem(noteM(tonic)))))))];
	}
	if (type=='chromatic-up') { //chromatic scale
		var crm = ['C','C♯','D','D♯','E','F','F♯','G','G♯','A','A♯','B'];
		tonic=tonic.replace('z','');
		while(crm[0]!=tonic)
			crm=invert(crm,1);
		crm=crm.concat([tonic]);
		return crm;
		
	}
	if (type=='chromatic-down') { //chromatic descending
		var crm = ['C','B','B\u0231','A','A\u0231','G','G\u0231','F','E','E\u0231','D','D\u0231'];
		tonic=tonic.replace('q','');
		while(crm[0]!=tonic)
			crm=invert(crm,1);
		crm=crm.concat([tonic]);
		return crm;
	}
	
	//special shit
	/*if (tonic=='G♯') return ['G♯','A♯','B♯','C♯','D♯','E♯','F♯♯']; //special case
	if (tonic=='B♯') return ['B♯','C♯♯','D♯♯','E♯','F♯♯','G♯♯','A♯♯']; //special case
	if (tonic=='b♯') return ['B♯','C♯♯','D♯','E♯','F♯♯','G♯','A♯']; //special case
	if (tonic=='A♯') return ['A♯','B♯','C♯♯','D♯♯','E♯','F♯♯','G♯♯']; //special case
	if (tonic=='E♯') return ['E♯','F♯♯','G♯♯','A♯','B♯','C♯♯','D♯♯']; //special case
	if (tonic=='e♯') return ['E♯','F♯♯','G♯','A♯','B♯','C♯','D♯']; //special case
	if (tonic=='D♯') return ['D♯','E♯','F♯♯','G♯','A♯','B♯','C♯♯']; //special case
	if (tonic=='g\u0231') return ['G\u0231','A\u0231','Bff','C\u0231','D\u0231','E\u0231','F'];
	if (tonic=='F\u0231') return ['F\u0231','G\u0231','A\u0231','Bff','C\u0231','D\u0231','E\u0231'];
	if (tonic=='f\u0231') return ['F\u0231','G\u0231','Aff','Bff','C\u0231','Dff','Eff'];
	if (tonic=='c\u0231') return ['C\u0231','D\u0231','Eff','F\u0231','G\u0231','Aff','Bff'];*/
	
    var scale = ["A","B","C","D","E","F","G"];
	var tnc=tonic;
	var shft=false;
	if (type.indexOf('minor')!=-1) {
		tonic=notem(tonic.toUpperCase().replace('\u0230','\u0231'));
		shft=true;
	}
    var shrp = ["C","G","D","A","E","B","F♯","C♯"];
    var flat = ["C","F","B\u0231","E\u0231","A\u0231","D\u0231","G\u0231","C\u0231"];

    var sloc = [0,2,18,19,27,91,95,127];
    var floc = [0,32,36,100,108,109,125,127];

    var pos;

    switch(tonic[tonic.length-1]) {
        case "♯":
            pos = dec2Bin(sloc[shrp.indexOf(tonic)]);
            var t=pos.length;
            for (var i=0; i<7-t; i++) pos="0"+pos;
            for (var i=0; i<pos.length; i++) {
                if (pos[i]==1)
                    scale[i]=scale[i]+"♯";
            }
            break;
        case "\u0231":
            pos = dec2Bin(floc[flat.indexOf(tonic)]);
            var t=pos.length;
            for (var i=0; i<7-t; i++) pos="0"+pos;
            for (var i=0; i<pos.length; i++) {
                if (pos[i]==1)
                    scale[i]=scale[i]+"\u0231";
            }
            break;
        case "F":
            pos = dec2Bin(floc[flat.indexOf(tonic)]);
            var t=pos.length;
            for (var i=0; i<7-t; i++) pos="0"+pos;
            for (var i=0; i<pos.length; i++) {
                if (pos[i]==1)
                    scale[i]=scale[i]+"\u0231";
            }
            break;
        default:
            pos = dec2Bin(sloc[shrp.indexOf(tonic)]);
            var t=pos.length;
            for (var i=0; i<7-t; i++) pos="0"+pos;
            for (var i=0; i<pos.length; i++) {
                if (pos[i]==1)
                    scale[i]=scale[i]+"♯";
            }
            break;
    }
    scale=scale.slice(scale.indexOf(tonic)).concat(scale.slice(0,scale.indexOf(tonic)));
    if (shft) { //minor
		var sls = scale.slice(0,scale.length-2);
		var sls2 = scale.slice(scale.length-2);
		scale = sls2.concat(sls);
	}	
	if (type=='melodic minor'&&direction=='Both') {
		var bscale = copyAry(scale);
		bscale[5] = noteM(notem(noteM(notem(noteM(notem(noteM(bscale[5]))))))); //sharp 6
		bscale[6] = noteM(notem(noteM(notem(noteM(notem(noteM(bscale[6]))))))); //sharp 7
		bscale.push(bscale[0]);
		for (var i=6; i>0; i--)
			bscale.push(scale[i]);
		scale = bscale;
		scale.push(scale[0]);
		return scale;
	}
	if (type=='melodic minor'&&direction=='Up') {
		scale[5] = noteM(notem(noteM(notem(noteM(notem(noteM(scale[5]))))))); //sharp 6
		scale[6] = noteM(notem(noteM(notem(noteM(notem(noteM(scale[6]))))))); //sharp 7
	}
	if (type=='harmonic minor') {
		scale[6] = notea(notem(scale[6])); //sharp 7
	}
	
	if (direction=='Both') {
		var bscale = copyAry(scale);
		bscale.push(bscale[0]);
		for (var i=6; i>0; i--)
			bscale.push(scale[i]);
		scale = bscale;
	}
	
	scale.push(scale[0]);
    return scale;
}

function dec2Bin(dec)
{
    if(dec >= 0) {
        return dec.toString(2);
    }
    else {
        return (~dec).toString(2);
    }
}

function noteM(note) {
    var majorThird;
    switch(note) {
        case "C":
            majorThird="E";
            break;
        case "C\u0231":
            majorThird="E\u0231";
            break;
        case "C♯":
            majorThird="E♯";
            break;
        case "Cff":
            majorThird="Eff";
            break;
        case "Cx":
            majorThird="Ex";
            break;
        case "D":
            majorThird="F♯";
            break;
        case "D\u0231":
            majorThird="F";
            break;
        case "D♯":
            majorThird="Fx";
            break;
        case "Dff":
            majorThird="F\u0231";
            break;
        case "E":
            majorThird="G♯";
            break;
        case "E\u0231":
            majorThird="G";
            break;
        case "Eff":
            majorThird="G\u0231";
            break;
        case "E♯":
            majorThird="Gx";
            break;
        case "F":
            majorThird="A";
            break;
        case "F\u0231":
            majorThird="A\u0231";
            break;
        case "Fff":
            majorThird="Aff";
            break;
        case "Fx":
            majorThird="Ax";
            break;
        case "F♯":
            majorThird="A♯";
            break;
        case "G":
            majorThird="B";
            break;
        case "G\u0231":
            majorThird="B\u0231";
            break;
        case "G♯":
            majorThird="B♯";
            break;
        case "Gx":
            majorThird="Bx";
            break;
        case "Gff":
            majorThird="Bff";
            break;
        case "A":
            majorThird="C♯";
            break;
        case "A♯":
            majorThird="Cx";
            break;
        case "A\u0231":
            majorThird="C";
            break;
        case "Aff":
            majorThird="C\u0231";
            break;
        case "B":
            majorThird="D♯";
            break;
        case "B♯":
            majorThird="Dx";
            break;
        case "B\u0231":
            majorThird="D";
            break;
        case "Bff":
            majorThird="D\u0231";
            break;
    }
    return majorThird;
}

function notem(note) {
    var minorThird;
    switch(note) {
        case "C":
            minorThird="E\u0231";
            break;
        case "C\u0231":
            minorThird="Eff";
            break;
        case "C♯":
            minorThird="E";
            break;
        case "C#":
            minorThird="E";
            break;            
        case "Cx":
            minorThird="E♯";
            break;
        case "D":
            minorThird="F";
            break;
        case "D\u0231":
            minorThird="F\u0231";
            break;
        case "D♯":
            minorThird="F♯";
            break;
        case "Dff":
            minorThird="Fff";
            break;
        case "E":
            minorThird="G";
            break;
        case "E\u0231":
            minorThird="G\u0231";
            break;
        case "Eff":
            minorThird="Gff";
            break;
        case "E♯":
            minorThird="G♯";
            break;
        case "F":
            minorThird="A\u0231";
            break;
        case "F\u0231":
            minorThird="Aff";
            break;
        case "Fx":
            minorThird="A♯";
            break;
        case "F♯":
            minorThird="A";
            break;
        case "F#":
            minorThird="A";
            break;            
        case "G":
            minorThird="B\u0231";
            break;
        case "G\u0231":
            minorThird="Bff";
            break;
        case "G♯":
            minorThird="B";
            break;
        case "Gx":
            minorThird="B♯";
            break;
        case "Gff":
            minorThird="A\u0231";
            break;
        case "A":
            minorThird="C";
            break;
        case "A♯":
            minorThird="C♯";
            break;
        case "A\u0231":
            minorThird="C\u0231";
            break;
        case "Aff":
            minorThird="Cff";
            break;
        case "Ax":
            minorThird="Cx";
            break;
        case "B":
            minorThird="D";
            break;
        case "B♯":
            minorThird="D♯";
            break;
        case "B\u0231":
            minorThird="D\u0231";
            break;
        case "Bff":
            minorThird="Dff";
            break;
    }
    return minorThird;
}

function notea(note) {
    var aug6;
    switch(note) {
        case "C":
            aug6="A♯";
            break;
        case "C\u0231":
            aug6="A";
            break;
        case "D":
            aug6="B♯";
            break;
        case "D\u0231":
            aug6="B";
            break;
        case "E\u0231":
            aug6="C♯";
            break;
        case "E":
            aug6="Cx";
            break;
        case "Eff":
            aug6="C";
            break;
        case "F":
            aug6="D♯";
            break;
        case "F\u0231":
            aug6="D";
            break;
        case "G\u0231":
            aug6="E";
            break;
        case "G":
            aug6="E♯";
            break;
        case "Aff":
            aug6="F";
            break;
        case "A\u0231":
            aug6="F♯";
            break;
        case "A":
            aug6="Fx";
            break;
        case "B\u0231":
            aug6="G♯";
            break;
        case "B":
            aug6="Gx";
            break;
    }
    return aug6;
}

function invert(chord,num) {
    for (var i=0; i<num; i++) {
        chord.push(chord[i]);
        //var val=chord[chord.length-1];
        //chord[chord.length-1]=val.slice(0,val.length-1)+(1+parseInt(val[val.length-1]));
    }
    chord=chord.slice(num);
    return chord;
}

//music utilities
function noNum(nt) {
	return nt.replace('0','').replace('1','').replace('2','').replace('3','').replace('4','').replace('5','').replace('6','').replace('7','').replace('8','');
}

function cleanNote(note) {
	if (!note) return;
	if (note.stem)
		note.stem.remove();
	if (note.beam)
		note.beam.remove();
	if (note['16-16']) {
		note['16-16'] = null;
	}
	if (note['8-16']) {
		note['8-16'].remove();
		note['8-16'] = null;
	}
	if (note['8.-16']) {
		note['8.-16'].remove();
		note['8.-16'] = null;
	}
	if (note.beams) {
		for (var i=0; i<note.beams.length; i++)
			note.beams[i].remove();
		note.beams = [];
	}
	if (note.beam2)
		note.beam2.remove();
	if (note.beam3)
		note.beam3.remove();
	if (note.flag)
		note.flag.remove();
	if (note.t3)
		note.t3.remove();
}

function retNum(nt) {
	var reps = ['a','b','c','d','e','f','g','A','B','C','D','E','F','G','x','♯','\u0231'];
	for (var i=0; i<reps.length; i++)
		while(nt.indexOf(reps[i])!=-1)
			nt=nt.replace(reps[i],'');
	return nt;
}

function retBase(nt) {
	var reps = ['♯','bb','\u0231','x','n','1','2','3','4','5','6','7','8','9'];
	for (var i=0; i<reps.length; i++)
		while(nt.indexOf(reps[i])!=-1)
			nt=nt.replace(reps[i],'');
	return nt;
}

function fixScale(ary) {
	for (var i=0; i<ary.length; i++) {
		if (!ary[i]) continue;
		ary[i]=ary[i].replace('\u0231','b');
		ary[i]=ary[i].replace('♯♯','x');
		ary[i]=ary[i].replace('♯','#');
	}
	return ary;
}

function cleanName(nt) {
	return nt.replace('♯','').replace('bb','').replace('\u0231','').replace('x','').replace('n','');
}

function dnTan(dxdy,theta) {
	return dxdy*Math.tan(theta);
}

function calcY(dx,theta,y0) {
	return y0+dx*Math.tan(theta);
}

function boxNote(note) {
	var bb = note.getBBox();
	note.x = bb.x;
	note.by = bb.y;
	note.width = bb.width;
	note.height = bb.height;
}

function beamPair(staff,n1,n2,theta,flip) {
	var S = staff.paper;
	var dur1 = n1.dur;
	var dur2 = n2.dur;
	
	if (!n1.beams) n1.beams = [];
	if (!n2.beams) n2.beams = [];
	
	var type = dur1+'-'+dur2;
	var bth = 10; //beam thickness
	var bsp = 5; //space between beams
	var stemW = 2;
	var yBuff = 0.54;
	var xBuff = 0.2;
	
	if (n1.by>n2.by) theta = -theta;
	
	if (!flip) {
		//first beam
		var x1 = n1.x + n1.width - stemW - xBuff;
		var x2 = n2.x + n2.width - xBuff;
		var y1 = n1.stem.getBBox().y - yBuff;
		var y2 = n2.stem.getBBox().y - yBuff;
		var beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
		staff.whole.prepend(beam);
		n1.beams.push(beam); //keep on first note
		n2.beams.push(beam); //keep on second note
		
		switch(type) {
			case '16-8':
				if (!n1['16-16']&&!n1['8-16']&&!n1['8.-16']) {
					x2 = x1 + n1.width - xBuff;
					y1 = y1 + bth + bsp;
					y2 = y1 + dnTan(n1.width,theta);
					beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
					staff.whole.prepend(beam);
					n1.beams.push(beam);
					n2.beams.push(beam);
				}
				break;
			case '16-8.':
				if (!n1['16-16']&&!n1['8-16']&&!n1['8.-16']) {
					x2 = x1 + n1.width - xBuff;
					y1 = y1 + bth + bsp;
					y2 = y1 + dnTan(n1.width,theta);
					beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
					staff.whole.prepend(beam);
					n1.beams.push(beam);
					n2.beams.push(beam);
				}
				break;
			case '8-16':
				//16th part
				x1 = n2.x;
				y2 = y2 + bth + bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8-16'] = beam;
				break;
			case '8.-16':
				//16th part
				x1 = n2.x;
				y2 = y2 + bth + bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8.-16'] = beam;
				break;
			case '16-16':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 += (bth+bsp);
				y2 += (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16-16'] = true;
				break;
			case '32-32':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 += (bth+bsp);
				y2 += (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16-16'] = true;

				y1 += (bth+bsp);
				y2 += (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['32-32'] = true;
				break;
			case 's16-s16':
				y1 += (bth+bsp);
				y2 += (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2+bth, x1,y1+bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				break;
		}
	} else {
		//first beam
		var x1 = n1.x;
		var x2 = n2.x;
		var y1 = n1.by + n1.height/2 + n1.stemH;
		var y2 = n2.by + n2.height/2 + n2.stemH;
		var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
		staff.whole.prepend(beam);
		n1.beams.push(beam); //keep on first note
		n2.beams.push(beam); //keep on second note
		
		switch(type) {
			case '16-8':
				if (!n1['16.-16.']&&!n1['16-16']&&!n1['8-16']&&!n1['8.-16']) {
					x2 = x1 + n1.width - xBuff;
					y1 = y1 - bth - bsp;
					y2 = y1 + dnTan(n1.width,theta);
					beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
					staff.whole.prepend(beam);
					n1.beams.push(beam);
					n2.beams.push(beam);
				}
				break;
			case '16-8.':
				if (!n1['16.-16.']&&!n1['16-16']&&!n1['8-16']&&!n1['8.-16']) {
					x2 = x1 + n1.width - xBuff;
					y1 = y1 - bth - bsp;
					y2 = y1 + dnTan(n1.width,theta);
					beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
					staff.whole.prepend(beam);
					n1.beams.push(beam);
					n2.beams.push(beam);
				}
				break;
			case '8-16':
				//16th part
				x1 = n2.x - n2.width;
				y2 = y2 - bth - bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8-16'] = beam;
				break;
			case '8.-16':
				//16th part
				x1 = n2.x - n2.width;
				y2 = y2 - bth - bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8-16'] = beam;
				break;
			case '16-16':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16-16'] = true;
				break;
			case '16.-16.':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16.-16.'] = true;
				break;
			case '16-32':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				
				//16th part
				x1 = n2.x - n2.width;
				y2 = y2 - bth - bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16-32'] = beam;
				break;
			case '16.-32':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				
				//16th part
				x1 = n2.x - n2.width;
				y2 = y2 - bth - bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16.-32'] = beam;
				break;
			case '8-32':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				x1 = n2.x - n2.width;
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8-32-1'] = beam;
				
				//16th part
				y2 = y2 - bth - bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8-32-2'] = beam;
				break;
			case '8.-32':
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				x1 = n2.x - n2.width;
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8.-32-1'] = beam;
				
				//16th part
				y2 = y2 - bth - bsp;
				y1 = y2 + dnTan(x1-x2,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['8.-32-2'] = beam;
				break;
			case '32-16':
				//x2 = x1 + n1.width;
				y1 = y1 - bth - bsp;
				y2 = y1 + dnTan(n1.width,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				if (!n1['16.-16.']&&!n1['16.-32']&&!n1['16-32']&&!n1['16-16']&&!n1['8-16']&&!n1['8.-16']) {
					x2 = x1 + n1.width - xBuff;
					y1 -= (bth+bsp);
					y2 -= (bth+bsp);
					var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
					staff.whole.prepend(beam);
					n1.beams.push(beam);
					n2.beams.push(beam);
				}
				break;
			case '32-16.':
				//x2 = x1 + n1.width;
				y1 = y1 - bth - bsp;
				y2 = y1 + dnTan(n1.width,theta);
				beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				if (!n1['16.-16.']&&!n1['16.-32']&&!n1['16-32']&&!n1['16-16']&&!n1['8-16']&&!n1['8.-16']) {
					x2 = x1 + n1.width - xBuff;
					y1 -= (bth+bsp);
					y2 -= (bth+bsp);
					var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
					staff.whole.prepend(beam);
					n1.beams.push(beam);
					n2.beams.push(beam);
				}
				break;
			case '32-32':
				if (n1['16-32']) {n1['16-32'].remove(); n1['16-32'] = null;}
				if (n1['16.-32']) {n1['16.-32'].remove(); n1['16.-32'] = null;}
				if (n1['8-32-1']) {n1['8-32-1'].remove(); n1['8-32-1'] = null;}
				if (n1['8-32-2']) {n1['8-32-2'].remove(); n1['8-32-2'] = null;}
				if (n1['8.-32-1']) {n1['8.-32-1'].remove(); n1['8.-32-1'] = null;}
				if (n1['8.-32-2']) {n1['8.-32-2'].remove(); n1['8.-32-2'] = null;}
				if (n1['8-16']) {n1['8-16'].remove(); n1['8-16'] = null;}
				if (n1['8.-16']) {n1['8.-16'].remove(); n1['8.-16'] = null;}
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['16-16'] = true;

				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				n2['32-32'] = true;
				break;
			case 's16-s16':
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				break;
			case 'q16-q16':
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				break;
			case 'v16-v16':
				y1 -= (bth+bsp);
				y2 -= (bth+bsp);
				var beam = S.polyline(x1,y1, x2,y2, x2,y2-bth, x1,y1-bth, x1,y1);
				staff.whole.prepend(beam);
				n1.beams.push(beam);
				n2.beams.push(beam);
				break;
		}
	}
}

function drawStems(staff,notes,type,dir) {
	//closest note to middle line gets normal stem (maybe limit in extreme cases)
	//max angle
	var rad = (2*3.1415)/360;
	var maxTheta = 15;
	maxTheta*=rad;
	var sdx = 2.2;
	var sdy = 3.2;
	var stemW = 2;
	var stemH = 45;
	var bth = 10;
	
	//paper
	var S = staff.paper;
	
	//save stem buddies
	for (var i=0; i<notes.length; i++) {
		if (!notes[i]) continue; //these are rests
		notes[i].stemBuddies = [];
		for (var j=0; j<notes.length; j++) {
			if (i!=j) notes[i].stemBuddies.push(notes[j]);
		}
	}
	
	//just get the notes
	var tmp = copyAry(notes);
	notes = [];
	for (var i=0; i<tmp.length; i++) {
		if (tmp[i]) notes.push(tmp[i]);
	}
	
	var copyObject = function(obj) {
		var nbj = {};
		for (var prop in obj) {
			nbj[prop] = obj[prop];
		}
		return nbj;
	}
	
	switch(dir) {
		case 'up':
			var min = 1000000;
			var minNote;
			for (var i=0; i<notes.length; i++) {
				//boxNote(notes[i]);
				if (notes[i].by<min) {
					min = notes[i].by; 
					minNote = i;
				}
			}
			
			//attempt angle change
			var theta = 0; //start with flat beam
			var incr = 1;
			var stop = false;
			if (minNote==0) {
				while(!stop) {
					theta+=incr*rad; //increment and convert to radians
					if (theta>=maxTheta) {break;}
					//check stem height
					for (var i=0; i<notes.length; i++) {
						if ( (notes[i].by) < (min+dnTan(notes[i].x-notes[minNote].x,theta))) {
							stop = true;
							theta-=incr*rad;
							break;
						}
					}
				}
			}
			
			if (minNote==(notes.length-1)) {
				while(!stop) {
					theta+=incr*rad; //increment and convert to radians
					if (theta>=maxTheta) {break;}
					//check stem height
					for (var i=0; i<notes.length; i++) {
						if ( (notes[i].by) < (min-dnTan(notes[i].x-notes[minNote].x,theta))) {
							stop = true;
							theta-=incr*rad;
							break;
						}
					}
				}
			}
			
			//minNote has full stemH
			notes[minNote].stemH = 3.5*17.75;
			var sign = -1;
			if (minNote==0) sign = 1;
			for (var i=0; i<notes.length; i++) {
				if (i==minNote) continue;
				notes[i].stemH = (notes[i].by + notes[i].height/2) - (notes[minNote].by + notes[minNote].height/2 - notes[minNote].stemH + sign*dnTan(notes[i].x - notes[minNote].x, theta));
			}
			
			//change stems
			for (var i=0; i<notes.length; i++) {
				var stem = S.rect(notes[i].x+notes[i].width-sdx,notes[i].by+notes[i].height/2-notes[i].stemH,stemW,notes[i].stemH);
				notes[i].stem = stem;
				staff.whole.prepend(stem);
			}
			
			//beam in pairs
			for (var i=0; i<notes.length-1; i++) {
				beamPair(staff,notes[i],notes[i+1],theta);
			}
			break;
		case 'down':
			var max = -1000000;
			var maxNote;
			for (var i=0; i<notes.length; i++) {
				//boxNote(notes[i]);
				if (notes[i].by>max) {
					max = notes[i].by; 
					maxNote = i;
				}
			}
			
			//attempt angle change
			var theta = 0; //start with flat beam
			var incr = 1;
			var stop = false;
			if (maxNote==(notes.length-1)) {
				while(!stop) {
					theta+=incr*rad; //increment and convert to radians
					if (theta>=maxTheta) {break;}
					//check stem height
					for (var i=0; i<notes.length; i++) {
						if ( (notes[i].by) > (max+dnTan(notes[i].x-notes[maxNote].x,theta))) {
							stop = true;
							theta-=incr*rad;
							break;
						}
					}
				}
			}
			
			if (maxNote==0) {
				while(!stop) {
					theta+=incr*rad; //increment and convert to radians
					if (theta>=maxTheta) {break;}
					//check stem height
					for (var i=0; i<notes.length; i++) {
						if ( (notes[i].by) > (max-dnTan(notes[i].x-notes[maxNote].x,theta))) {
							stop = true;
							theta-=incr*rad;
							break;
						}
					}
				}
			}
			
			//minNote has full stemH
			notes[maxNote].stemH = 3.5*17.75;
			var sign = 1;
			if (maxNote==0) sign = -1;
			for (var i=0; i<notes.length; i++) {
				if (i==maxNote) continue;
				notes[i].stemH = (notes[maxNote].by + notes[maxNote].height/2 + notes[maxNote].stemH + sign*dnTan(notes[i].x - notes[maxNote].x, theta)) - (notes[i].by + notes[i].height/2);
			}
			
			//change stems
			for (var i=0; i<notes.length; i++) {
				var stem = S.rect(notes[i].x,notes[i].by+notes[i].height/2,stemW,notes[i].stemH);
				notes[i].stem = stem;
				staff.whole.prepend(stem);
			}
			
			//beam in pairs
			for (var i=0; i<notes.length-1; i++) {
				beamPair(staff,notes[i],notes[i+1],theta,true);
			}
			break;
	}
	
	//draw numbers on tuplets
	var durs = '';
	for (var i=0; i<notes.length; i++) {
		durs+=notes[i].dur;
	}
	switch(durs) {
		case 'f8f8f8f8':
			var mn = notes[1];
			var mn2 = notes[2];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'4').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'f8f8f8': //three
			var mn = notes[1];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'4').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'f8f8': //two
			var mn = notes[0];
			var mn2 = notes[1];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'4').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 't8t8t8': //all three
			var mn = notes[1];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'3').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 't8t8': //two
			var mn = notes[0];
			var mn2 = notes[1];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'3').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'd8d8':
			var mn = notes[0];
			var mn2 = notes[1];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'2').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 's16s16':
			var mn = notes[0];
			var mn2 = notes[1];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'6').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 's16s16s16': //three sextuplets
			var mn = notes[1];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'6').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 's16s16s16s16':
			var mn = notes[1];
			var mn2 = notes[2];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'6').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 's16s16s16s16s16': //three sextuplets
			var mn = notes[2];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'6').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 's16s16s16s16s16s16':
			var mn = notes[2];
			var mn2 = notes[3];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'6').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'q16q16':
			var mn = notes[0];
			var mn2 = notes[1];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'5').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'q16q16q16': //three sextuplets
			var mn = notes[1];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'5').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'q16q16q16q16':
			var mn = notes[1];
			var mn2 = notes[2];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'5').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'q16q16q16q16q16': //three sextuplets
			var mn = notes[2];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'5').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'v16v16':
			var mn = notes[0];
			var mn2 = notes[1];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'7').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'v16v16v16': //three sextuplets
			var mn = notes[1];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'7').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'v16v16v16v16':
			var mn = notes[1];
			var mn2 = notes[2];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'7').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'v16v16v16v16v16': //three sextuplets
			var mn = notes[2];
			var x = mn.x;
			var y = mn.by;
			if (dir=='up') {y-=mn.stemH-5; x+=mn.width/2+5;}
			else {y+=mn.stemH+25;}
			mn.t3 = staff.whole.text(x,y,'7').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'v16v16v16v16v16v16':
			var mn = notes[2];
			var mn2 = notes[3];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'7').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
		case 'v16v16v16v16v16v16v16':
			var mn = notes[2];
			var mn2 = notes[3];
			var x = (mn.x+mn2.x)/2+mn.width-5;
			var y = (mn.by-mn.stemH)/2+(mn2.by-mn2.stemH)/2+5;
			if (dir=='up') {

			} else {
				x = (mn.x+mn2.x)/2;
				y = (mn.by+mn.stemH)/2+(mn2.by+mn2.stemH)/2+25;
			}
			mn.t3 = staff.whole.text(x,y,'7').attr({fontStyle:'italic'});
			staff.whole.prepend(mn.t3);
			break;
	}
}

/* PATHS AND SHIT */
//paths for svg shit
//notes
var wholePath = "M215 112c-50 0 -69 -43 -69 -88c0 -77 57 -136 134 -136c50 0 69 43 69 88c0 77 -57 136 -134 136zM495 0c0 -43 -35"
        + " -76 -73 -97c-53 -30 -113 -41 -174 -41s-122 11 -175 41c-38 21 -73 54 -73 97s35 76 73 97c53 30 114 41 175 41s121 -11"
        + " 174 -41 c38 -21 73 -54 73 -97z";
var closedPath = "M224 136c53 0 105 -26 105 -86c0 -71 -57 -122 -104 -150c-36 -22 -78 -36 -120 -36c-53 0 -105 26 -105"
		+ " 86c0 71 58 122 105 150c36 22 77 36 119 36z";
var openPath = "M318 67c0 25 -21 42 -43 42c-4 0 -9 -1 -13 -2c-31 -9 -79 -41 -117 -65s-85 -55 -106 -80c-7 -8 -11 -19 -11 -29c0 -25 21 -42 43 -42c4"
		+ " 0 8 1 12 2c31 9 79 41 117 65s86 55 107 80c7 8 11 19 11 29zM267 136c44 0 79 -20 79 -68c0 -19 -6 -38 -12 -57c-13 -37 -32 -73 -65 -95c-54"
		+ " -36 -115 -52 -190 -52c-44 0 -79 20 -79 68c0 19 6 38 12 57c13 37 31 73 64 95c54 36 116 52 191 52z";

//clefs
var altoPath = "M318 0c0 -33 7 -73 45 -73c29 0 57 31 88 31c123 0 229 -89 229 -208c0 -169 -93 -250 -265 -250c-83 0 -152 61 -152 142c0 42 34 77 76 77s76 -35 76 -77c0 -39 -49 -37 -49 -76c0 -23 24 -38 49 -38c116 0 140 90 140 222c0 106 -12 180 -104 180 c-72 0 -119 -71 -119 -149c0 -9 -7 -14 -14 -14s-13 5 -13 14c0 76 -31 147 -84 200v-471c0 -6 -4 -10 -10 -10h-21c-6 0 -10 4 -10 10v980c0 6 4 10 10 10h21c6 0 10 -4 10 -10v-471c53 53 84 124 84 200c0 9 6 14 13 14s14 -5 14 -14c0 -78 47 -149 119 -149 c92 0 104 74 104 180c0 132 -24 222 -140 222c-25 0 -49 -15 -49 -38c0 -39 49 -37 49 -76c0 -42 -34 -77 -76 -77s-76 35 -76 77c0 81 69 142 152 142c172 0 265 -81 265 -250c0 -119 -106 -208 -229 -208c-31 0 -59 31 -88 31c-38 0 -45 -40 -45 -73zM129 -500h-119 c-6 0 -10 4 -10 10v980c0 6 4 10 10 10h119c6 0 10 -4 10 -10v-980c0 -6 -4 -10 -10 -10z";
var treblePath = "M374 260c5 0 10 1 15 1c154 0 254 -127 254 -259c0 -76 -33 -153 -107 -208c-22 -17 -47 -29 -73 -37c3 -36 5 -72 5 -108c0 -19 0"
		+ " -37 -1 -56c-7 -120 -88 -226 -206 -226c-108 0 -195 87 -195 195c0 58 53 104 112 104c54 0 95 -48 95 -104c0 -52 -43 -95 -95 -95 c-12 0 -24"
		+ " 4 -35 9c26 -41 70 -70 121 -70c96 0 157 93 163 193c1 18 2 35 2 53c0 32 -2 64 -5 96c-29 -5 -58 -8 -89 -8c-188 0 -333 171 -333 372c0 178 133"
		+ " 306 251 440c-18 63 -35 126 -42 191c-6 51 -7 102 -7 154c0 116 55 226 150 295c2 2 5 3 8 3s6 -1 8 -3c70 -84 132 -246 132 -359c0 -144 -87 -256"
		+ " -183 -365c20 -69 39 -138 55 -208zM459 -205c69 24 117 96 117 166c0 92 -69 184 -179 193c25 -117 48 -235 62 -359zM71 31c0 -136 131 -251 267"
		+ " -251c28 0 55 2 82 6c-15 128 -38 247 -64 367c-79 -9 -125 -62 -125 -121c0 -44 26 -92 82 -124c4 -4 7 -9 7 -14c0 -11 -9 -21 -20 -21c-3 0 -6 1"
		+ " -9 2c-80 43 -116 114 -116 184c0 88 57 173 158 196c-14 60 -30 119 -46 178c-108 -121 -216 -242 -216 -402zM411 1050c-99 -50 -161 -151 -161"
		+ " -262c0 -76 15 -137 33 -200c82 97 149 198 149 325 c0 58 -4 84 -21 137z";
var bassPath = "M556 -125c0 29 23 52 52 52s52 -23 52 -52s-23 -52 -52 -52s-52 23 -52 52zM556 125c0 29 23 52 52 52s52 -23 52"
		+ " -52s-23 -52 -52 -52s-52 23 -52 52zM233 261c171 0 292 -86 292 -248c0 -263 -264 -415 -517 -521c-2 -2 -5 -3 -8 -3c-6 0 -11"
		+ " 5 -11 11c0 3 1 6 3 8 c203 118 415 265 415 494c0 121 -64 237 -174 237c-79 0 -138 -57 -164 -133c14 8 28 13 43 13c55 0 100"
		+ " -45 100 -100c0 -58 -44 -107 -100 -107c-60 0 -112 48 -112 107c0 132 103 242 233 242z";

//accidentals
var sharpPath = "M215 -316c0 -9 -8 -17 -17 -17s-17 8 -17 17v151l-87 -31v-162c0 -9 -8 -17 -17 -17s-17 8 -17 17v150l-39"
		+ " -13c-10 -4 -21 4 -21 15v64c0 7 5 13 11 15l49 18v164l-39 -14c-10 -4 -21 4 -21 15v65c0 7 5 13 11 15l49 17v163c0 9 8"
		+ " 17 17 17s17 -8 17 -17v-151l87 31v162 c0 9 8 17 17 17s17 -8 17 -17v-150l39 13c10 4 21 -4 21 -15v-64c0 -7 -5 -13 -11"
		+ " -15l-49 -18v-164l39 14c10 4 21 -4 21 -15v-65c0 -7 -5 -13 -11 -15l-49 -17v-163zM94 67v-164l87 30v164z";
var doublesharpPath = "M63.4219 333.7031 L43.5938 333.7031 L43.5938 321.4688 Q43.5938 315.8438 36 315.8438 Q33.6094 315.8438"
        + " 31.2188 317.3906 Q28.4062 319.2188 28.4062 321.4688 L28.4062 333.7031 L9.4219 333.7031 L9.4219 314.7188 L21.6562"
        + " 314.7188 Q27.2812 314.7188 27.2812 307.125 Q27.2812 304.7344 25.5938 302.1328 Q23.9062 299.5312 21.6562 299.5312"
        + " L9.4219 299.5312 L9.4219 280.4062 L28.4062 280.4062 L28.4062 292.6406 Q28.4062 294.8906 31.2188 296.7188 Q33.6094"
        + " 298.2656 36 298.2656 Q43.5938 298.2656 43.5938 292.6406 L43.5938 280.4062 L63.4219 280.4062 L63.4219 299.5312 L51.1875"
        + " 299.5312 Q48.9375 299.5312 47.25 302.1328 Q45.5625 304.7344 45.5625 307.125 Q45.5625 314.7188 51.1875 314.7188 L63.4219"
        + " 314.7188 L63.4219 333.7031 Z";
var flatPath = "M27 41l-1 -66v-11c0 -22 1 -44 4 -66c45 38 93 80 93 139c0 33 -14 67 -43 67c-31 0 -52 -30 -53 -63zM-15 -138l-12 595c8"
        + " 5 18 8 27 8s19 -3 27 -8l-7 -345c25 21 58 34 91 34c52 0 89 -48 89 -102c0 -80 -86 -117 -147 -169c-15 -13 -24 -38 -45 -38 c-13 0 -23 11 -23 25z";
var doubleflatPath = "M28.125 392.4844 L28.125 266.625 L35.4375 266.625 L35.4375 352.4062 L42.4688 343.6875 Q49.2188 337.5 56.5312 337.5"
        + " Q61.3125 337.5 65.9531 339.6094 Q70.5938 341.7188 72.8438 346.3594 Q75.0938 351 75.0938 357.4688 Q74.8125 364.2188 68.625 371.25"
        + " Q62.4375 378.2812 51.1875 383.9062 Q39.9375 389.5312 28.125 392.4844 ZM75.9375 392.4844 L75.9375 266.625 L83.25 266.625 L83.25"
        + " 352.4062 L90.2812 343.6875 Q97.0312 337.5 104.3438 337.5 Q109.125 337.5 113.7656 339.6094 Q118.4062 341.7188 120.6562 346.3594"
        + " Q122.9062 351 122.9062 357.4688 Q122.625 364.2188 116.4375 371.25 Q110.25 378.2812 99 383.9062 Q87.75 389.5312 75.9375 392.4844"
        + " ZM35.4375 378.8438 Q51.4688 373.3594 56.9531 367.6641 Q62.4375 361.9688 62.4375 358.0312 Q62.4375 355.2188 62.0156 353.5312"
        + " Q61.5938 351.8438 59.7656 350.2969 Q57.9375 348.75 55.6875 348.75 Q53.4375 348.75 49.7812 350.1562 Q46.125 351.5625 43.5938"
        + " 354.0938 L35.4375 362.25 L35.4375 378.8438 ZM83.25 378.8438 Q99.2812 373.3594 104.7656 367.6641 Q110.25 361.9688 110.25"
        + " 358.0312 Q110.25 355.2188 109.8281 353.5312 Q109.4062 351.8438 107.5781 350.2969 Q105.75 348.75 103.5 348.75 Q101.25 348.75"
        + " 97.5938 350.1562 Q93.9375 351.5625 91.4062 354.0938 L83.25 362.25 L83.25 378.8438 Z";
var naturalPath = "M-8 375c8 4 17 7 26 7s17 -3 25 -7l-3 -183l106 20h3c10 0 18 -7 18 -17l7 -570c-8 -4 -16 -7 -25 -7s-17 3 -25 7l3 183l-106 -20h-3c-10 0 -18 7 -18 17zM131 112l-92 -17l-3 -207l92 17z";

//time signatures
var onePath="M122 503c18 0 34 -16 53 -16c15 0 29 7 42 13c1 1 3 1 4 1c7 0 12 -7 12 -17v-367c0 -48 28 -94 73 -94c8 0 12 -5 12 -11s-4 -12 -12 -12c-44 0 -87 13 -131 13s-87 -13 -131 -13c-8 0 -12 6 -12 12s4 11 12 11c45 0 73 46 73 94v245c0 12 -9 19 -17 19 c-4 0 -8 -3 -10 -7l-64 -136c-3 -6 -7 -9 -12 -9c-8 0 -16 6 -16 14c0 2 1 5 2 7l117 250c1 2 3 3 5 3z";
var twoPath="M23 11c-1 -7 -6 -11 -11 -11c-6 0 -12 4 -12 11c0 175 235 165 235 344c0 60 -18 122 -70 122c-26 0 -51 -14 -51 -37c0 -27 35 -41 35 -68c0 -38 -30 -69 -68 -69s-69 31 -69 69c0 76 72 128 153 128c96 0 187 -56 187 -145c0 -153 -151 -159 -249 -220c9 2 17 3 26 3 c33 0 70 -11 105 -36c21 -15 46 -23 66 -23c21 0 39 9 44 29c2 6 6 9 11 9c6 0 12 -5 12 -12c0 -67 -90 -105 -138 -105c-36 0 -71 14 -96 44c-13 16 -31 22 -48 22c-30 0 -59 -20 -62 -55z";
var threePath="M150 477c-29 0 -59 -8 -59 -33c0 -22 36 -25 36 -47c0 -32 -26 -58 -58 -58s-57 26 -57 58c0 65 67 103 138 103c91 0 169 -33 169 -114c0 -43 -4 -82 -42 -100c-9 -4 -14 -12 -14 -21s5 -18 14 -22c41 -19 56 -57 56 -103c0 -92 -79 -140 -179 -140c-79 0 -154 42 -154 113c0 36 30 66 66 66s65 -30 65 -66c0 -25 -40 -28 -40 -53c0 -27 32 -37 63 -37c49 0 63 61 63 117v16c0 54 -2 94 -50 94h-80c-10 0 -14 8 -14 15s4 14 14 14h80c49 0 50 43 50 99v8c0 54 -18 91 -67 91z";
var fourPath="M204 307c22 14 44 29 60 50c11 15 19 33 27 50c2 4 5 6 9 6c6 0 13 -5 13 -14v-245h72c10 0 15 -7 15 -14s-5 -15 -15 -15h-72v-8c0 -48 27 -94 72 -94c8 0 12 -5 12 -11s-4 -12 -12 -12c-44 0 -87 13 -131 13s-87 -13 -131 -13c-8 0 -12 6 -12 12s4 11 12 11 c45 0 73 46 73 94v8h-167c-23 0 -31 14 -31 23c0 3 1 5 2 6c80 93 138 207 138 330c0 9 6 16 13 16h3c23 -7 47 -13 71 -13s48 6 71 13c2 1 3 1 5 1c11 0 18 -10 12 -17l-284 -330h167v131c0 8 1 17 8 22z";
var fivePath = "M46 500c46 -8 91 -13 137 -13s92 5 138 13h4c12 0 19 -10 13 -16c-68 -68 -166 -93 -263 -93c-9 0 -17 -8 -17 -17v-96c28 28 66 43 105 43c116 0 186 -51 186 -161c0 -94 -87 -160 -186 -160c-82 0 -163 39 -163 113c0 36 30 66 66 66s65 -30 65 -66 c0 -25 -40 -28 -40 -53c0 -30 37 -37 72 -37c57 0 70 71 70 137c0 63 -15 132 -70 132c-42 0 -83 -12 -107 -45c-3 -4 -8 -6 -12 -6c-8 0 -15 6 -15 15v228c0 9 7 16 15 16h2z";
var sixPath="M170 256c-51 0 -53 -44 -53 -102v-14v-15c0 -58 2 -102 53 -102c57 0 61 51 61 117s-4 116 -61 116zM117 266c17 7 34 13 53 13c101 0 170 -44 170 -139s-69 -140 -170 -140c-112 0 -170 124 -170 250c0 128 72 250 190 250c71 0 138 -39 138 -103c0 -36 -29 -66 -65 -66 s-66 30 -66 66c0 24 39 25 39 49c0 20 -23 31 -46 31c-66 0 -75 -65 -75 -139c0 -24 2 -48 2 -72z";
var sevenPath = "M67 410c-31 0 -38 -43 -38 -70v-75c0 -10 -7 -15 -14 -15s-15 5 -15 15v220c0 10 8 15 15 15s14 -5 14 -15v-14c0 -9 12 -19 15 -15c21 29 48 44 78 44c29 0 58 -13 84 -39c12 -12 27 -17 43 -17c30 0 63 19 84 50c3 5 7 6 11 6c8 0 16 -6 16 -14c0 -3 -1 -6 -3 -9 c-83 -118 -158 -249 -158 -387c0 -25 3 -50 8 -76c2 -9 -5 -17 -13 -17c-1 0 -3 1 -4 1c-24 7 -48 15 -73 15s-50 -8 -74 -15c-1 0 -3 -1 -4 -1c-9 0 -16 9 -12 17c54 128 134 242 216 355c-20 -11 -40 -16 -59 -16c-22 0 -42 8 -60 26s-39 31 -57 31z";
var eightPath="M259 288c27 29 49 62 49 102c0 55 -57 87 -117 87c-47 0 -75 -36 -75 -71c0 -20 10 -40 30 -52zM289 271c55 -31 83 -79 83 -127c0 -73 -66 -144 -189 -144c-94 0 -183 54 -183 140c0 50 39 85 76 120c-41 28 -61 67 -61 106c0 68 61 134 176 134c81 0 161 -38 161 -110 c0 -47 -30 -85 -63 -119zM106 242c-33 -29 -62 -59 -62 -102c0 -69 66 -117 139 -117c54 0 86 42 86 83c0 24 -10 48 -35 62z";
var ninePath="M170 244c51 0 53 44 53 102v14v15c0 58 -2 102 -53 102c-57 0 -61 -51 -61 -117s4 -116 61 -116zM223 234c-17 -7 -34 -13 -53 -13c-101 0 -170 44 -170 139s69 140 170 140c112 0 170 -124 170 -250c0 -128 -72 -250 -190 -250c-71 0 -138 39 -138 103c0 36 29 66 65 66 s66 -30 66 -66c0 -24 -39 -25 -39 -49c0 -20 23 -31 46 -31c66 0 75 65 75 139c0 24 -2 48 -2 72z";

//brace
var bracePath = "M-12 -656c0 -352 -132 -696 -132 -1032c0 -180 36 -344 156 -484c4 -4 8 -8 8 -12c0 -8 -12 -16 -20 -16c-4 0 -8 0 -12 4c-160 184 -216 416 -216 656c0 360 140 712 140 1052c0 176 -40 344 -160 480v8v8c120 136 160 304 160 480c0 340 -140 692 -140 1052 c0 240 56 472 216 656c4 4 8 4 12 4c8 0 20 -8 20 -16c0 -4 -4 -8 -8 -12c-120 -140 -156 -304 -156 -484c0 -336 132 -680 132 -1032c0 -240 -52 -472 -208 -656c156 -184 208 -416 208 -656z";

//rest paths
var thirtyTwoRestPath = "M154 455c79 0 46 -98 91 -98c15 0 46 49 52 63c6 13 23 12 28 0l-216 -920c-8 -7 -18 -10 -28 -10s-19 3 -27 10l86 327c-35 -13 -71 -23 -108 -23c-47 0 -87 34 -87 79c0 40 32 72 72 72c79 0 46 -98 91 -98c17 0 54 54 59 71l39 149c-34 -12 -70 -23 -106 -23 c-47 0 -87 34 -87 79c0 40 33 72 73 72c79 0 45 -98 90 -98c16 0 52 51 56 68l40 151c-33 -12 -68 -22 -103 -22c-47 0 -87 34 -87 79c0 40 32 72 72 72z";
var sixteenthRestPath = "M66 -500l101 327c-34 -12 -70 -23 -106 -23c-46 0 -87 33 -87 79c0 40 32 72 72 72c25 0 49 -15 57 -39c10 -28 5 -59 34 -59c16 0 55 51 60 68l46 151c-34 -12 -68 -22 -104 -22c-46 0 -87 33 -87 79c0 40 33 72 73 72c25 0 48 -15 56 -39c10 -28 5 -59 34 -59 c15 0 50 49 57 63c6 12 23 12 28 0l-179 -670c-8 -7 -17 -10 -27 -10s-20 3 -28 10z";
var eighthRestPath = "M72 -250l117 326c-34 -12 -69 -22 -105 -22c-46 0 -87 33 -87 79c0 40 33 72 73 72c25 0 48 -15 56 -39c10 -28 6 -59 35 -59c16 0 54 48 61 63c6 12 23 12 28 0l-123 -420c-8 -7 -17 -10 -27 -10s-20 3 -28 10z";
var quarterRestPath = "M-23 -116c0 28 11 42 40 42c33 0 78 -13 119 -31l-132 158c-7 9 -10 17 -10 25c0 34 50 66 87 99c25 22 37 52 37 83c0 24 -8 49 -25 69l-35 42c-3 3 -4 7 -4 10c0 9 9 15 17 15c4 0 8 -1 11 -5l151 -180c7 -9 10 -17 10 -25c0 -34 -50 -66 -87 -99 c-25 -22 -37 -52 -37 -83c0 -24 7 -49 24 -69l84 -99c3 -3 4 -7 4 -10c0 -9 -8 -16 -16 -16c-4 0 -9 2 -12 6c-18 21 -63 38 -97 38c-41 0 -53 -26 -53 -67c0 -35 11 -74 28 -94c5 -6 0 -13 -6 -13c-2 0 -4 0 -6 2c-45 54 -92 148 -92 202z";
var halfRestPath = "M365 0h-355c-6 0 -10 4 -10 10v136c0 6 4 10 10 10h355c6 0 10 -4 10 -10v-136c0 -6 -4 -10 -10 -10z";
var wholeRestPath = "M365 -156h-355c-6 0 -10 4 -10 10v136c0 6 4 10 10 10h355c6 0 10 -4 10 -10v-136c0 -6 -4 -10 -10 -10z";

//flag paths
var thirtyTwoFlagI = "M0 205c89 50 206 128 206 228c0 22 -3 44 -8 66c-77 -88 -198 -157 -198 -279v-15zM267 864c0 -38 -12 -70 -30 -100c16 -38 24 -79 24 -120c0 -38 -12 -70 -30 -100c11 -36 17 -73 17 -111c0 -178 -248 -255 -248 -433h-16v750h16v-105c97 44 224 117 224 219 c0 29 -9 45 -9 53c0 14 11 22 23 22c24 0 29 -44 29 -75zM0 425c95 45 219 118 219 219c0 27 -5 54 -14 79c-79 -90 -205 -158 -205 -283v-15z";
var thirtyTwoFlagPath = "M0 -212v-5c0 -110 85 -194 144 -285c3 11 5 23 5 35c0 93 -85 187 -149 255zM0 0c0 -175 191 -292 191 -467c0 -29 -8 -57 -19 -84c17 -35 29 -71 29 -111c0 -36 -8 -72 -23 -105c18 -35 29 -72 29 -113c0 -60 -15 -119 -41 -173c-5 -8 -13 -11 -20 -11 c-13 0 -26 11 -23 27c26 49 42 102 42 157c0 91 -94 175 -165 233v-103h-16v750h16zM0 -430v-5c0 -112 88 -194 149 -285c6 19 10 38 10 58c0 90 -91 173 -159 232z";
var sixFlagPath = "M0 0v-500h-16v500h16zM0 0c0 -178 203 -292 203 -470c0 -33 -9 -65 -23 -95c18 -37 29 -75 29 -117c0 -63 -16 -125 -42 -183c-5 -8 -12 -12 -19 -12c-13 0 -26 11 -23 27c26 52 42 110 42 168c0 97 -95 191 -167 257v212c0 -118 91 -206 153 -304c5 15 7 31 7 47 c0 96 -91 190 -160 257v213z";
var eighthFlagPath = "M0 0h-16v250h16c98 58 227 148 227 259c0 57 -16 112 -41 163c-3 16 10 27 23 27c7 0 15 -3 20 -11c25 -56 40 -117 40 -179c0 -204 -269 -305 -269 -509z";
var eighthFlagPathU = "M0 0h-16v250h16c98 58 227 148 227 259c0 57 -16 112 -41 163c-3 16 10 27 23 27c7 0 15 -3 20 -11c25 -56 40 -117 40 -179c0 -204 -269 -305 -269 -509z";
var eighthFlag = "M0 0c0 -198 209 -335 209 -533c0 -71 -16 -141 -42 -207c-5 -8 -12 -12 -19 -12c-13 0 -26 11 -23 27c26 61 42 126 42 192c0 104 -95 208 -167 283h-16v250h16z";
var sixteenthFlag = "M0 0c0 -178 203 -292 203 -470c0 -33 -9 -65 -23 -95c18 -37 29 -75 29 -117c0 -63 -16 -125 -42 -183c-5 -8 -12 -12 -19 -12c-13 0 -26 11 -23 27c26 52 42 110 42 168c0 97 -95 191 -167 257v-75h-16v500h16zM153 -517c5 15 7 31 7 47c0 96 -91 190 -160 257 c0 -118 91 -206 153 -304z";
var eighthFlagI = "M0 0h-16v250h16c98 58 227 148 227 259c0 57 -16 112 -41 163c-3 16 10 27 23 27c7 0 15 -3 20 -11c25 -56 40 -117 40 -179c0 -204 -269 -305 -269 -509z";
var sixteenthFlagI = "M0 205c92 51 214 131 214 233c0 24 -5 48 -14 70c-80 -89 -200 -160 -200 -283v-20zM269 663c0 -44 -15 -82 -38 -116c16 -34 25 -71 25 -109c0 -181 -256 -257 -256 -438h-16v500h16v-70c98 49 227 127 227 233c0 21 -6 42 -14 62c-3 16 10 27 23 27c30 0 33 -63 33 -89z";

var rnGrad2 = 'l(-0.25,-0.25,1.25,1.25)#A0AFB3-#FFFFFF';